{
  "possibleTypes": {
    "CashOfferDetails": [
      "PricingsCashOfferDetails",
      "UnderwritingCashOfferDetails",
      "WebCashOfferDetails"
    ],
    "CustomerFacingPromptBehaviorBehavior": [
      "CustomerFacingPromptBehaviorFollowUpPrompt"
    ],
    "CustomerFacingPromptResponse": [
      "CustomerFacingPromptResponseSelectedOptions",
      "CustomerFacingPromptResponseText"
    ],
    "CustomerTask": [
      "InformationalTask",
      "SingleCTATask"
    ],
    "DecodedTaskData": [
      "OdProtosAbraV0Data_AbraTaskData",
      "OdProtosAbraV0Data_FollowupSpecialtyInspectionRequestedTaskData",
      "OdProtosAbraV0Data_WalkProposedTaskData",
      "OdProtosAcquisitionUnderwritingData_LgmReviewTaskData",
      "OdProtosAcquisitionUnderwritingData_PricingDecisionTaskData",
      "OdProtosAdmiralData_IncidentInvestigationTaskData",
      "OdProtosAdmiralData_ModelPredictionReviewTaskData",
      "OdProtosAdmiralData_PatrolResponseReviewTaskData",
      "OdProtosAdmiralData_SecurityCameraReviewTaskData",
      "OdProtosBuyTasks_CompleteBuyOfferTaskData",
      "OdProtosDocumentsHuntingOpsTasks_DocumentHuntingTaskData",
      "OdProtosInstitutionsTasks_OffBalanceSheetTaskData",
      "OdProtosListerineData_ListingDataEntryTaskData",
      "OdProtosListerineData_ListingPhotosReviewTaskData",
      "OdProtosPricingTaskQueue_PricingTaskData",
      "OdProtosRefurbyData_APResolutionTaskData",
      "OdProtosRefurbyData_ChangeOrderReviewTaskData",
      "OdProtosRefurbyData_InteriorVirtualAssessmentTaskData",
      "OdProtosSupportData_TicketOutcomeTask",
      "OdProtosTrustData_IdentityReviewTask",
      "OdProtosWebData_AgentVirtualAssessmentVideoReviewTaskData",
      "OdProtosWebData_ContractChangeRequestOutcomeTaskData",
      "OdProtosWebData_SelfServeVirtualAssessmentVideoReviewTaskData",
      "OdProtosWebData_VirtualAssessmentVideoReviewTaskData"
    ],
    "GoogleProtobuf_Value_KindOneof": [
      "GoogleProtobuf_Value_KindOneof_BoolValue",
      "GoogleProtobuf_Value_KindOneof_ListValue",
      "GoogleProtobuf_Value_KindOneof_NullValue",
      "GoogleProtobuf_Value_KindOneof_NumberValue",
      "GoogleProtobuf_Value_KindOneof_StringValue",
      "GoogleProtobuf_Value_KindOneof_StructValue"
    ],
    "OdProtosAbraV0Data_PostContractDiligenceReview_DecisionOneof": [
      "OdProtosAbraV0Data_PostContractDiligenceReview_DecisionOneof_AddendumRequired",
      "OdProtosAbraV0Data_PostContractDiligenceReview_DecisionOneof_ClearToClose",
      "OdProtosAbraV0Data_PostContractDiligenceReview_DecisionOneof_Withdraw"
    ],
    "OdProtosAbraV0Data_Question_ResponseOneof": [
      "OdProtosAbraV0Data_Question_ResponseOneof_FloatResponse",
      "OdProtosAbraV0Data_Question_ResponseOneof_IntegerResponse",
      "OdProtosAbraV0Data_Question_ResponseOneof_StringArrayResponse",
      "OdProtosAbraV0Data_Question_ResponseOneof_StringResponse"
    ],
    "OdProtosAbraV0Events_AssessmentEvent_EventOneof": [
      "OdProtosAbraV0Events_AssessmentEvent_EventOneof_Completed",
      "OdProtosAbraV0Events_AssessmentEvent_EventOneof_OnsiteCompleted"
    ],
    "OdProtosAbraV0Events_DiligenceEvent_EventOneof": [
      "OdProtosAbraV0Events_DiligenceEvent_EventOneof_Completed"
    ],
    "OdProtosAbraV0Services_CreateAssessmentHandoffRequest_TypeOneof": [
      "OdProtosAbraV0Services_CreateAssessmentHandoffRequest_TypeOneof_Expert",
      "OdProtosAbraV0Services_CreateAssessmentHandoffRequest_TypeOneof_Invitation"
    ],
    "OdProtosAbraV0Services_EnsureAssessmentTaskWithHandoffRequest_TypeOneof": [
      "OdProtosAbraV0Services_EnsureAssessmentTaskWithHandoffRequest_TypeOneof_Expert",
      "OdProtosAbraV0Services_EnsureAssessmentTaskWithHandoffRequest_TypeOneof_Invitation"
    ],
    "OdProtosAcquisitionUnderwritingData_PricingDecision_DecisionOneof": [
      "OdProtosAcquisitionUnderwritingData_PricingDecision_DecisionOneof_PricingAdjustment",
      "OdProtosAcquisitionUnderwritingData_PricingDecision_DecisionOneof_Skip",
      "OdProtosAcquisitionUnderwritingData_PricingDecision_DecisionOneof_Walk"
    ],
    "OdProtosAcquisitionUnderwritingData_UnderwritingOutcome_OutcomeOneof": [
      "OdProtosAcquisitionUnderwritingData_UnderwritingOutcome_OutcomeOneof_Proceed",
      "OdProtosAcquisitionUnderwritingData_UnderwritingOutcome_OutcomeOneof_Walk"
    ],
    "OdProtosAcquisitionUnderwritingEvents_TaskEvent_EventOneof": [
      "OdProtosAcquisitionUnderwritingEvents_TaskEvent_EventOneof_PricingDecisionResolved",
      "OdProtosAcquisitionUnderwritingEvents_TaskEvent_EventOneof_WalkResolved"
    ],
    "OdProtosAcquisitionUnderwritingServices_CancelUnderwritingResponse_ResponseOneof": [
      "OdProtosAcquisitionUnderwritingServices_CancelUnderwritingResponse_ResponseOneof_Error",
      "OdProtosAcquisitionUnderwritingServices_CancelUnderwritingResponse_ResponseOneof_Success"
    ],
    "OdProtosAcquisitionUnderwritingServices_ComputeUnderwritingOutcomeResponse_ResponseOneof": [
      "OdProtosAcquisitionUnderwritingServices_ComputeUnderwritingOutcomeResponse_ResponseOneof_Error",
      "OdProtosAcquisitionUnderwritingServices_ComputeUnderwritingOutcomeResponse_ResponseOneof_Success"
    ],
    "OdProtosAcquisitionUnderwritingServices_CreateUnderwritingWalkResponse_ResponseOneof": [
      "OdProtosAcquisitionUnderwritingServices_CreateUnderwritingWalkResponse_ResponseOneof_Error",
      "OdProtosAcquisitionUnderwritingServices_CreateUnderwritingWalkResponse_ResponseOneof_Success"
    ],
    "OdProtosAcquisitionUnderwritingServices_CreateWalkProposalResponse_ResponseOneof": [
      "OdProtosAcquisitionUnderwritingServices_CreateWalkProposalResponse_ResponseOneof_Error",
      "OdProtosAcquisitionUnderwritingServices_CreateWalkProposalResponse_ResponseOneof_Success"
    ],
    "OdProtosAcquisitionUnderwritingServices_CreateWalkResolutionDirectOverrideValuationResponse_ResponseOneof": [
      "OdProtosAcquisitionUnderwritingServices_CreateWalkResolutionDirectOverrideValuationResponse_ResponseOneof_Error",
      "OdProtosAcquisitionUnderwritingServices_CreateWalkResolutionDirectOverrideValuationResponse_ResponseOneof_Success"
    ],
    "OdProtosAcquisitionUnderwritingServices_CreateWalkResolutionResponse_ResponseOneof": [
      "OdProtosAcquisitionUnderwritingServices_CreateWalkResolutionResponse_ResponseOneof_Error",
      "OdProtosAcquisitionUnderwritingServices_CreateWalkResolutionResponse_ResponseOneof_Success"
    ],
    "OdProtosAcquisitionUnderwritingServices_CreateWalkResolutionTaskResponse_ResponseOneof": [
      "OdProtosAcquisitionUnderwritingServices_CreateWalkResolutionTaskResponse_ResponseOneof_Error",
      "OdProtosAcquisitionUnderwritingServices_CreateWalkResolutionTaskResponse_ResponseOneof_Success"
    ],
    "OdProtosAcquisitionUnderwritingServices_GetEngagementResponse_ResponseOneof": [
      "OdProtosAcquisitionUnderwritingServices_GetEngagementResponse_ResponseOneof_Error",
      "OdProtosAcquisitionUnderwritingServices_GetEngagementResponse_ResponseOneof_Success"
    ],
    "OdProtosAcquisitionUnderwritingServices_GetPricingDecisionResponse_ResponseOneof": [
      "OdProtosAcquisitionUnderwritingServices_GetPricingDecisionResponse_ResponseOneof_Error",
      "OdProtosAcquisitionUnderwritingServices_GetPricingDecisionResponse_ResponseOneof_Success"
    ],
    "OdProtosAcquisitionUnderwritingServices_GetSubEngagementResponse_ResponseOneof": [
      "OdProtosAcquisitionUnderwritingServices_GetSubEngagementResponse_ResponseOneof_Error",
      "OdProtosAcquisitionUnderwritingServices_GetSubEngagementResponse_ResponseOneof_Success"
    ],
    "OdProtosAcquisitionUnderwritingServices_PreviewOverrideFeesRequest_BaseValuationOneof": [
      "OdProtosAcquisitionUnderwritingServices_PreviewOverrideFeesRequest_BaseValuationOneof_EnsembledValuationId",
      "OdProtosAcquisitionUnderwritingServices_PreviewOverrideFeesRequest_BaseValuationOneof_SingleValuationId"
    ],
    "OdProtosAcquisitionUnderwritingServices_PreviewOverrideFeesResponse_ResponseOneof": [
      "OdProtosAcquisitionUnderwritingServices_PreviewOverrideFeesResponse_ResponseOneof_Error",
      "OdProtosAcquisitionUnderwritingServices_PreviewOverrideFeesResponse_ResponseOneof_Success"
    ],
    "OdProtosAcquisitionUnderwritingServices_RecordCamundaProcessInstanceCreationResponse_ResponseOneof": [
      "OdProtosAcquisitionUnderwritingServices_RecordCamundaProcessInstanceCreationResponse_ResponseOneof_Error",
      "OdProtosAcquisitionUnderwritingServices_RecordCamundaProcessInstanceCreationResponse_ResponseOneof_Success"
    ],
    "OdProtosAcquisitionUnderwritingServices_RecordCamundaProcessInstanceFinishResponse_ResponseOneof": [
      "OdProtosAcquisitionUnderwritingServices_RecordCamundaProcessInstanceFinishResponse_ResponseOneof_Error",
      "OdProtosAcquisitionUnderwritingServices_RecordCamundaProcessInstanceFinishResponse_ResponseOneof_Success"
    ],
    "OdProtosAcquisitionUnderwritingServices_RecordEngagementCompletedResponse_ResponseOneof": [
      "OdProtosAcquisitionUnderwritingServices_RecordEngagementCompletedResponse_ResponseOneof_Error",
      "OdProtosAcquisitionUnderwritingServices_RecordEngagementCompletedResponse_ResponseOneof_Success"
    ],
    "OdProtosAcquisitionUnderwritingServices_RecordEngagementPricingResponse_ResponseOneof": [
      "OdProtosAcquisitionUnderwritingServices_RecordEngagementPricingResponse_ResponseOneof_Error",
      "OdProtosAcquisitionUnderwritingServices_RecordEngagementPricingResponse_ResponseOneof_Success"
    ],
    "OdProtosAcquisitionUnderwritingServices_RecordNewEngagementResponse_ResponseOneof": [
      "OdProtosAcquisitionUnderwritingServices_RecordNewEngagementResponse_ResponseOneof_Error",
      "OdProtosAcquisitionUnderwritingServices_RecordNewEngagementResponse_ResponseOneof_Success"
    ],
    "OdProtosAcquisitionUnderwritingServices_RecordNewSubEngagementRequest_SubEngagementOneof": [
      "OdProtosAcquisitionUnderwritingServices_RecordNewSubEngagementRequest_SubEngagementOneof_DataLabeling",
      "OdProtosAcquisitionUnderwritingServices_RecordNewSubEngagementRequest_SubEngagementOneof_EnsembledValuation",
      "OdProtosAcquisitionUnderwritingServices_RecordNewSubEngagementRequest_SubEngagementOneof_LgmReview",
      "OdProtosAcquisitionUnderwritingServices_RecordNewSubEngagementRequest_SubEngagementOneof_OverrideValuation",
      "OdProtosAcquisitionUnderwritingServices_RecordNewSubEngagementRequest_SubEngagementOneof_PostRenoValuation",
      "OdProtosAcquisitionUnderwritingServices_RecordNewSubEngagementRequest_SubEngagementOneof_PreRenoValuation",
      "OdProtosAcquisitionUnderwritingServices_RecordNewSubEngagementRequest_SubEngagementOneof_PricingDecision",
      "OdProtosAcquisitionUnderwritingServices_RecordNewSubEngagementRequest_SubEngagementOneof_RepairBudgetReview",
      "OdProtosAcquisitionUnderwritingServices_RecordNewSubEngagementRequest_SubEngagementOneof_RiskAssessment"
    ],
    "OdProtosAcquisitionUnderwritingServices_RecordNewSubEngagementResponse_ResponseOneof": [
      "OdProtosAcquisitionUnderwritingServices_RecordNewSubEngagementResponse_ResponseOneof_Error",
      "OdProtosAcquisitionUnderwritingServices_RecordNewSubEngagementResponse_ResponseOneof_Success"
    ],
    "OdProtosAcquisitionUnderwritingServices_RecordSubEngagementCompletedResponse_ResponseOneof": [
      "OdProtosAcquisitionUnderwritingServices_RecordSubEngagementCompletedResponse_ResponseOneof_Error",
      "OdProtosAcquisitionUnderwritingServices_RecordSubEngagementCompletedResponse_ResponseOneof_Success"
    ],
    "OdProtosAcquisitionUnderwritingServices_RecordSubEngagementStoppedResponse_ResponseOneof": [
      "OdProtosAcquisitionUnderwritingServices_RecordSubEngagementStoppedResponse_ResponseOneof_Error",
      "OdProtosAcquisitionUnderwritingServices_RecordSubEngagementStoppedResponse_ResponseOneof_Success"
    ],
    "OdProtosAcquisitionUnderwritingServices_ResolvePricingDecisionResponse_ResponseOneof": [
      "OdProtosAcquisitionUnderwritingServices_ResolvePricingDecisionResponse_ResponseOneof_Error",
      "OdProtosAcquisitionUnderwritingServices_ResolvePricingDecisionResponse_ResponseOneof_Success"
    ],
    "OdProtosAcquisitionUnderwritingServices_TerminatePropertyEngagementResponse_ResponseOneof": [
      "OdProtosAcquisitionUnderwritingServices_TerminatePropertyEngagementResponse_ResponseOneof_Error",
      "OdProtosAcquisitionUnderwritingServices_TerminatePropertyEngagementResponse_ResponseOneof_Success"
    ],
    "OdProtosAdmiralData_HubCommand_CommandOneof": [
      "OdProtosAdmiralData_HubCommand_CommandOneof_FactoryReset",
      "OdProtosAdmiralData_HubCommand_CommandOneof_Lock",
      "OdProtosAdmiralData_HubCommand_CommandOneof_Reboot",
      "OdProtosAdmiralData_HubCommand_CommandOneof_Siren",
      "OdProtosAdmiralData_HubCommand_CommandOneof_WiFiHotspotCredentialsGet",
      "OdProtosAdmiralData_HubCommand_CommandOneof_WiFiHotspotCredentialsSet"
    ],
    "OdProtosAdmiralEvents_JammingEvent_EventOneof": [
      "OdProtosAdmiralEvents_JammingEvent_EventOneof_Jamming"
    ],
    "OdProtosAdmiralEvents_LockboxEvent_EventOneof": [
      "OdProtosAdmiralEvents_LockboxEvent_EventOneof_CodeSet"
    ],
    "OdProtosAdmiralEvents_Sessions_EventOneof": [
      "OdProtosAdmiralEvents_Sessions_EventOneof_Session"
    ],
    "OdProtosAdmiralServices_HubSchemaStatus_Error_IssueOneof": [
      "OdProtosAdmiralServices_HubSchemaStatus_Error_IssueOneof_LowBatteryIssue",
      "OdProtosAdmiralServices_HubSchemaStatus_Error_IssueOneof_MissingDeviceIssue",
      "OdProtosAdmiralServices_HubSchemaStatus_Error_IssueOneof_OfflineIssue"
    ],
    "OdProtosAdmiralServices_ResolveCameraReviewRequest_ResolutionOneof": [
      "OdProtosAdmiralServices_ResolveCameraReviewRequest_ResolutionOneof_FalseAlarm",
      "OdProtosAdmiralServices_ResolveCameraReviewRequest_ResolutionOneof_IncidentReportId"
    ],
    "OdProtosAdmiralServices_UnlockHomeRequest_IdentifierOneof": [
      "OdProtosAdmiralServices_UnlockHomeRequest_IdentifierOneof_AddressUuid",
      "OdProtosAdmiralServices_UnlockHomeRequest_IdentifierOneof_HubIdentifier"
    ],
    "OdProtosAgentDataStoreEvents_AgentVerificationEvent_EventOneof": [
      "OdProtosAgentDataStoreEvents_AgentVerificationEvent_EventOneof_AgentVerificationStatusUpdated"
    ],
    "OdProtosAgentDataStore_GetAgentContactRequest_IdentifierOneof": [
      "OdProtosAgentDataStore_GetAgentContactRequest_IdentifierOneof_ContactId",
      "OdProtosAgentDataStore_GetAgentContactRequest_IdentifierOneof_Id"
    ],
    "OdProtosAuthAuthzData_Grant_GrantedFromOneof": [
      "OdProtosAuthAuthzData_Grant_GrantedFromOneof_GrantedFromBranchId",
      "OdProtosAuthAuthzData_Grant_GrantedFromOneof_GrantedFromVendorId"
    ],
    "OdProtosBuyTasks_CompleteBuyOfferTaskData_BuyOfferIdOneof": [
      "OdProtosBuyTasks_CompleteBuyOfferTaskData_BuyOfferIdOneof_WebListingOfferId"
    ],
    "OdProtosBuydirectPropertyEngagements_ResaleBuyDirect_EventExtensions_Domain_TypeOneof": [
      "OdProtosBuydirectPropertyEngagements_ResaleBuyDirect_EventExtensions_Domain_TypeOneof_Deactivated",
      "OdProtosBuydirectPropertyEngagements_ResaleBuyDirect_EventExtensions_Domain_TypeOneof_DetailsUpdated",
      "OdProtosBuydirectPropertyEngagements_ResaleBuyDirect_EventExtensions_Domain_TypeOneof_OffTheMarket",
      "OdProtosBuydirectPropertyEngagements_ResaleBuyDirect_EventExtensions_Domain_TypeOneof_OnTheMarket",
      "OdProtosBuydirectPropertyEngagements_ResaleBuyDirect_EventExtensions_Domain_TypeOneof_Published",
      "OdProtosBuydirectPropertyEngagements_ResaleBuyDirect_EventExtensions_Domain_TypeOneof_Terminated",
      "OdProtosBuydirectPropertyEngagements_ResaleBuyDirect_EventExtensions_Domain_TypeOneof_Unpublished"
    ],
    "OdProtosBuyerV2Events_PropertyReactionEvent_EventOneof": [
      "OdProtosBuyerV2Events_PropertyReactionEvent_EventOneof_Created"
    ],
    "OdProtosBuyerV2Events_SavedSearchEvent_EventOneof": [
      "OdProtosBuyerV2Events_SavedSearchEvent_EventOneof_Created",
      "OdProtosBuyerV2Events_SavedSearchEvent_EventOneof_Updated"
    ],
    "OdProtosBuyerV2Events_TourFeedbackEvent_EventOneof": [
      "OdProtosBuyerV2Events_TourFeedbackEvent_EventOneof_Created"
    ],
    "OdProtosBuyerV2ServicesBuyer_SubmitTourFeedbackRequest_TouredHomeOneof": [
      "OdProtosBuyerV2ServicesBuyer_SubmitTourFeedbackRequest_TouredHomeOneof_AddressUuid",
      "OdProtosBuyerV2ServicesBuyer_SubmitTourFeedbackRequest_TouredHomeOneof_ChannelId",
      "OdProtosBuyerV2ServicesBuyer_SubmitTourFeedbackRequest_TouredHomeOneof_ListingId"
    ],
    "OdProtosCabinetEvents_AssetEvent_EventOneof": [
      "OdProtosCabinetEvents_AssetEvent_EventOneof_AssetCreated"
    ],
    "OdProtosCasaEvents_RecordsAddressEvent_EventOneof": [
      "OdProtosCasaEvents_RecordsAddressEvent_EventOneof_CreateAlias",
      "OdProtosCasaEvents_RecordsAddressEvent_EventOneof_Update"
    ],
    "OdProtosCasaEvents_RecordsAddressInvalidateEvent_EventOneof": [
      "OdProtosCasaEvents_RecordsAddressInvalidateEvent_EventOneof_Invalidate"
    ],
    "OdProtosCasaEvents_RecordsInputAddressEvent_EventOneof": [
      "OdProtosCasaEvents_RecordsInputAddressEvent_EventOneof_PublishInputAddress"
    ],
    "OdProtosCaseyV0Data_TaskSearchFilters_SLA_DueRestrictionsOneof": [
      "OdProtosCaseyV0Data_TaskSearchFilters_SLA_DueRestrictionsOneof_Due",
      "OdProtosCaseyV0Data_TaskSearchFilters_SLA_DueRestrictionsOneof_TimeRestriction"
    ],
    "OdProtosCaseyV0Events_TaskEvent_EventOneof": [
      "OdProtosCaseyV0Events_TaskEvent_EventOneof_Closed",
      "OdProtosCaseyV0Events_TaskEvent_EventOneof_Create",
      "OdProtosCaseyV0Events_TaskEvent_EventOneof_Update"
    ],
    "OdProtosCaseyV0Services_Task_Time_TimeOneof": [
      "OdProtosCaseyV0Services_Task_Time_TimeOneof_ExactTime"
    ],
    "OdProtosCaseyV0Services_UpdateRelatedObjectReference_Request_SearchByOneof": [
      "OdProtosCaseyV0Services_UpdateRelatedObjectReference_Request_SearchByOneof_RelatedObject",
      "OdProtosCaseyV0Services_UpdateRelatedObjectReference_Request_SearchByOneof_TaskId"
    ],
    "OdProtosCaseyV1Events_TaskClosingEvent_EventOneof": [
      "OdProtosCaseyV1Events_TaskClosingEvent_EventOneof_CloseTaskEvent"
    ],
    "OdProtosCaseyV1Services_Task_Time_TimeOneof": [
      "OdProtosCaseyV1Services_Task_Time_TimeOneof_ExactTime"
    ],
    "OdProtosCaseyV1Services_UpdateRelatedObjectReference_Request_SearchByOneof": [
      "OdProtosCaseyV1Services_UpdateRelatedObjectReference_Request_SearchByOneof_RelatedObject",
      "OdProtosCaseyV1Services_UpdateRelatedObjectReference_Request_SearchByOneof_TaskId"
    ],
    "OdProtosCommonAssumptions_AssumptionItem_ValueOneof": [
      "OdProtosCommonAssumptions_AssumptionItem_ValueOneof_FloatListValue",
      "OdProtosCommonAssumptions_AssumptionItem_ValueOneof_FloatValue",
      "OdProtosCommonAssumptions_AssumptionItem_ValueOneof_HeadlineSegmentedValue",
      "OdProtosCommonAssumptions_AssumptionItem_ValueOneof_IntValue",
      "OdProtosCommonAssumptions_AssumptionItem_ValueOneof_StringSegmentedFloatValue",
      "OdProtosCommonAssumptions_AssumptionItem_ValueOneof_StringSegmentedIntValue",
      "OdProtosCommonAssumptions_AssumptionItem_ValueOneof_StringSegmentedStringValue"
    ],
    "OdProtosCommonOptionsTesting_TestJSONEvent_EventOneof": [
      "OdProtosCommonOptionsTesting_TestJSONEvent_EventOneof_EventA"
    ],
    "OdProtosCommonOptionsTesting_TestProtoEvent_EventOneof": [
      "OdProtosCommonOptionsTesting_TestProtoEvent_EventOneof_EventA"
    ],
    "OdProtosCommunicationData_CallAnalysis_AnalysisOneof": [
      "OdProtosCommunicationData_CallAnalysis_AnalysisOneof_OfferReviewAnalysis",
      "OdProtosCommunicationData_CallAnalysis_AnalysisOneof_ScheduleAssessmentAnalysis"
    ],
    "OdProtosCommunicationData_HelpscoutThreadMessage_DirectionOneof": [
      "OdProtosCommunicationData_HelpscoutThreadMessage_DirectionOneof_Incoming",
      "OdProtosCommunicationData_HelpscoutThreadMessage_DirectionOneof_Note",
      "OdProtosCommunicationData_HelpscoutThreadMessage_DirectionOneof_Outgoing"
    ],
    "OdProtosCommunicationEvents_ChatEvent_EventOneof": [
      "OdProtosCommunicationEvents_ChatEvent_EventOneof_Incoming",
      "OdProtosCommunicationEvents_ChatEvent_EventOneof_Outgoing"
    ],
    "OdProtosCommunicationEvents_EmailEvent_EventOneof": [
      "OdProtosCommunicationEvents_EmailEvent_EventOneof_Incoming",
      "OdProtosCommunicationEvents_EmailEvent_EventOneof_Outgoing",
      "OdProtosCommunicationEvents_EmailEvent_EventOneof_SentEmailStatus"
    ],
    "OdProtosCommunicationEvents_PhoneCallEvent_EventOneof": [
      "OdProtosCommunicationEvents_PhoneCallEvent_EventOneof_CallAnalysis",
      "OdProtosCommunicationEvents_PhoneCallEvent_EventOneof_PhoneCall",
      "OdProtosCommunicationEvents_PhoneCallEvent_EventOneof_TranscriptAvailable"
    ],
    "OdProtosCommunicationEvents_SmsEvent_EventOneof": [
      "OdProtosCommunicationEvents_SmsEvent_EventOneof_Incoming",
      "OdProtosCommunicationEvents_SmsEvent_EventOneof_Outgoing",
      "OdProtosCommunicationEvents_SmsEvent_EventOneof_Status"
    ],
    "OdProtosCommunicationEvents_VoicemailEvent_EventOneof": [
      "OdProtosCommunicationEvents_VoicemailEvent_EventOneof_Voicemail"
    ],
    "OdProtosCommunicationServices_CreateProviderCallRequest_CallConfigOneof": [
      "OdProtosCommunicationServices_CreateProviderCallRequest_CallConfigOneof_OfferReview",
      "OdProtosCommunicationServices_CreateProviderCallRequest_CallConfigOneof_ScheduleAssessment"
    ],
    "OdProtosCommunicationServices_CreateProviderCallRequest_ProviderConfigOneof": [
      "OdProtosCommunicationServices_CreateProviderCallRequest_ProviderConfigOneof_RetellAi"
    ],
    "OdProtosCommunicationServices_GetPhoneCallsRequest_IdentifierOneof": [
      "OdProtosCommunicationServices_GetPhoneCallsRequest_IdentifierOneof_CustomerId",
      "OdProtosCommunicationServices_GetPhoneCallsRequest_IdentifierOneof_OfferId",
      "OdProtosCommunicationServices_GetPhoneCallsRequest_IdentifierOneof_OperatorId"
    ],
    "OdProtosCommunicationServices_GetTranscriptsForPhoneCallsRequest_IdentifierOneof": [
      "OdProtosCommunicationServices_GetTranscriptsForPhoneCallsRequest_IdentifierOneof_CommunicationIds",
      "OdProtosCommunicationServices_GetTranscriptsForPhoneCallsRequest_IdentifierOneof_CustomerIds",
      "OdProtosCommunicationServices_GetTranscriptsForPhoneCallsRequest_IdentifierOneof_OfferIds",
      "OdProtosCommunicationServices_GetTranscriptsForPhoneCallsRequest_IdentifierOneof_OperatorIds"
    ],
    "OdProtosCommunicationServices_GetVoicemailsRequest_IdentifierOneof": [
      "OdProtosCommunicationServices_GetVoicemailsRequest_IdentifierOneof_CustomerId"
    ],
    "OdProtosCustardV1Data_ContactEvent_CommunicationEvent_Individual_IndividualIdOneof": [
      "OdProtosCustardV1Data_ContactEvent_CommunicationEvent_Individual_IndividualIdOneof_ContactId",
      "OdProtosCustardV1Data_ContactEvent_CommunicationEvent_Individual_IndividualIdOneof_UserId"
    ],
    "OdProtosCustardV1Data_ContactEvent_CommunicationEvent_TypedCommunicationEventOneof": [
      "OdProtosCustardV1Data_ContactEvent_CommunicationEvent_TypedCommunicationEventOneof_EmailEvent",
      "OdProtosCustardV1Data_ContactEvent_CommunicationEvent_TypedCommunicationEventOneof_PhoneCallEvent",
      "OdProtosCustardV1Data_ContactEvent_CommunicationEvent_TypedCommunicationEventOneof_SmsEvent",
      "OdProtosCustardV1Data_ContactEvent_CommunicationEvent_TypedCommunicationEventOneof_VoicemailEvent"
    ],
    "OdProtosCustardV1Data_ContactEvent_TypedContactEventOneof": [
      "OdProtosCustardV1Data_ContactEvent_TypedContactEventOneof_CommunicationEvent"
    ],
    "OdProtosCustardV1Events_ContactEventEvent_EventOneof": [
      "OdProtosCustardV1Events_ContactEventEvent_EventOneof_Create"
    ],
    "OdProtosCustomerV1Services_CustomerRequests_Search_CustomerSearchParamsOneof": [
      "OdProtosCustomerV1Services_CustomerRequests_Search_CustomerSearchParamsOneof_EmailParams",
      "OdProtosCustomerV1Services_CustomerRequests_Search_CustomerSearchParamsOneof_MultiParams",
      "OdProtosCustomerV1Services_CustomerRequests_Search_CustomerSearchParamsOneof_PhoneParams"
    ],
    "OdProtosDeadletterServices_AttemptProcessResponse_ResponseOneof": [
      "OdProtosDeadletterServices_AttemptProcessResponse_ResponseOneof_Error",
      "OdProtosDeadletterServices_AttemptProcessResponse_ResponseOneof_Success"
    ],
    "OdProtosDeadletterServices_ListDeadLettersResponse_ResponseOneof": [
      "OdProtosDeadletterServices_ListDeadLettersResponse_ResponseOneof_Error",
      "OdProtosDeadletterServices_ListDeadLettersResponse_ResponseOneof_Success"
    ],
    "OdProtosDirectoryData_User_ChangePassword_IdentifierOneof": [
      "OdProtosDirectoryData_User_ChangePassword_IdentifierOneof_Email",
      "OdProtosDirectoryData_User_ChangePassword_IdentifierOneof_Token"
    ],
    "OdProtosDirectoryServices_UserRequests_Get_IdentifierOneof": [
      "OdProtosDirectoryServices_UserRequests_Get_IdentifierOneof_Email",
      "OdProtosDirectoryServices_UserRequests_Get_IdentifierOneof_Token"
    ],
    "OdProtosDiscloseData_DataEntryValidation_RuleOneof": [
      "OdProtosDiscloseData_DataEntryValidation_RuleOneof_DoesNotContainSubstringRule",
      "OdProtosDiscloseData_DataEntryValidation_RuleOneof_MaxNumericalValueRule",
      "OdProtosDiscloseData_DataEntryValidation_RuleOneof_MaxStringLengthRule",
      "OdProtosDiscloseData_DataEntryValidation_RuleOneof_MinNumericalValueRule",
      "OdProtosDiscloseData_DataEntryValidation_RuleOneof_MinStringLengthRule",
      "OdProtosDiscloseData_DataEntryValidation_RuleOneof_ValidFloatRule",
      "OdProtosDiscloseData_DataEntryValidation_RuleOneof_ValidIntegerRule"
    ],
    "OdProtosDiscloseData_TemplateField_FieldReference_FieldTypeOneof": [
      "OdProtosDiscloseData_TemplateField_FieldReference_FieldTypeOneof_CheckBox",
      "OdProtosDiscloseData_TemplateField_FieldReference_FieldTypeOneof_Image",
      "OdProtosDiscloseData_TemplateField_FieldReference_FieldTypeOneof_TextField"
    ],
    "OdProtosDiscloseData_TemplateField_ReferenceOneof": [
      "OdProtosDiscloseData_TemplateField_ReferenceOneof_FieldGroupReference",
      "OdProtosDiscloseData_TemplateField_ReferenceOneof_FieldReference"
    ],
    "OdProtosDistilleryEvents_DistilleryEvent_EventOneof": [
      "OdProtosDistilleryEvents_DistilleryEvent_EventOneof_Enqueued",
      "OdProtosDistilleryEvents_DistilleryEvent_EventOneof_Extracted",
      "OdProtosDistilleryEvents_DistilleryEvent_EventOneof_Transformed",
      "OdProtosDistilleryEvents_DistilleryEvent_EventOneof_Validated"
    ],
    "OdProtosDistilleryServices_DistilleryRequests_GetResults_ByOneof": [
      "OdProtosDistilleryServices_DistilleryRequests_GetResults_ByOneof_DocumentId",
      "OdProtosDistilleryServices_DistilleryRequests_GetResults_ByOneof_JobId"
    ],
    "OdProtosDistilleryServices_DistilleryRequests_SubmitJob_ParamsOneof": [
      "OdProtosDistilleryServices_DistilleryRequests_SubmitJob_ParamsOneof_Dms",
      "OdProtosDistilleryServices_DistilleryRequests_SubmitJob_ParamsOneof_DocumentUrl"
    ],
    "OdProtosDocumentManagementEvents_DocumentEvent_EventOneof": [
      "OdProtosDocumentManagementEvents_DocumentEvent_EventOneof_Create",
      "OdProtosDocumentManagementEvents_DocumentEvent_EventOneof_Deleted",
      "OdProtosDocumentManagementEvents_DocumentEvent_EventOneof_Update"
    ],
    "OdProtosDocumentManagementServices_DocumentRequests_List_ParamsOneof": [
      "OdProtosDocumentManagementServices_DocumentRequests_List_ParamsOneof_CurrentLead",
      "OdProtosDocumentManagementServices_DocumentRequests_List_ParamsOneof_Documentable",
      "OdProtosDocumentManagementServices_DocumentRequests_List_ParamsOneof_Ids",
      "OdProtosDocumentManagementServices_DocumentRequests_List_ParamsOneof_ListingOffer"
    ],
    "OdProtosDocumentManagementServices_DocumentRequests_Upload_ParamsOneof": [
      "OdProtosDocumentManagementServices_DocumentRequests_Upload_ParamsOneof_Document"
    ],
    "OdProtosDocumentsHuntingOpsTasks_SendRequestedDocumentTaskData_TransactionIdOneof": [
      "OdProtosDocumentsHuntingOpsTasks_SendRequestedDocumentTaskData_TransactionIdOneof_ListingOfferId",
      "OdProtosDocumentsHuntingOpsTasks_SendRequestedDocumentTaskData_TransactionIdOneof_OfferId"
    ],
    "OdProtosElementsEvents_UtilityContextEvent_EventOneof": [
      "OdProtosElementsEvents_UtilityContextEvent_EventOneof_Create",
      "OdProtosElementsEvents_UtilityContextEvent_EventOneof_Update"
    ],
    "OdProtosElementsEvents_UtilityTaskEvent_EventOneof": [
      "OdProtosElementsEvents_UtilityTaskEvent_EventOneof_Create",
      "OdProtosElementsEvents_UtilityTaskEvent_EventOneof_Update"
    ],
    "OdProtosEventsOrganizations_RecordsOrganizationsEvent_EventOneof": [
      "OdProtosEventsOrganizations_RecordsOrganizationsEvent_EventOneof_Create",
      "OdProtosEventsOrganizations_RecordsOrganizationsEvent_EventOneof_Update"
    ],
    "OdProtosEventsUsers_RecordsUsersEvent_EventOneof": [
      "OdProtosEventsUsers_RecordsUsersEvent_EventOneof_Create",
      "OdProtosEventsUsers_RecordsUsersEvent_EventOneof_MemberCreate",
      "OdProtosEventsUsers_RecordsUsersEvent_EventOneof_MemberRemove",
      "OdProtosEventsUsers_RecordsUsersEvent_EventOneof_PasswordChange",
      "OdProtosEventsUsers_RecordsUsersEvent_EventOneof_RoleChange",
      "OdProtosEventsUsers_RecordsUsersEvent_EventOneof_Update"
    ],
    "OdProtosFenceServices_BulkGetRegionsFromAddressRequest_Address_AddressOneof": [
      "OdProtosFenceServices_BulkGetRegionsFromAddressRequest_Address_AddressOneof_AddressUuid",
      "OdProtosFenceServices_BulkGetRegionsFromAddressRequest_Address_AddressOneof_CasaAddress"
    ],
    "OdProtosFenceServices_GetRegionsFromAddressRequest_AddressOneof": [
      "OdProtosFenceServices_GetRegionsFromAddressRequest_AddressOneof_AddressUuid",
      "OdProtosFenceServices_GetRegionsFromAddressRequest_AddressOneof_CasaAddress"
    ],
    "OdProtosFulfillmentServices_CreateClosingValidationRequest_ByOneof": [
      "OdProtosFulfillmentServices_CreateClosingValidationRequest_ByOneof_SkipValidation",
      "OdProtosFulfillmentServices_CreateClosingValidationRequest_ByOneof_Validate"
    ],
    "OdProtosFulfillmentServices_FulfillmentEvent_EventOneof": [
      "OdProtosFulfillmentServices_FulfillmentEvent_EventOneof_Created",
      "OdProtosFulfillmentServices_FulfillmentEvent_EventOneof_Updated"
    ],
    "OdProtosFulfillmentServices_GetClosingValidationByID_Request_ByOneof": [
      "OdProtosFulfillmentServices_GetClosingValidationByID_Request_ByOneof_ClosingValidationId",
      "OdProtosFulfillmentServices_GetClosingValidationByID_Request_ByOneof_FulfillmentId"
    ],
    "OdProtosFulfillmentServices_GetFulfillmentByID_Request_ByOneof": [
      "OdProtosFulfillmentServices_GetFulfillmentByID_Request_ByOneof_FulfillmentId",
      "OdProtosFulfillmentServices_GetFulfillmentByID_Request_ByOneof_ListingOfferUuid",
      "OdProtosFulfillmentServices_GetFulfillmentByID_Request_ByOneof_OfferUuid"
    ],
    "OdProtosHedgehogData_Test_TestNameOneof": [
      "OdProtosHedgehogData_Test_TestNameOneof_AdhocTestName",
      "OdProtosHedgehogData_Test_TestNameOneof_SavedTestName"
    ],
    "OdProtosHedgehogServices_RunTestRequest_TestDatasetOneof": [
      "OdProtosHedgehogServices_RunTestRequest_TestDatasetOneof_DatasetFileContents",
      "OdProtosHedgehogServices_RunTestRequest_TestDatasetOneof_SqlQuery"
    ],
    "OdProtosHedgehogServices_RunTestRequest_TestNameOneof": [
      "OdProtosHedgehogServices_RunTestRequest_TestNameOneof_AdhocTestName",
      "OdProtosHedgehogServices_RunTestRequest_TestNameOneof_SavedTestName"
    ],
    "OdProtosHodorEvents_HoaEvent_EventOneof": [
      "OdProtosHodorEvents_HoaEvent_EventOneof_Create",
      "OdProtosHodorEvents_HoaEvent_EventOneof_Deleted",
      "OdProtosHodorEvents_HoaEvent_EventOneof_Update"
    ],
    "OdProtosHodorEvents_HoaPropertyEvent_EventOneof": [
      "OdProtosHodorEvents_HoaPropertyEvent_EventOneof_Created",
      "OdProtosHodorEvents_HoaPropertyEvent_EventOneof_Deleted"
    ],
    "OdProtosHomeDataStore_HomeDetailEvent_EventOneof": [
      "OdProtosHomeDataStore_HomeDetailEvent_EventOneof_AddressUpdate",
      "OdProtosHomeDataStore_HomeDetailEvent_EventOneof_HomeDetailWrite"
    ],
    "OdProtosHomeDataStore_ResolutionStrategy_StrategyOneof": [
      "OdProtosHomeDataStore_ResolutionStrategy_StrategyOneof_BuyBoxCappedPreferenceStrategy",
      "OdProtosHomeDataStore_ResolutionStrategy_StrategyOneof_CalculateAboveGradeSqftFeature",
      "OdProtosHomeDataStore_ResolutionStrategy_StrategyOneof_ConditionScoreStrategy",
      "OdProtosHomeDataStore_ResolutionStrategy_StrategyOneof_FirstPartyFirstStrategy",
      "OdProtosHomeDataStore_ResolutionStrategy_StrategyOneof_OrderPreferenceCappedStrategy",
      "OdProtosHomeDataStore_ResolutionStrategy_StrategyOneof_OrderPreferenceSorted",
      "OdProtosHomeDataStore_ResolutionStrategy_StrategyOneof_OrderPreferenceStrategy",
      "OdProtosHomeDataStore_ResolutionStrategy_StrategyOneof_TmpDwellingTypeFilterStrategy"
    ],
    "OdProtosHomeDataStore_ResolverScope_ResolverLevelOneof": [
      "OdProtosHomeDataStore_ResolverScope_ResolverLevelOneof_CountyResolver",
      "OdProtosHomeDataStore_ResolverScope_ResolverLevelOneof_DefaultResolver",
      "OdProtosHomeDataStore_ResolverScope_ResolverLevelOneof_MarketResolver"
    ],
    "OdProtosHomeworkData_LineItemFilter_Operand_ValueOneof": [
      "OdProtosHomeworkData_LineItemFilter_Operand_ValueOneof_StringValue",
      "OdProtosHomeworkData_LineItemFilter_Operand_ValueOneof_StringValueList"
    ],
    "OdProtosHomeworkData_LineItem_AssociatedWithOneof": [
      "OdProtosHomeworkData_LineItem_AssociatedWithOneof_ProjectId",
      "OdProtosHomeworkData_LineItem_AssociatedWithOneof_WorkOrderId"
    ],
    "OdProtosHomeworkData_ProjectFilter_Operand_ValueOneof": [
      "OdProtosHomeworkData_ProjectFilter_Operand_ValueOneof_KindValue",
      "OdProtosHomeworkData_ProjectFilter_Operand_ValueOneof_MarketValue",
      "OdProtosHomeworkData_ProjectFilter_Operand_ValueOneof_MarketValueList",
      "OdProtosHomeworkData_ProjectFilter_Operand_ValueOneof_StateValue",
      "OdProtosHomeworkData_ProjectFilter_Operand_ValueOneof_StringValue",
      "OdProtosHomeworkData_ProjectFilter_Operand_ValueOneof_StringValueList",
      "OdProtosHomeworkData_ProjectFilter_Operand_ValueOneof_Timestamp"
    ],
    "OdProtosHomeworkData_Project_OwnedByOneof": [
      "OdProtosHomeworkData_Project_OwnedByOneof_BranchId",
      "OdProtosHomeworkData_Project_OwnedByOneof_HumanId",
      "OdProtosHomeworkData_Project_OwnedByOneof_OrganizationId"
    ],
    "OdProtosHomeworkData_Signature_DecisionOneof": [
      "OdProtosHomeworkData_Signature_DecisionOneof_AcceptedBy",
      "OdProtosHomeworkData_Signature_DecisionOneof_RejectedBy"
    ],
    "OdProtosHomeworkData_WorkOrderFilter_Operand_ValueOneof": [
      "OdProtosHomeworkData_WorkOrderFilter_Operand_ValueOneof_KindValueList",
      "OdProtosHomeworkData_WorkOrderFilter_Operand_ValueOneof_MarketValue",
      "OdProtosHomeworkData_WorkOrderFilter_Operand_ValueOneof_MarketValueList",
      "OdProtosHomeworkData_WorkOrderFilter_Operand_ValueOneof_StateValue",
      "OdProtosHomeworkData_WorkOrderFilter_Operand_ValueOneof_StateValueList",
      "OdProtosHomeworkData_WorkOrderFilter_Operand_ValueOneof_StringValue",
      "OdProtosHomeworkData_WorkOrderFilter_Operand_ValueOneof_StringValueList",
      "OdProtosHomeworkData_WorkOrderFilter_Operand_ValueOneof_TimestampValue"
    ],
    "OdProtosHomeworkEvents_ChangeOrderEvent_EventOneof": [
      "OdProtosHomeworkEvents_ChangeOrderEvent_EventOneof_StateChange"
    ],
    "OdProtosHomeworkEvents_LineItemEvent_EventOneof": [
      "OdProtosHomeworkEvents_LineItemEvent_EventOneof_StateChange"
    ],
    "OdProtosHomeworkEvents_ProjectEvent_EventOneof": [
      "OdProtosHomeworkEvents_ProjectEvent_EventOneof_Create",
      "OdProtosHomeworkEvents_ProjectEvent_EventOneof_EndDateChange",
      "OdProtosHomeworkEvents_ProjectEvent_EventOneof_LastMarkedSeenAtChange",
      "OdProtosHomeworkEvents_ProjectEvent_EventOneof_ScopeSignature",
      "OdProtosHomeworkEvents_ProjectEvent_EventOneof_StartDateChange",
      "OdProtosHomeworkEvents_ProjectEvent_EventOneof_StateChange"
    ],
    "OdProtosHomeworkEvents_ReworkEvent_EventOneof": [
      "OdProtosHomeworkEvents_ReworkEvent_EventOneof_Create"
    ],
    "OdProtosHomeworkEvents_WorkOrderEvent_EventOneof": [
      "OdProtosHomeworkEvents_WorkOrderEvent_EventOneof_AssignedBranchChange",
      "OdProtosHomeworkEvents_WorkOrderEvent_EventOneof_CompletionDateChange",
      "OdProtosHomeworkEvents_WorkOrderEvent_EventOneof_ComputedCostChange",
      "OdProtosHomeworkEvents_WorkOrderEvent_EventOneof_Create",
      "OdProtosHomeworkEvents_WorkOrderEvent_EventOneof_Delete",
      "OdProtosHomeworkEvents_WorkOrderEvent_EventOneof_StartDateChange",
      "OdProtosHomeworkEvents_WorkOrderEvent_EventOneof_StateChange",
      "OdProtosHomeworkEvents_WorkOrderEvent_EventOneof_VendorManagerChange"
    ],
    "OdProtosHomeworkEvents_WorkOrderScopeEvent_EventOneof": [
      "OdProtosHomeworkEvents_WorkOrderScopeEvent_EventOneof_Create",
      "OdProtosHomeworkEvents_WorkOrderScopeEvent_EventOneof_Signature"
    ],
    "OdProtosHomeworkServices_CreateLineItemRequest_AssociatedWithOneof": [
      "OdProtosHomeworkServices_CreateLineItemRequest_AssociatedWithOneof_ProjectId",
      "OdProtosHomeworkServices_CreateLineItemRequest_AssociatedWithOneof_WorkOrderId"
    ],
    "OdProtosHomeworkServices_CreateProjectRequest_OwnedByOneof": [
      "OdProtosHomeworkServices_CreateProjectRequest_OwnedByOneof_BranchId",
      "OdProtosHomeworkServices_CreateProjectRequest_OwnedByOneof_HumanId",
      "OdProtosHomeworkServices_CreateProjectRequest_OwnedByOneof_OrganizationId"
    ],
    "OdProtosHomeworkServices_GetLatestTriageActionDecisionRequest_LookupOneof": [
      "OdProtosHomeworkServices_GetLatestTriageActionDecisionRequest_LookupOneof_FlipToken",
      "OdProtosHomeworkServices_GetLatestTriageActionDecisionRequest_LookupOneof_TaskId"
    ],
    "OdProtosHomeworkServices_GetLatestTriageIntakeDecisionRequest_LookupOneof": [
      "OdProtosHomeworkServices_GetLatestTriageIntakeDecisionRequest_LookupOneof_FlipToken",
      "OdProtosHomeworkServices_GetLatestTriageIntakeDecisionRequest_LookupOneof_TaskId"
    ],
    "OdProtosHomeworkServices_ProposeLineItemRequest_AssociatedWithOneof": [
      "OdProtosHomeworkServices_ProposeLineItemRequest_AssociatedWithOneof_AssociatedWithProjectId",
      "OdProtosHomeworkServices_ProposeLineItemRequest_AssociatedWithOneof_AssociatedWithWorkOrderId"
    ],
    "OdProtosHomeworkServices_SignatureRequest_DecisionOneof": [
      "OdProtosHomeworkServices_SignatureRequest_DecisionOneof_AcceptedAt",
      "OdProtosHomeworkServices_SignatureRequest_DecisionOneof_RejectedAt"
    ],
    "OdProtosHomeworkServices_StartTriageProcessRequest_SourceOneof": [
      "OdProtosHomeworkServices_StartTriageProcessRequest_SourceOneof_IncidentReportId",
      "OdProtosHomeworkServices_StartTriageProcessRequest_SourceOneof_ListingFeedbackId",
      "OdProtosHomeworkServices_StartTriageProcessRequest_SourceOneof_Message",
      "OdProtosHomeworkServices_StartTriageProcessRequest_SourceOneof_NoteId"
    ],
    "OdProtosHomeworkServices_UpdateLineItemRequest_AssociatedWithOneof": [
      "OdProtosHomeworkServices_UpdateLineItemRequest_AssociatedWithOneof_ProjectId",
      "OdProtosHomeworkServices_UpdateLineItemRequest_AssociatedWithOneof_WorkOrderId"
    ],
    "OdProtosHomeworkServices_UpdateProjectRequest_OwnedByOneof": [
      "OdProtosHomeworkServices_UpdateProjectRequest_OwnedByOneof_BranchId",
      "OdProtosHomeworkServices_UpdateProjectRequest_OwnedByOneof_HumanId",
      "OdProtosHomeworkServices_UpdateProjectRequest_OwnedByOneof_OrganizationId"
    ],
    "OdProtosHook_HttpEvent_EventOneof": [
      "OdProtosHook_HttpEvent_EventOneof_HttpRequest"
    ],
    "OdProtosHook_InternalHttpEvent_EventOneof": [
      "OdProtosHook_InternalHttpEvent_EventOneof_HttpRequest"
    ],
    "OdProtosIndextriousData_Filter_FieldExists_ValueOneof": [
      "OdProtosIndextriousData_Filter_FieldExists_ValueOneof_Field",
      "OdProtosIndextriousData_Filter_FieldExists_ValueOneof_NestedField"
    ],
    "OdProtosIndextriousData_Filter_FieldNotExists_ValueOneof": [
      "OdProtosIndextriousData_Filter_FieldNotExists_ValueOneof_Field",
      "OdProtosIndextriousData_Filter_FieldNotExists_ValueOneof_NestedField"
    ],
    "OdProtosIndextriousData_Filter_Operand_ValueOneof": [
      "OdProtosIndextriousData_Filter_Operand_ValueOneof_ArrayValue",
      "OdProtosIndextriousData_Filter_Operand_ValueOneof_GeoBoundingBoxValue",
      "OdProtosIndextriousData_Filter_Operand_ValueOneof_GeoDistanceValue",
      "OdProtosIndextriousData_Filter_Operand_ValueOneof_GeoPolygonValue",
      "OdProtosIndextriousData_Filter_Operand_ValueOneof_RangeValue",
      "OdProtosIndextriousData_Filter_Operand_ValueOneof_StringValue"
    ],
    "OdProtosIndextriousData_Filter_ValueOneof": [
      "OdProtosIndextriousData_Filter_ValueOneof_And",
      "OdProtosIndextriousData_Filter_ValueOneof_Exists",
      "OdProtosIndextriousData_Filter_ValueOneof_Multi",
      "OdProtosIndextriousData_Filter_ValueOneof_Not",
      "OdProtosIndextriousData_Filter_ValueOneof_NotExists",
      "OdProtosIndextriousData_Filter_ValueOneof_Or",
      "OdProtosIndextriousData_Filter_ValueOneof_Single"
    ],
    "OdProtosIndextriousData_SearchResult_ResultOneof": [
      "OdProtosIndextriousData_SearchResult_ResultOneof_Address",
      "OdProtosIndextriousData_SearchResult_ResultOneof_BuyerProperty",
      "OdProtosIndextriousData_SearchResult_ResultOneof_Customer",
      "OdProtosIndextriousData_SearchResult_ResultOneof_Fulfillment",
      "OdProtosIndextriousData_SearchResult_ResultOneof_Hodor",
      "OdProtosIndextriousData_SearchResult_ResultOneof_Human",
      "OdProtosIndextriousData_SearchResult_ResultOneof_Listing",
      "OdProtosIndextriousData_SearchResult_ResultOneof_ListingOffer",
      "OdProtosIndextriousData_SearchResult_ResultOneof_LwcListing",
      "OdProtosIndextriousData_SearchResult_ResultOneof_Note",
      "OdProtosIndextriousData_SearchResult_ResultOneof_Operator",
      "OdProtosIndextriousData_SearchResult_ResultOneof_Organization",
      "OdProtosIndextriousData_SearchResult_ResultOneof_Property",
      "OdProtosIndextriousData_SearchResult_ResultOneof_Renovation",
      "OdProtosIndextriousData_SearchResult_ResultOneof_SellDirectOffer",
      "OdProtosIndextriousData_SearchResult_ResultOneof_SellerLead",
      "OdProtosIndextriousData_SearchResult_ResultOneof_Showing",
      "OdProtosIndextriousData_SearchResult_ResultOneof_Task",
      "OdProtosIndextriousData_SearchResult_ResultOneof_Ticket",
      "OdProtosIndextriousData_SearchResult_ResultOneof_TourRequest",
      "OdProtosIndextriousData_SearchResult_ResultOneof_TradePartnerWorkOrder"
    ],
    "OdProtosIndextriousServices_BackfillIndexRequest_IdsOneof": [
      "OdProtosIndextriousServices_BackfillIndexRequest_IdsOneof_IdsFromFile",
      "OdProtosIndextriousServices_BackfillIndexRequest_IdsOneof_StringIds"
    ],
    "OdProtosInsightData_UserIdentifier_UserIdentifierOneof": [
      "OdProtosInsightData_UserIdentifier_UserIdentifierOneof_AnonymousId",
      "OdProtosInsightData_UserIdentifier_UserIdentifierOneof_CustomerUuid"
    ],
    "OdProtosInsightV2Data_Identifier_Customer_IdentifierOneof": [
      "OdProtosInsightV2Data_Identifier_Customer_IdentifierOneof_AnonymousId",
      "OdProtosInsightV2Data_Identifier_Customer_IdentifierOneof_CustomerUuid"
    ],
    "OdProtosInsightV2Data_Identifier_IdentifierOneof": [
      "OdProtosInsightV2Data_Identifier_IdentifierOneof_CustomerIdentifier",
      "OdProtosInsightV2Data_Identifier_IdentifierOneof_LeadIdentifier",
      "OdProtosInsightV2Data_Identifier_IdentifierOneof_PropertyIdentifier"
    ],
    "OdProtosInsightV2Data_Identifier_Lead_IdentifierOneof": [
      "OdProtosInsightV2Data_Identifier_Lead_IdentifierOneof_LeadId",
      "OdProtosInsightV2Data_Identifier_Lead_IdentifierOneof_SellerInputId",
      "OdProtosInsightV2Data_Identifier_Lead_IdentifierOneof_SellerLeadUuid"
    ],
    "OdProtosInsightV2Data_Identifier_Property_IdentifierOneof": [
      "OdProtosInsightV2Data_Identifier_Property_IdentifierOneof_AddressToken"
    ],
    "OdProtosInsightV2Events_TraitEvent_EventOneof": [
      "OdProtosInsightV2Events_TraitEvent_EventOneof_CustomerChange",
      "OdProtosInsightV2Events_TraitEvent_EventOneof_LeadChange"
    ],
    "OdProtosInstitutionsData_Activity_Details_DetailsTypeOneof": [
      "OdProtosInstitutionsData_Activity_Details_DetailsTypeOneof_BidUpload",
      "OdProtosInstitutionsData_Activity_Details_DetailsTypeOneof_BulkDownload",
      "OdProtosInstitutionsData_Activity_Details_DetailsTypeOneof_MlsDownload",
      "OdProtosInstitutionsData_Activity_Details_DetailsTypeOneof_TapeDownload"
    ],
    "OdProtosInstitutionsData_MonetaryPreference_PreferenceOneof": [
      "OdProtosInstitutionsData_MonetaryPreference_PreferenceOneof_Amount",
      "OdProtosInstitutionsData_MonetaryPreference_PreferenceOneof_Percentage"
    ],
    "OdProtosInstitutionsReithouseDataBrokerage_DocumentRequirement_TransitionRequirement_WhenOneof": [
      "OdProtosInstitutionsReithouseDataBrokerage_DocumentRequirement_TransitionRequirement_WhenOneof_BeforeArchive",
      "OdProtosInstitutionsReithouseDataBrokerage_DocumentRequirement_TransitionRequirement_WhenOneof_BeforeTransitionToState"
    ],
    "OdProtosInstitutionsReithouseDataBrokerage_Rule_TypeOneof": [
      "OdProtosInstitutionsReithouseDataBrokerage_Rule_TypeOneof_DocumentRequirement"
    ],
    "OdProtosInstitutionsReithouseDataBrokerage_Violation_TypeOneof": [
      "OdProtosInstitutionsReithouseDataBrokerage_Violation_TypeOneof_DocumentViolation"
    ],
    "OdProtosInstitutionsReithouseData_Asset_LocationOneof": [
      "OdProtosInstitutionsReithouseData_Asset_LocationOneof_CabinetAssetId",
      "OdProtosInstitutionsReithouseData_Asset_LocationOneof_Url"
    ],
    "OdProtosInstitutionsReithouseData_BrokerCommission_CommissionOneof": [
      "OdProtosInstitutionsReithouseData_BrokerCommission_CommissionOneof_Amount",
      "OdProtosInstitutionsReithouseData_BrokerCommission_CommissionOneof_Percentage"
    ],
    "OdProtosInstitutionsReithouseData_Concession_CommissionOneof": [
      "OdProtosInstitutionsReithouseData_Concession_CommissionOneof_CommissionAmount",
      "OdProtosInstitutionsReithouseData_Concession_CommissionOneof_Percentage"
    ],
    "OdProtosInstitutionsReithouseData_Contingency_ContingencyType_TypeOneof": [
      "OdProtosInstitutionsReithouseData_Contingency_ContingencyType_TypeOneof_Appraisal",
      "OdProtosInstitutionsReithouseData_Contingency_ContingencyType_TypeOneof_Financing",
      "OdProtosInstitutionsReithouseData_Contingency_ContingencyType_TypeOneof_HomeSale",
      "OdProtosInstitutionsReithouseData_Contingency_ContingencyType_TypeOneof_Inspection",
      "OdProtosInstitutionsReithouseData_Contingency_ContingencyType_TypeOneof_ResolutionPeriod"
    ],
    "OdProtosInstitutionsReithouseData_Document_SigningError_TypeOneof": [
      "OdProtosInstitutionsReithouseData_Document_SigningError_TypeOneof_DocumentSignatureRequestDeclined",
      "OdProtosInstitutionsReithouseData_Document_SigningError_TypeOneof_DocumentSignatureRequestEmailBounced"
    ],
    "OdProtosInstitutionsReithouseData_Error_TypeOneof": [
      "OdProtosInstitutionsReithouseData_Error_TypeOneof_DocumentError",
      "OdProtosInstitutionsReithouseData_Error_TypeOneof_DocumentGenerationMissingExternalField",
      "OdProtosInstitutionsReithouseData_Error_TypeOneof_ParticipantError",
      "OdProtosInstitutionsReithouseData_Error_TypeOneof_TermError",
      "OdProtosInstitutionsReithouseData_Error_TypeOneof_TransactionMissingFieldError"
    ],
    "OdProtosInstitutionsReithouseData_FeeSplit_Split_SplitOneof": [
      "OdProtosInstitutionsReithouseData_FeeSplit_Split_SplitOneof_Amount",
      "OdProtosInstitutionsReithouseData_FeeSplit_Split_SplitOneof_Percentage"
    ],
    "OdProtosInstitutionsReithouseData_GroupSpecific_DomainOneof": [
      "OdProtosInstitutionsReithouseData_GroupSpecific_DomainOneof_ClearinghouseSpecific"
    ],
    "OdProtosInstitutionsReithouseData_OverrideField_ValueOneof": [
      "OdProtosInstitutionsReithouseData_OverrideField_ValueOneof_BoolVal",
      "OdProtosInstitutionsReithouseData_OverrideField_ValueOneof_StringVal"
    ],
    "OdProtosInstitutionsReithouseData_SellerCredit_CreditOneof": [
      "OdProtosInstitutionsReithouseData_SellerCredit_CreditOneof_Amount",
      "OdProtosInstitutionsReithouseData_SellerCredit_CreditOneof_Percentage"
    ],
    "OdProtosInstitutionsReithouseData_TermType_TypeOneof": [
      "OdProtosInstitutionsReithouseData_TermType_TypeOneof_AdditionalEarnestDeposit",
      "OdProtosInstitutionsReithouseData_TermType_TypeOneof_AppraisalDate",
      "OdProtosInstitutionsReithouseData_TermType_TypeOneof_BrokerCommission",
      "OdProtosInstitutionsReithouseData_TermType_TypeOneof_BuyerBrokerCommission",
      "OdProtosInstitutionsReithouseData_TermType_TypeOneof_CloseOfEscrowDate",
      "OdProtosInstitutionsReithouseData_TermType_TypeOneof_Concession",
      "OdProtosInstitutionsReithouseData_TermType_TypeOneof_Contingency",
      "OdProtosInstitutionsReithouseData_TermType_TypeOneof_ContractExpiration",
      "OdProtosInstitutionsReithouseData_TermType_TypeOneof_Conveyances",
      "OdProtosInstitutionsReithouseData_TermType_TypeOneof_EarnestDeposit",
      "OdProtosInstitutionsReithouseData_TermType_TypeOneof_EarnestDepositDue",
      "OdProtosInstitutionsReithouseData_TermType_TypeOneof_FundingRelatedDelays",
      "OdProtosInstitutionsReithouseData_TermType_TypeOneof_InspectionSchedule",
      "OdProtosInstitutionsReithouseData_TermType_TypeOneof_LandSurveyRequirement",
      "OdProtosInstitutionsReithouseData_TermType_TypeOneof_OpendoorCommission",
      "OdProtosInstitutionsReithouseData_TermType_TypeOneof_OxFee",
      "OdProtosInstitutionsReithouseData_TermType_TypeOneof_Price",
      "OdProtosInstitutionsReithouseData_TermType_TypeOneof_Reimbursement",
      "OdProtosInstitutionsReithouseData_TermType_TypeOneof_RentBack",
      "OdProtosInstitutionsReithouseData_TermType_TypeOneof_Repair",
      "OdProtosInstitutionsReithouseData_TermType_TypeOneof_SellerBrokerCommission",
      "OdProtosInstitutionsReithouseData_TermType_TypeOneof_SellerCredit",
      "OdProtosInstitutionsReithouseData_TermType_TypeOneof_SellerDisclosuresDue",
      "OdProtosInstitutionsReithouseData_TermType_TypeOneof_TerminationOption",
      "OdProtosInstitutionsReithouseData_TermType_TypeOneof_TextTerm",
      "OdProtosInstitutionsReithouseData_TermType_TypeOneof_TitlePolicyAmendment",
      "OdProtosInstitutionsReithouseData_TermType_TypeOneof_TitlePolicyFee",
      "OdProtosInstitutionsReithouseData_TermType_TypeOneof_VacancyDate"
    ],
    "OdProtosInstitutionsReithouseServices_UpdateGroupSpecificRequest_DomainOneof": [
      "OdProtosInstitutionsReithouseServices_UpdateGroupSpecificRequest_DomainOneof_UpdateClearinghouseSpecific"
    ],
    "OdProtosInstitutionsServices_GetSellableRequest_IdentifierOneof": [
      "OdProtosInstitutionsServices_GetSellableRequest_IdentifierOneof_AddressId",
      "OdProtosInstitutionsServices_GetSellableRequest_IdentifierOneof_Id",
      "OdProtosInstitutionsServices_GetSellableRequest_IdentifierOneof_SellableInfo"
    ],
    "OdProtosInstitutionsTasks_Field_FieldOneof": [
      "OdProtosInstitutionsTasks_Field_FieldOneof_Bool",
      "OdProtosInstitutionsTasks_Field_FieldOneof_Date",
      "OdProtosInstitutionsTasks_Field_FieldOneof_Int",
      "OdProtosInstitutionsTasks_Field_FieldOneof_String",
      "OdProtosInstitutionsTasks_Field_FieldOneof_Timestamp"
    ],
    "OdProtosInstitutionsTasks_TaskConfig_Deadline_AnchorOneof": [
      "OdProtosInstitutionsTasks_TaskConfig_Deadline_AnchorOneof_AnchorDate",
      "OdProtosInstitutionsTasks_TaskConfig_Deadline_AnchorOneof_AnchorTimestamp",
      "OdProtosInstitutionsTasks_TaskConfig_Deadline_AnchorOneof_CustomClass"
    ],
    "OdProtosInventoryPrototypeServices_GetAgentFeedbacksRequest_IdentifierOneof": [
      "OdProtosInventoryPrototypeServices_GetAgentFeedbacksRequest_IdentifierOneof_FlipToken"
    ],
    "OdProtosInventoryPrototypeServices_InventoryManagementRequest_CreateEvent_EventDetailsOneof": [
      "OdProtosInventoryPrototypeServices_InventoryManagementRequest_CreateEvent_EventDetailsOneof_BuyOfferDetails",
      "OdProtosInventoryPrototypeServices_InventoryManagementRequest_CreateEvent_EventDetailsOneof_ChangeAddressTokenDetails",
      "OdProtosInventoryPrototypeServices_InventoryManagementRequest_CreateEvent_EventDetailsOneof_ListPriceEnsembledValuationCompletedDetails",
      "OdProtosInventoryPrototypeServices_InventoryManagementRequest_CreateEvent_EventDetailsOneof_ListPriceEnsembledValuationEscalatedDetails",
      "OdProtosInventoryPrototypeServices_InventoryManagementRequest_CreateEvent_EventDetailsOneof_ListPriceValuationCompletedDetails",
      "OdProtosInventoryPrototypeServices_InventoryManagementRequest_CreateEvent_EventDetailsOneof_ListPriceValuationRequestedDetails",
      "OdProtosInventoryPrototypeServices_InventoryManagementRequest_CreateEvent_EventDetailsOneof_ListingPhotosUploadedDetails"
    ],
    "OdProtosJohnnyfiveEvents_PatrolResponseEvent_EventOneof": [
      "OdProtosJohnnyfiveEvents_PatrolResponseEvent_EventOneof_Created"
    ],
    "OdProtosJohnnyfiveEvents_PatrolResponsePDFEvent_EventOneof": [
      "OdProtosJohnnyfiveEvents_PatrolResponsePDFEvent_EventOneof_Uploaded"
    ],
    "OdProtosJourneyDataCategories_AgentConnectCategory_EventOneof": [
      "OdProtosJourneyDataCategories_AgentConnectCategory_EventOneof_DeniedEvent",
      "OdProtosJourneyDataCategories_AgentConnectCategory_EventOneof_HandoffEvent",
      "OdProtosJourneyDataCategories_AgentConnectCategory_EventOneof_ViewEvent"
    ],
    "OdProtosJourneyDataCategories_AloCategory_EventOneof": [
      "OdProtosJourneyDataCategories_AloCategory_EventOneof_HandoffPageViewEvent",
      "OdProtosJourneyDataCategories_AloCategory_EventOneof_HandoffSubmitEvent",
      "OdProtosJourneyDataCategories_AloCategory_EventOneof_PageViewEvent",
      "OdProtosJourneyDataCategories_AloCategory_EventOneof_QualificationEvent"
    ],
    "OdProtosJourneyDataCategories_AssessmentCategory_EventOneof": [
      "OdProtosJourneyDataCategories_AssessmentCategory_EventOneof_FirstPhotoTaken",
      "OdProtosJourneyDataCategories_AssessmentCategory_EventOneof_FirstQuestionAnswered",
      "OdProtosJourneyDataCategories_AssessmentCategory_EventOneof_FlowCompleted",
      "OdProtosJourneyDataCategories_AssessmentCategory_EventOneof_FlowStart",
      "OdProtosJourneyDataCategories_AssessmentCategory_EventOneof_Requested",
      "OdProtosJourneyDataCategories_AssessmentCategory_EventOneof_ScheduleStart",
      "OdProtosJourneyDataCategories_AssessmentCategory_EventOneof_SpaceCompleted"
    ],
    "OdProtosJourneyDataCategories_AuthenticationCategory_EventOneof": [
      "OdProtosJourneyDataCategories_AuthenticationCategory_EventOneof_ClientRegistration",
      "OdProtosJourneyDataCategories_AuthenticationCategory_EventOneof_Login",
      "OdProtosJourneyDataCategories_AuthenticationCategory_EventOneof_LoginFailure",
      "OdProtosJourneyDataCategories_AuthenticationCategory_EventOneof_Registration",
      "OdProtosJourneyDataCategories_AuthenticationCategory_EventOneof_RegistrationFailure"
    ],
    "OdProtosJourneyDataCategories_ChatCategory_EventOneof": [
      "OdProtosJourneyDataCategories_ChatCategory_EventOneof_Interaction"
    ],
    "OdProtosJourneyDataCategories_CommunicationCategory_EventOneof": [
      "OdProtosJourneyDataCategories_CommunicationCategory_EventOneof_SmsReceived",
      "OdProtosJourneyDataCategories_CommunicationCategory_EventOneof_SmsSent",
      "OdProtosJourneyDataCategories_CommunicationCategory_EventOneof_SubscriptionUpdated"
    ],
    "OdProtosJourneyDataCategories_ExperimentationCategory_EventOneof": [
      "OdProtosJourneyDataCategories_ExperimentationCategory_EventOneof_Assignment",
      "OdProtosJourneyDataCategories_ExperimentationCategory_EventOneof_Impression",
      "OdProtosJourneyDataCategories_ExperimentationCategory_EventOneof_LeadAssignment",
      "OdProtosJourneyDataCategories_ExperimentationCategory_EventOneof_LeadImpression"
    ],
    "OdProtosJourneyDataCategories_HomeGuideCategory_EventOneof": [
      "OdProtosJourneyDataCategories_HomeGuideCategory_EventOneof_Qualification",
      "OdProtosJourneyDataCategories_HomeGuideCategory_EventOneof_Valuation"
    ],
    "OdProtosJourneyDataCategories_LanguageCategory_EventOneof": [
      "OdProtosJourneyDataCategories_LanguageCategory_EventOneof_SelectEvent"
    ],
    "OdProtosJourneyDataCategories_MarketplacePropertyCategory_EventOneof": [
      "OdProtosJourneyDataCategories_MarketplacePropertyCategory_EventOneof_DetailPageView",
      "OdProtosJourneyDataCategories_MarketplacePropertyCategory_EventOneof_OfferStart",
      "OdProtosJourneyDataCategories_MarketplacePropertyCategory_EventOneof_Reaction",
      "OdProtosJourneyDataCategories_MarketplacePropertyCategory_EventOneof_RentalScamBannerLearnMore",
      "OdProtosJourneyDataCategories_MarketplacePropertyCategory_EventOneof_RentalScamBannerView",
      "OdProtosJourneyDataCategories_MarketplacePropertyCategory_EventOneof_Share",
      "OdProtosJourneyDataCategories_MarketplacePropertyCategory_EventOneof_SimilarHomesClick",
      "OdProtosJourneyDataCategories_MarketplacePropertyCategory_EventOneof_TourBookingStart"
    ],
    "OdProtosJourneyDataCategories_MortgageCategory_EventOneof": [
      "OdProtosJourneyDataCategories_MortgageCategory_EventOneof_ApplicationDecision",
      "OdProtosJourneyDataCategories_MortgageCategory_EventOneof_ApplicationStart",
      "OdProtosJourneyDataCategories_MortgageCategory_EventOneof_ApplicationSubmit",
      "OdProtosJourneyDataCategories_MortgageCategory_EventOneof_DisclosuresSigned",
      "OdProtosJourneyDataCategories_MortgageCategory_EventOneof_DownPaymentSelection",
      "OdProtosJourneyDataCategories_MortgageCategory_EventOneof_IntegrationResult",
      "OdProtosJourneyDataCategories_MortgageCategory_EventOneof_IntegrationStart",
      "OdProtosJourneyDataCategories_MortgageCategory_EventOneof_LowerReferral",
      "OdProtosJourneyDataCategories_MortgageCategory_EventOneof_OutOfPocketMaxSelection",
      "OdProtosJourneyDataCategories_MortgageCategory_EventOneof_PrequalDecision",
      "OdProtosJourneyDataCategories_MortgageCategory_EventOneof_PrequalStart",
      "OdProtosJourneyDataCategories_MortgageCategory_EventOneof_PrequalStepComplete",
      "OdProtosJourneyDataCategories_MortgageCategory_EventOneof_PrequalStepView",
      "OdProtosJourneyDataCategories_MortgageCategory_EventOneof_PrequalSubmit",
      "OdProtosJourneyDataCategories_MortgageCategory_EventOneof_PrequalValidationError",
      "OdProtosJourneyDataCategories_MortgageCategory_EventOneof_ProductPricingSeeDetails",
      "OdProtosJourneyDataCategories_MortgageCategory_EventOneof_ProductPricingSelect",
      "OdProtosJourneyDataCategories_MortgageCategory_EventOneof_ProductPricingStart",
      "OdProtosJourneyDataCategories_MortgageCategory_EventOneof_RateLockComplete",
      "OdProtosJourneyDataCategories_MortgageCategory_EventOneof_RateLockStart",
      "OdProtosJourneyDataCategories_MortgageCategory_EventOneof_StepComplete",
      "OdProtosJourneyDataCategories_MortgageCategory_EventOneof_StepView",
      "OdProtosJourneyDataCategories_MortgageCategory_EventOneof_ValidationError"
    ],
    "OdProtosJourneyDataCategories_PlatformCategory_EventOneof": [
      "OdProtosJourneyDataCategories_PlatformCategory_EventOneof_AccordionClickEvent",
      "OdProtosJourneyDataCategories_PlatformCategory_EventOneof_AccordionViewEvent",
      "OdProtosJourneyDataCategories_PlatformCategory_EventOneof_AppBackgroundedEvent",
      "OdProtosJourneyDataCategories_PlatformCategory_EventOneof_AppDownloadLinkEvent",
      "OdProtosJourneyDataCategories_PlatformCategory_EventOneof_AppForegroundedEvent",
      "OdProtosJourneyDataCategories_PlatformCategory_EventOneof_AppLaunchedEvent",
      "OdProtosJourneyDataCategories_PlatformCategory_EventOneof_BoxViewEvent",
      "OdProtosJourneyDataCategories_PlatformCategory_EventOneof_ButtonClickEvent",
      "OdProtosJourneyDataCategories_PlatformCategory_EventOneof_ButtonViewEvent",
      "OdProtosJourneyDataCategories_PlatformCategory_EventOneof_CardViewEvent",
      "OdProtosJourneyDataCategories_PlatformCategory_EventOneof_CheckboxClickEvent",
      "OdProtosJourneyDataCategories_PlatformCategory_EventOneof_CheckboxViewEvent",
      "OdProtosJourneyDataCategories_PlatformCategory_EventOneof_CustomerOneTimeExperienceEvent",
      "OdProtosJourneyDataCategories_PlatformCategory_EventOneof_CustomerUnsubscribeEvent",
      "OdProtosJourneyDataCategories_PlatformCategory_EventOneof_FormFieldCompleteEvent",
      "OdProtosJourneyDataCategories_PlatformCategory_EventOneof_FormFieldFocusEvent",
      "OdProtosJourneyDataCategories_PlatformCategory_EventOneof_FormFieldValidationErrorEvent",
      "OdProtosJourneyDataCategories_PlatformCategory_EventOneof_FormSubmitAttemptEvent",
      "OdProtosJourneyDataCategories_PlatformCategory_EventOneof_FormViewEvent",
      "OdProtosJourneyDataCategories_PlatformCategory_EventOneof_ImageViewEvent",
      "OdProtosJourneyDataCategories_PlatformCategory_EventOneof_InitialPageViewEvent",
      "OdProtosJourneyDataCategories_PlatformCategory_EventOneof_InputFocusEvent",
      "OdProtosJourneyDataCategories_PlatformCategory_EventOneof_InputViewEvent",
      "OdProtosJourneyDataCategories_PlatformCategory_EventOneof_LeadOneTimeExperienceEvent",
      "OdProtosJourneyDataCategories_PlatformCategory_EventOneof_LinkClickEvent",
      "OdProtosJourneyDataCategories_PlatformCategory_EventOneof_LinkViewEvent",
      "OdProtosJourneyDataCategories_PlatformCategory_EventOneof_PageLoadedEvent",
      "OdProtosJourneyDataCategories_PlatformCategory_EventOneof_PageViewEvent",
      "OdProtosJourneyDataCategories_PlatformCategory_EventOneof_RadioClickEvent",
      "OdProtosJourneyDataCategories_PlatformCategory_EventOneof_RadioViewEvent",
      "OdProtosJourneyDataCategories_PlatformCategory_EventOneof_ScreenViewEvent",
      "OdProtosJourneyDataCategories_PlatformCategory_EventOneof_SessionEndEvent",
      "OdProtosJourneyDataCategories_PlatformCategory_EventOneof_SessionStartEvent",
      "OdProtosJourneyDataCategories_PlatformCategory_EventOneof_TextViewEvent"
    ],
    "OdProtosJourneyDataCategories_RetailWebUnlockCategory_EventOneof": [
      "OdProtosJourneyDataCategories_RetailWebUnlockCategory_EventOneof_ContactUsEvent",
      "OdProtosJourneyDataCategories_RetailWebUnlockCategory_EventOneof_GeneralErrorEvent",
      "OdProtosJourneyDataCategories_RetailWebUnlockCategory_EventOneof_IdVerificationEvent",
      "OdProtosJourneyDataCategories_RetailWebUnlockCategory_EventOneof_IdVerificationSubmissionEvent",
      "OdProtosJourneyDataCategories_RetailWebUnlockCategory_EventOneof_LocationPermissionEvent",
      "OdProtosJourneyDataCategories_RetailWebUnlockCategory_EventOneof_PropertyStatusEvent",
      "OdProtosJourneyDataCategories_RetailWebUnlockCategory_EventOneof_UnlockAttemptEvent",
      "OdProtosJourneyDataCategories_RetailWebUnlockCategory_EventOneof_ViewEvent"
    ],
    "OdProtosJourneyDataCategories_SellCategory_EventOneof": [
      "OdProtosJourneyDataCategories_SellCategory_EventOneof_AddressEntry",
      "OdProtosJourneyDataCategories_SellCategory_EventOneof_AddressEntryV2",
      "OdProtosJourneyDataCategories_SellCategory_EventOneof_ApiOfferRequest",
      "OdProtosJourneyDataCategories_SellCategory_EventOneof_ApiReferralHandover",
      "OdProtosJourneyDataCategories_SellCategory_EventOneof_CustomerProductIntentAtFinalOffer",
      "OdProtosJourneyDataCategories_SellCategory_EventOneof_CustomerProductIntentPostFinalOffer",
      "OdProtosJourneyDataCategories_SellCategory_EventOneof_ExperienceViewed",
      "OdProtosJourneyDataCategories_SellCategory_EventOneof_FinalOfferCompsDataDisplayed",
      "OdProtosJourneyDataCategories_SellCategory_EventOneof_OnboardingStart",
      "OdProtosJourneyDataCategories_SellCategory_EventOneof_ProductClosed",
      "OdProtosJourneyDataCategories_SellCategory_EventOneof_SignedContract",
      "OdProtosJourneyDataCategories_SellCategory_EventOneof_SimilarHomeComparisonClick",
      "OdProtosJourneyDataCategories_SellCategory_EventOneof_SimilarHomeComparisonView",
      "OdProtosJourneyDataCategories_SellCategory_EventOneof_SsvaTaskComplete"
    ],
    "OdProtosJourneyDataCategories_SellDirectCategory_EventOneof": [
      "OdProtosJourneyDataCategories_SellDirectCategory_EventOneof_ClientQualificationCompleted",
      "OdProtosJourneyDataCategories_SellDirectCategory_EventOneof_FinalOfferCreated",
      "OdProtosJourneyDataCategories_SellDirectCategory_EventOneof_OfferCreated",
      "OdProtosJourneyDataCategories_SellDirectCategory_EventOneof_OfferFallthrough",
      "OdProtosJourneyDataCategories_SellDirectCategory_EventOneof_OfferView",
      "OdProtosJourneyDataCategories_SellDirectCategory_EventOneof_Qualification",
      "OdProtosJourneyDataCategories_SellDirectCategory_EventOneof_SignComplete",
      "OdProtosJourneyDataCategories_SellDirectCategory_EventOneof_SignQuestionsSubmit",
      "OdProtosJourneyDataCategories_SellDirectCategory_EventOneof_SignStart"
    ],
    "OdProtosJourneyDataCategories_SellEACategory_EventOneof": [
      "OdProtosJourneyDataCategories_SellEACategory_EventOneof_Complete",
      "OdProtosJourneyDataCategories_SellEACategory_EventOneof_Schedule"
    ],
    "OdProtosJourneyDataCategories_SellFinalOfferCallCategory_EventOneof": [
      "OdProtosJourneyDataCategories_SellFinalOfferCallCategory_EventOneof_Canceled",
      "OdProtosJourneyDataCategories_SellFinalOfferCallCategory_EventOneof_Proposed",
      "OdProtosJourneyDataCategories_SellFinalOfferCallCategory_EventOneof_Rescheduled",
      "OdProtosJourneyDataCategories_SellFinalOfferCallCategory_EventOneof_ScheduleReminder",
      "OdProtosJourneyDataCategories_SellFinalOfferCallCategory_EventOneof_Scheduled"
    ],
    "OdProtosJourneyDataCategories_SellListCategory_EventOneof": [
      "OdProtosJourneyDataCategories_SellListCategory_EventOneof_AgreementSignComplete",
      "OdProtosJourneyDataCategories_SellListCategory_EventOneof_OfferView",
      "OdProtosJourneyDataCategories_SellListCategory_EventOneof_Qualification"
    ],
    "OdProtosJourneyDataCategories_SellORVACategory_EventOneof": [
      "OdProtosJourneyDataCategories_SellORVACategory_EventOneof_Cancel",
      "OdProtosJourneyDataCategories_SellORVACategory_EventOneof_Reschedule",
      "OdProtosJourneyDataCategories_SellORVACategory_EventOneof_Schedule"
    ],
    "OdProtosJourneyDataCategories_SellOfferReviewCategory_EventOneof": [
      "OdProtosJourneyDataCategories_SellOfferReviewCategory_EventOneof_Canceled",
      "OdProtosJourneyDataCategories_SellOfferReviewCategory_EventOneof_Completed",
      "OdProtosJourneyDataCategories_SellOfferReviewCategory_EventOneof_Rescheduled",
      "OdProtosJourneyDataCategories_SellOfferReviewCategory_EventOneof_Scheduled"
    ],
    "OdProtosJourneyDataCategories_SellOnboardingCategory_EventOneof": [
      "OdProtosJourneyDataCategories_SellOnboardingCategory_EventOneof_QuestionsSubmit"
    ],
    "OdProtosJourneyDataCategories_SellVACategory_EventOneof": [
      "OdProtosJourneyDataCategories_SellVACategory_EventOneof_Complete",
      "OdProtosJourneyDataCategories_SellVACategory_EventOneof_FlowStart",
      "OdProtosJourneyDataCategories_SellVACategory_EventOneof_Occupancy",
      "OdProtosJourneyDataCategories_SellVACategory_EventOneof_Start"
    ],
    "OdProtosJourneyDataCategories_SellWithUpsideCategory_EventOneof": [
      "OdProtosJourneyDataCategories_SellWithUpsideCategory_EventOneof_EstimatedSalesPriceChange",
      "OdProtosJourneyDataCategories_SellWithUpsideCategory_EventOneof_PricingOptionsLoaded",
      "OdProtosJourneyDataCategories_SellWithUpsideCategory_EventOneof_Qualification",
      "OdProtosJourneyDataCategories_SellWithUpsideCategory_EventOneof_UpfrontCashChange"
    ],
    "OdProtosJourneyDataOptions_CdpOptions_OptionsOneof": [
      "OdProtosJourneyDataOptions_CdpOptions_OptionsOneof_Enum",
      "OdProtosJourneyDataOptions_CdpOptions_OptionsOneof_Map",
      "OdProtosJourneyDataOptions_CdpOptions_OptionsOneof_Message"
    ],
    "OdProtosJourneyDataOptions_Validation_RulesOneof": [
      "OdProtosJourneyDataOptions_Validation_RulesOneof_Enum",
      "OdProtosJourneyDataOptions_Validation_RulesOneof_Int",
      "OdProtosJourneyDataOptions_Validation_RulesOneof_Message",
      "OdProtosJourneyDataOptions_Validation_RulesOneof_String"
    ],
    "OdProtosJourneyData_EventWrapper_CategoryOneof": [
      "OdProtosJourneyData_EventWrapper_CategoryOneof_AgentConnect",
      "OdProtosJourneyData_EventWrapper_CategoryOneof_Alo",
      "OdProtosJourneyData_EventWrapper_CategoryOneof_Assessment",
      "OdProtosJourneyData_EventWrapper_CategoryOneof_Authentication",
      "OdProtosJourneyData_EventWrapper_CategoryOneof_Chat",
      "OdProtosJourneyData_EventWrapper_CategoryOneof_Communication",
      "OdProtosJourneyData_EventWrapper_CategoryOneof_Experimentation",
      "OdProtosJourneyData_EventWrapper_CategoryOneof_HomeGuide",
      "OdProtosJourneyData_EventWrapper_CategoryOneof_Language",
      "OdProtosJourneyData_EventWrapper_CategoryOneof_MarketplaceProperty",
      "OdProtosJourneyData_EventWrapper_CategoryOneof_Mortgage",
      "OdProtosJourneyData_EventWrapper_CategoryOneof_Platform",
      "OdProtosJourneyData_EventWrapper_CategoryOneof_RetailWebUnlock",
      "OdProtosJourneyData_EventWrapper_CategoryOneof_Sell",
      "OdProtosJourneyData_EventWrapper_CategoryOneof_SellDirect",
      "OdProtosJourneyData_EventWrapper_CategoryOneof_SellEa",
      "OdProtosJourneyData_EventWrapper_CategoryOneof_SellFinalOfferCall",
      "OdProtosJourneyData_EventWrapper_CategoryOneof_SellList",
      "OdProtosJourneyData_EventWrapper_CategoryOneof_SellOfferReview",
      "OdProtosJourneyData_EventWrapper_CategoryOneof_SellOnboarding",
      "OdProtosJourneyData_EventWrapper_CategoryOneof_SellOrva",
      "OdProtosJourneyData_EventWrapper_CategoryOneof_SellVa",
      "OdProtosJourneyData_EventWrapper_CategoryOneof_SellWithUpside"
    ],
    "OdProtosJourneyData_EventWrapper_SourceOneof": [
      "OdProtosJourneyData_EventWrapper_SourceOneof_BackendSource",
      "OdProtosJourneyData_EventWrapper_SourceOneof_BackfillSource",
      "OdProtosJourneyData_EventWrapper_SourceOneof_EdgeSource",
      "OdProtosJourneyData_EventWrapper_SourceOneof_MobileSource",
      "OdProtosJourneyData_EventWrapper_SourceOneof_WebsiteSource"
    ],
    "OdProtosJourneyData_UserEvent_EventOneof": [
      "OdProtosJourneyData_UserEvent_EventOneof_SellDirectConversionEvent"
    ],
    "OdProtosJourneyData_UserEvent_SourceOneof": [
      "OdProtosJourneyData_UserEvent_SourceOneof_BackendSource",
      "OdProtosJourneyData_UserEvent_SourceOneof_MobileSource",
      "OdProtosJourneyData_UserEvent_SourceOneof_WebsiteSource"
    ],
    "OdProtosJourneyEvents_RichUserEvent_EventOneof": [
      "OdProtosJourneyEvents_RichUserEvent_EventOneof_Created",
      "OdProtosJourneyEvents_RichUserEvent_EventOneof_CreatedV2"
    ],
    "OdProtosJourneyEvents_UserEvent_EventOneof": [
      "OdProtosJourneyEvents_UserEvent_EventOneof_Created",
      "OdProtosJourneyEvents_UserEvent_EventOneof_CreatedV2"
    ],
    "OdProtosListerineEvents_ListerineTaskEvent_EventOneof": [
      "OdProtosListerineEvents_ListerineTaskEvent_EventOneof_D1WReportUpdate",
      "OdProtosListerineEvents_ListerineTaskEvent_EventOneof_DateEntryStateUpdate",
      "OdProtosListerineEvents_ListerineTaskEvent_EventOneof_ExternalListingStateUpdate",
      "OdProtosListerineEvents_ListerineTaskEvent_EventOneof_FlipStateUpdate",
      "OdProtosListerineEvents_ListerineTaskEvent_EventOneof_IsFrozenUpdate",
      "OdProtosListerineEvents_ListerineTaskEvent_EventOneof_PhotosReviewStateUpdate",
      "OdProtosListerineEvents_ListerineTaskEvent_EventOneof_PhotosRouteStateUpdate",
      "OdProtosListerineEvents_ListerineTaskEvent_EventOneof_PhotosStateUpdate",
      "OdProtosListerineEvents_ListerineTaskEvent_EventOneof_PriceStateUpdate",
      "OdProtosListerineEvents_ListerineTaskEvent_EventOneof_SetupVisitStateUpdate",
      "OdProtosListerineEvents_ListerineTaskEvent_EventOneof_TaskCreate",
      "OdProtosListerineEvents_ListerineTaskEvent_EventOneof_WarehouseListingStateUpdate"
    ],
    "OdProtosListerineServices_Validation_RuleOneof": [
      "OdProtosListerineServices_Validation_RuleOneof_DoesNotContainSubstring",
      "OdProtosListerineServices_Validation_RuleOneof_MaxNumericalValue",
      "OdProtosListerineServices_Validation_RuleOneof_MaxStringLength",
      "OdProtosListerineServices_Validation_RuleOneof_MinNumericalValue",
      "OdProtosListerineServices_Validation_RuleOneof_MinStringLength",
      "OdProtosListerineServices_Validation_RuleOneof_ValidFloat",
      "OdProtosListerineServices_Validation_RuleOneof_ValidInteger"
    ],
    "OdProtosListingsEvents_ListingEvent_EventOneof": [
      "OdProtosListingsEvents_ListingEvent_EventOneof_ListingPricingInputsChanged"
    ],
    "OdProtosListingsEvents_LwcProductViewEvent_EventOneof": [
      "OdProtosListingsEvents_LwcProductViewEvent_EventOneof_AgentProposed",
      "OdProtosListingsEvents_LwcProductViewEvent_EventOneof_AgentSet",
      "OdProtosListingsEvents_LwcProductViewEvent_EventOneof_AgentUnset",
      "OdProtosListingsEvents_LwcProductViewEvent_EventOneof_AloQualificationChanged",
      "OdProtosListingsEvents_LwcProductViewEvent_EventOneof_BrokerageProposed",
      "OdProtosListingsEvents_LwcProductViewEvent_EventOneof_BrokerageSet",
      "OdProtosListingsEvents_LwcProductViewEvent_EventOneof_BrokerageUnset",
      "OdProtosListingsEvents_LwcProductViewEvent_EventOneof_Created",
      "OdProtosListingsEvents_LwcProductViewEvent_EventOneof_Disqualified",
      "OdProtosListingsEvents_LwcProductViewEvent_EventOneof_ListingActive",
      "OdProtosListingsEvents_LwcProductViewEvent_EventOneof_ListingAgreementSigned",
      "OdProtosListingsEvents_LwcProductViewEvent_EventOneof_ListingInContract",
      "OdProtosListingsEvents_LwcProductViewEvent_EventOneof_ListingSold",
      "OdProtosListingsEvents_LwcProductViewEvent_EventOneof_Qualified",
      "OdProtosListingsEvents_LwcProductViewEvent_EventOneof_StateUpdated",
      "OdProtosListingsEvents_LwcProductViewEvent_EventOneof_TimestampUpdated"
    ],
    "OdProtosListingsServices_ListingDetailV2_ProductDetailOneof": [
      "OdProtosListingsServices_ListingDetailV2_ProductDetailOneof_LwcProduct",
      "OdProtosListingsServices_ListingDetailV2_ProductDetailOneof_Parn"
    ],
    "OdProtosListingsServices_ListingDetail_ProductDetailOneof": [
      "OdProtosListingsServices_ListingDetail_ProductDetailOneof_LwcProduct",
      "OdProtosListingsServices_ListingDetail_ProductDetailOneof_Parn"
    ],
    "OdProtosMdfServices_ModelRequest_ModelRequestOneof": [
      "OdProtosMdfServices_ModelRequest_ModelRequestOneof_BrnSpendRequest",
      "OdProtosMdfServices_ModelRequest_ModelRequestOneof_DaysToPendBiasRequest",
      "OdProtosMdfServices_ModelRequest_ModelRequestOneof_ForecastedSpreadDailyChangeRequest",
      "OdProtosMdfServices_ModelRequest_ModelRequestOneof_IndifferencePriceTargetModelRequest",
      "OdProtosMdfServices_ModelRequest_ModelRequestOneof_InitialMarkupFeaturesRequest",
      "OdProtosMdfServices_ModelRequest_ModelRequestOneof_MultivariatePrelistValGainAdjustmentRequest",
      "OdProtosMdfServices_ModelRequest_ModelRequestOneof_MultivariateValGainAdjustmentRequest",
      "OdProtosMdfServices_ModelRequest_ModelRequestOneof_NationwideValuationsEnsemblerRequest",
      "OdProtosMdfServices_ModelRequest_ModelRequestOneof_NegativeSelectionChargeRequest",
      "OdProtosMdfServices_ModelRequest_ModelRequestOneof_PostlistRepairSpendRequest",
      "OdProtosMdfServices_ModelRequest_ModelRequestOneof_PrelistRepairScopeRequest",
      "OdProtosMdfServices_ModelRequest_ModelRequestOneof_QuantariumDebiasedValuationRequest",
      "OdProtosMdfServices_ModelRequest_ModelRequestOneof_QuantariumEnsemblerModelRequest",
      "OdProtosMdfServices_ModelRequest_ModelRequestOneof_QuantariumValuationRequest",
      "OdProtosMdfServices_ModelRequest_ModelRequestOneof_RealtytracValuationRequest",
      "OdProtosMdfServices_ModelRequest_ModelRequestOneof_ResalePricingRecommendationsRequest",
      "OdProtosMdfServices_ModelRequest_ModelRequestOneof_ResaleProbabilityContractModelRequest",
      "OdProtosMdfServices_ModelRequest_ModelRequestOneof_ResaleTargetPriceModelRequest",
      "OdProtosMdfServices_ModelRequest_ModelRequestOneof_RestbCalibrationScoreRequest",
      "OdProtosMdfServices_ModelRequest_ModelRequestOneof_ValuationsEnsemblerRequest",
      "OdProtosMdfServices_ModelRequest_ModelRequestOneof_VendigiQuintilesRequest"
    ],
    "OdProtosMdfServices_ModelResponse_ModelResponseOneof": [
      "OdProtosMdfServices_ModelResponse_ModelResponseOneof_BrnSpendResponse",
      "OdProtosMdfServices_ModelResponse_ModelResponseOneof_DaysToPendBiasResponse",
      "OdProtosMdfServices_ModelResponse_ModelResponseOneof_Error",
      "OdProtosMdfServices_ModelResponse_ModelResponseOneof_ForecastedSpreadDailyChangeResponse",
      "OdProtosMdfServices_ModelResponse_ModelResponseOneof_IndifferencePriceTargetModelResponse",
      "OdProtosMdfServices_ModelResponse_ModelResponseOneof_InitialMarkupFeaturesResponse",
      "OdProtosMdfServices_ModelResponse_ModelResponseOneof_MultivariatePrelistValGainAdjustmentResponse",
      "OdProtosMdfServices_ModelResponse_ModelResponseOneof_MultivariateValGainAdjustmentResponse",
      "OdProtosMdfServices_ModelResponse_ModelResponseOneof_NationwideValuationsEnsemblerResponse",
      "OdProtosMdfServices_ModelResponse_ModelResponseOneof_NegativeSelectionChargeResponse",
      "OdProtosMdfServices_ModelResponse_ModelResponseOneof_PostlistRepairSpendResponse",
      "OdProtosMdfServices_ModelResponse_ModelResponseOneof_PrelistRepairScopeResponse",
      "OdProtosMdfServices_ModelResponse_ModelResponseOneof_QuantariumDebiasedValuationResponse",
      "OdProtosMdfServices_ModelResponse_ModelResponseOneof_QuantariumEnsemblerModelResponse",
      "OdProtosMdfServices_ModelResponse_ModelResponseOneof_QuantariumValuationResponse",
      "OdProtosMdfServices_ModelResponse_ModelResponseOneof_RealtytracValuationResponse",
      "OdProtosMdfServices_ModelResponse_ModelResponseOneof_ResalePricingRecommendationsResponse",
      "OdProtosMdfServices_ModelResponse_ModelResponseOneof_ResaleProbabilityContractModelResponse",
      "OdProtosMdfServices_ModelResponse_ModelResponseOneof_ResaleTargetPriceModelResponse",
      "OdProtosMdfServices_ModelResponse_ModelResponseOneof_RestbCalibrationScoreResponse",
      "OdProtosMdfServices_ModelResponse_ModelResponseOneof_ValuationsEnsemblerResponse",
      "OdProtosMdfServices_ModelResponse_ModelResponseOneof_VendigiQuintilesResponse"
    ],
    "OdProtosMerchandisingData_DataSources_InputOneof": [
      "OdProtosMerchandisingData_DataSources_InputOneof_ExcludeAll",
      "OdProtosMerchandisingData_DataSources_InputOneof_Excluded",
      "OdProtosMerchandisingData_DataSources_InputOneof_Included"
    ],
    "OdProtosMerchandisingData_Value_KindOneof": [
      "OdProtosMerchandisingData_Value_KindOneof_Bool",
      "OdProtosMerchandisingData_Value_KindOneof_Float64",
      "OdProtosMerchandisingData_Value_KindOneof_Int64",
      "OdProtosMerchandisingData_Value_KindOneof_Null",
      "OdProtosMerchandisingData_Value_KindOneof_String",
      "OdProtosMerchandisingData_Value_KindOneof_StringList",
      "OdProtosMerchandisingData_Value_KindOneof_Timestamp"
    ],
    "OdProtosMerchandisingServices_ListRuleSetVersionsRequest_InputOneof": [
      "OdProtosMerchandisingServices_ListRuleSetVersionsRequest_InputOneof_RuleSetId",
      "OdProtosMerchandisingServices_ListRuleSetVersionsRequest_InputOneof_RuleSetVersionIds"
    ],
    "OdProtosMerchandisingServices_ListRuleSetsRequest_InputOneof": [
      "OdProtosMerchandisingServices_ListRuleSetsRequest_InputOneof_Markets",
      "OdProtosMerchandisingServices_ListRuleSetsRequest_InputOneof_RuleSetIds"
    ],
    "OdProtosMl_Feature_ValueOneof": [
      "OdProtosMl_Feature_ValueOneof_FloatValue",
      "OdProtosMl_Feature_ValueOneof_IntValue",
      "OdProtosMl_Feature_ValueOneof_StrValue"
    ],
    "OdProtosMolassesData_MlsTask_UpdateRequestOneof": [
      "OdProtosMolassesData_MlsTask_UpdateRequestOneof_AddOpenHouseInfo",
      "OdProtosMolassesData_MlsTask_UpdateRequestOneof_CloseOfEscrowDateUpdate",
      "OdProtosMolassesData_MlsTask_UpdateRequestOneof_FhaEligibleUpdate",
      "OdProtosMolassesData_MlsTask_UpdateRequestOneof_ListingStatusUpdate",
      "OdProtosMolassesData_MlsTask_UpdateRequestOneof_PricingUpdate",
      "OdProtosMolassesData_MlsTask_UpdateRequestOneof_TemporarilyOffMarketStatusUpdate",
      "OdProtosMolassesData_MlsTask_UpdateRequestOneof_UploadDisclosureDocs"
    ],
    "OdProtosMolassesEvents_ListingCreationResponse_EventOneof": [
      "OdProtosMolassesEvents_ListingCreationResponse_EventOneof_ListingCreationFailure",
      "OdProtosMolassesEvents_ListingCreationResponse_EventOneof_ListingCreationSuccess"
    ],
    "OdProtosMolassesEvents_ListingUpdatesEvent_EventOneof": [
      "OdProtosMolassesEvents_ListingUpdatesEvent_EventOneof_CloseOfEscrowDateUpdated",
      "OdProtosMolassesEvents_ListingUpdatesEvent_EventOneof_FhaEligibleUpdated",
      "OdProtosMolassesEvents_ListingUpdatesEvent_EventOneof_ListingCreated",
      "OdProtosMolassesEvents_ListingUpdatesEvent_EventOneof_OpenHouseInfoAdded",
      "OdProtosMolassesEvents_ListingUpdatesEvent_EventOneof_PriceUpdated",
      "OdProtosMolassesEvents_ListingUpdatesEvent_EventOneof_TemporarilyOffMarketStatusUpdated"
    ],
    "OdProtosMolassesEvents_ListingUpdatesToMolassesEvent_EventOneof": [
      "OdProtosMolassesEvents_ListingUpdatesToMolassesEvent_EventOneof_CloseOfEscrowDateUpdated",
      "OdProtosMolassesEvents_ListingUpdatesToMolassesEvent_EventOneof_FhaEligibleUpdated",
      "OdProtosMolassesEvents_ListingUpdatesToMolassesEvent_EventOneof_ListingCreated",
      "OdProtosMolassesEvents_ListingUpdatesToMolassesEvent_EventOneof_OpenHouseInfoAdded",
      "OdProtosMolassesEvents_ListingUpdatesToMolassesEvent_EventOneof_PriceUpdated",
      "OdProtosMolassesEvents_ListingUpdatesToMolassesEvent_EventOneof_TemporarilyOffMarketStatusUpdated"
    ],
    "OdProtosNotesEvents_NoteEvent_EventOneof": [
      "OdProtosNotesEvents_NoteEvent_EventOneof_Create",
      "OdProtosNotesEvents_NoteEvent_EventOneof_Delete",
      "OdProtosNotesEvents_NoteEvent_EventOneof_Update"
    ],
    "OdProtosNotificationsData_Notification_AssociatedWithOneof": [
      "OdProtosNotificationsData_Notification_AssociatedWithOneof_AddressId",
      "OdProtosNotificationsData_Notification_AssociatedWithOneof_ProjectId",
      "OdProtosNotificationsData_Notification_AssociatedWithOneof_VisitId",
      "OdProtosNotificationsData_Notification_AssociatedWithOneof_WorkOrderId"
    ],
    "OdProtosNotificationsServices_CreateNotificationRequest_AssociatedWithOneof": [
      "OdProtosNotificationsServices_CreateNotificationRequest_AssociatedWithOneof_AddressId",
      "OdProtosNotificationsServices_CreateNotificationRequest_AssociatedWithOneof_ProjectId",
      "OdProtosNotificationsServices_CreateNotificationRequest_AssociatedWithOneof_VisitId",
      "OdProtosNotificationsServices_CreateNotificationRequest_AssociatedWithOneof_WorkOrderId"
    ],
    "OdProtosOperatorData_Filter_OperatorFilterOneof": [
      "OdProtosOperatorData_Filter_OperatorFilterOneof_ManagerToken",
      "OdProtosOperatorData_Filter_OperatorFilterOneof_OperatorTokens"
    ],
    "OdProtosOperatorEvents_OperatorEvent_EventOneof": [
      "OdProtosOperatorEvents_OperatorEvent_EventOneof_Created",
      "OdProtosOperatorEvents_OperatorEvent_EventOneof_Deactivated",
      "OdProtosOperatorEvents_OperatorEvent_EventOneof_Deleted",
      "OdProtosOperatorEvents_OperatorEvent_EventOneof_Updated"
    ],
    "OdProtosOperatorEvents_OperatorOfftimeEvent_EventOneof": [
      "OdProtosOperatorEvents_OperatorOfftimeEvent_EventOneof_Created",
      "OdProtosOperatorEvents_OperatorOfftimeEvent_EventOneof_Deleted"
    ],
    "OdProtosOperatorServices_RefreshOperatorDataRequest_OperatorFilterOneof": [
      "OdProtosOperatorServices_RefreshOperatorDataRequest_OperatorFilterOneof_OperatorEmails",
      "OdProtosOperatorServices_RefreshOperatorDataRequest_OperatorFilterOneof_OperatorTokens"
    ],
    "OdProtosOperatorServices_WorkAssignmentConfigFilter_OperatorFilterOneof": [
      "OdProtosOperatorServices_WorkAssignmentConfigFilter_OperatorFilterOneof_HumanTokens",
      "OdProtosOperatorServices_WorkAssignmentConfigFilter_OperatorFilterOneof_ManagerToken"
    ],
    "OdProtosOstiaryServices_CheckRiskProhibitedRegionResponse_ResponseOneof": [
      "OdProtosOstiaryServices_CheckRiskProhibitedRegionResponse_ResponseOneof_Error",
      "OdProtosOstiaryServices_CheckRiskProhibitedRegionResponse_ResponseOneof_Success"
    ],
    "OdProtosOutreachServices_RecordOutreachOutcomeRequest_OutcomeTypeOneof": [
      "OdProtosOutreachServices_RecordOutreachOutcomeRequest_OutcomeTypeOneof_OrvaSchedulingOutcomeType"
    ],
    "OdProtosOxOxCommsData_Communication_InteractionOneof": [
      "OdProtosOxOxCommsData_Communication_InteractionOneof_PhoneCall",
      "OdProtosOxOxCommsData_Communication_InteractionOneof_SmsMessage"
    ],
    "OdProtosPartnershipEvents_LoyaltyEventEvent_EventOneof": [
      "OdProtosPartnershipEvents_LoyaltyEventEvent_EventOneof_Created",
      "OdProtosPartnershipEvents_LoyaltyEventEvent_EventOneof_Deleted",
      "OdProtosPartnershipEvents_LoyaltyEventEvent_EventOneof_Recalculated",
      "OdProtosPartnershipEvents_LoyaltyEventEvent_EventOneof_Updated"
    ],
    "OdProtosPartnershipEvents_ReferralELAEvent_EventOneof": [
      "OdProtosPartnershipEvents_ReferralELAEvent_EventOneof_Passback",
      "OdProtosPartnershipEvents_ReferralELAEvent_EventOneof_Takeback"
    ],
    "OdProtosPartnershipEvents_ReferralEvent_EventOneof": [
      "OdProtosPartnershipEvents_ReferralEvent_EventOneof_Created",
      "OdProtosPartnershipEvents_ReferralEvent_EventOneof_Deleted",
      "OdProtosPartnershipEvents_ReferralEvent_EventOneof_HandoverOccurred",
      "OdProtosPartnershipEvents_ReferralEvent_EventOneof_Updated"
    ],
    "OdProtosPartnershipEvents_ReferralPaymentEvent_EventOneof": [
      "OdProtosPartnershipEvents_ReferralPaymentEvent_EventOneof_Updated"
    ],
    "OdProtosPartnershipEvents_SellerInputEvent_EventOneof": [
      "OdProtosPartnershipEvents_SellerInputEvent_EventOneof_CreatedLead",
      "OdProtosPartnershipEvents_SellerInputEvent_EventOneof_UpdatedQualifiedLead"
    ],
    "OdProtosPartnershipServices_CreateSellRequestResponse_DataOneof": [
      "OdProtosPartnershipServices_CreateSellRequestResponse_DataOneof_DenialReason",
      "OdProtosPartnershipServices_CreateSellRequestResponse_DataOneof_SellRequestError",
      "OdProtosPartnershipServices_CreateSellRequestResponse_DataOneof_SellerInputId"
    ],
    "OdProtosPartnershipServices_CreateSellerInputResponse_DataOneof": [
      "OdProtosPartnershipServices_CreateSellerInputResponse_DataOneof_DenialReason",
      "OdProtosPartnershipServices_CreateSellerInputResponse_DataOneof_SellerInputError",
      "OdProtosPartnershipServices_CreateSellerInputResponse_DataOneof_SellerInputId"
    ],
    "OdProtosPartnershipServices_GetOutboundBuyerReferralsRequest_InputOneof": [
      "OdProtosPartnershipServices_GetOutboundBuyerReferralsRequest_InputOneof_PartnerIdentifier",
      "OdProtosPartnershipServices_GetOutboundBuyerReferralsRequest_InputOneof_SalesRepresentativeId"
    ],
    "OdProtosPartnershipServices_GetReferralLinkRequest_UserDataOneof": [
      "OdProtosPartnershipServices_GetReferralLinkRequest_UserDataOneof_Slug",
      "OdProtosPartnershipServices_GetReferralLinkRequest_UserDataOneof_UserEmail",
      "OdProtosPartnershipServices_GetReferralLinkRequest_UserDataOneof_UserToken"
    ],
    "OdProtosPartnershipServices_UpdateReferralUserForSellerInputRequest_UserDataOneof": [
      "OdProtosPartnershipServices_UpdateReferralUserForSellerInputRequest_UserDataOneof_UserEmail",
      "OdProtosPartnershipServices_UpdateReferralUserForSellerInputRequest_UserDataOneof_UserId"
    ],
    "OdProtosPbdbData_Expr_TypeOneof": [
      "OdProtosPbdbData_Expr_TypeOneof_Function",
      "OdProtosPbdbData_Expr_TypeOneof_Identifier",
      "OdProtosPbdbData_Expr_TypeOneof_Value"
    ],
    "OdProtosPbdbData_Expr_Value_TypeOneof": [
      "OdProtosPbdbData_Expr_Value_TypeOneof_Bool",
      "OdProtosPbdbData_Expr_Value_TypeOneof_Bytes",
      "OdProtosPbdbData_Expr_Value_TypeOneof_Double",
      "OdProtosPbdbData_Expr_Value_TypeOneof_Duration",
      "OdProtosPbdbData_Expr_Value_TypeOneof_Float",
      "OdProtosPbdbData_Expr_Value_TypeOneof_Int32",
      "OdProtosPbdbData_Expr_Value_TypeOneof_Int64",
      "OdProtosPbdbData_Expr_Value_TypeOneof_String",
      "OdProtosPbdbData_Expr_Value_TypeOneof_Timestamp",
      "OdProtosPbdbData_Expr_Value_TypeOneof_Uint32",
      "OdProtosPbdbData_Expr_Value_TypeOneof_Uint64"
    ],
    "OdProtosPictionaryBracketeerData_Edit_SpecOneof": [
      "OdProtosPictionaryBracketeerData_Edit_SpecOneof_BracketingSpec"
    ],
    "OdProtosPictionaryData_Operation_DetailOneof": [
      "OdProtosPictionaryData_Operation_DetailOneof_BracketeerJob"
    ],
    "OdProtosPictionaryEvents_EditJob_EventOneof": [
      "OdProtosPictionaryEvents_EditJob_EventOneof_EditJobCreated",
      "OdProtosPictionaryEvents_EditJob_EventOneof_EditJobEnded",
      "OdProtosPictionaryEvents_EditJob_EventOneof_EditJobFailed",
      "OdProtosPictionaryEvents_EditJob_EventOneof_EditJobStarted"
    ],
    "OdProtosPictionaryEvents_GDrive_EventOneof": [
      "OdProtosPictionaryEvents_GDrive_EventOneof_AssetAdded",
      "OdProtosPictionaryEvents_GDrive_EventOneof_DropFolderCreated",
      "OdProtosPictionaryEvents_GDrive_EventOneof_DropFolderDeleted",
      "OdProtosPictionaryEvents_GDrive_EventOneof_InvalidFileReceived",
      "OdProtosPictionaryEvents_GDrive_EventOneof_NewFileIncoming"
    ],
    "OdProtosPictionaryEvents_Portfolio_EventOneof": [
      "OdProtosPictionaryEvents_Portfolio_EventOneof_AlbumReady"
    ],
    "OdProtosPictionaryServices_GetDropFolderReq_IdentifierOneof": [
      "OdProtosPictionaryServices_GetDropFolderReq_IdentifierOneof_AddressUuid",
      "OdProtosPictionaryServices_GetDropFolderReq_IdentifierOneof_DropFolderId",
      "OdProtosPictionaryServices_GetDropFolderReq_IdentifierOneof_FlipToken",
      "OdProtosPictionaryServices_GetDropFolderReq_IdentifierOneof_ListingUuid",
      "OdProtosPictionaryServices_GetDropFolderReq_IdentifierOneof_Subject"
    ],
    "OdProtosPictionaryServices_GetWorkshopReq_IdentifierOneof": [
      "OdProtosPictionaryServices_GetWorkshopReq_IdentifierOneof_AddressUuid",
      "OdProtosPictionaryServices_GetWorkshopReq_IdentifierOneof_FlipToken",
      "OdProtosPictionaryServices_GetWorkshopReq_IdentifierOneof_ListingUuid",
      "OdProtosPictionaryServices_GetWorkshopReq_IdentifierOneof_WorkshopId"
    ],
    "OdProtosPictionaryServices_SetDropFolderMetaReq_IdentifierOneof": [
      "OdProtosPictionaryServices_SetDropFolderMetaReq_IdentifierOneof_Id",
      "OdProtosPictionaryServices_SetDropFolderMetaReq_IdentifierOneof_Subject"
    ],
    "OdProtosPricingDataPropertyEngagements_AcquisitionDataLabeling_EventExtensions_Domain_TypeOneof": [
      "OdProtosPricingDataPropertyEngagements_AcquisitionDataLabeling_EventExtensions_Domain_TypeOneof_Completed"
    ],
    "OdProtosPricingDataPropertyEngagements_AcquisitionRepairBudgetReview_EventExtensions_Domain_Completed_WalkProposalStatusOneof": [
      "OdProtosPricingDataPropertyEngagements_AcquisitionRepairBudgetReview_EventExtensions_Domain_Completed_WalkProposalStatusOneof_NoWalkProposed",
      "OdProtosPricingDataPropertyEngagements_AcquisitionRepairBudgetReview_EventExtensions_Domain_Completed_WalkProposalStatusOneof_WalkProposed"
    ],
    "OdProtosPricingDataPropertyEngagements_AcquisitionRepairBudgetReview_EventExtensions_Domain_TypeOneof": [
      "OdProtosPricingDataPropertyEngagements_AcquisitionRepairBudgetReview_EventExtensions_Domain_TypeOneof_Canceled",
      "OdProtosPricingDataPropertyEngagements_AcquisitionRepairBudgetReview_EventExtensions_Domain_TypeOneof_Completed"
    ],
    "OdProtosPricingDataPropertyEngagements_AcquisitionRiskAssessment_EventExtensions_Domain_Completed_WalkResultOneof": [
      "OdProtosPricingDataPropertyEngagements_AcquisitionRiskAssessment_EventExtensions_Domain_Completed_WalkResultOneof_NoWalkProposed",
      "OdProtosPricingDataPropertyEngagements_AcquisitionRiskAssessment_EventExtensions_Domain_Completed_WalkResultOneof_ShouldWalk"
    ],
    "OdProtosPricingDataPropertyEngagements_AcquisitionRiskAssessment_EventExtensions_Domain_ManualCompleted_ResultOneof": [
      "OdProtosPricingDataPropertyEngagements_AcquisitionRiskAssessment_EventExtensions_Domain_ManualCompleted_ResultOneof_EscalatedToManager",
      "OdProtosPricingDataPropertyEngagements_AcquisitionRiskAssessment_EventExtensions_Domain_ManualCompleted_ResultOneof_NotEscalated"
    ],
    "OdProtosPricingDataPropertyEngagements_AcquisitionRiskAssessment_EventExtensions_Domain_TypeOneof": [
      "OdProtosPricingDataPropertyEngagements_AcquisitionRiskAssessment_EventExtensions_Domain_TypeOneof_Completed",
      "OdProtosPricingDataPropertyEngagements_AcquisitionRiskAssessment_EventExtensions_Domain_TypeOneof_ManualCompleted",
      "OdProtosPricingDataPropertyEngagements_AcquisitionRiskAssessment_EventExtensions_Domain_TypeOneof_ManualRequired",
      "OdProtosPricingDataPropertyEngagements_AcquisitionRiskAssessment_EventExtensions_Domain_TypeOneof_Reused",
      "OdProtosPricingDataPropertyEngagements_AcquisitionRiskAssessment_EventExtensions_Domain_TypeOneof_Skipped"
    ],
    "OdProtosPricingDataPropertyEngagements_AcquisitionUnderwriting_EventExtensions_Domain_Completed_Error_KindOneof": [
      "OdProtosPricingDataPropertyEngagements_AcquisitionUnderwriting_EventExtensions_Domain_Completed_Error_KindOneof_PreconditionFailed",
      "OdProtosPricingDataPropertyEngagements_AcquisitionUnderwriting_EventExtensions_Domain_Completed_Error_KindOneof_Unknown"
    ],
    "OdProtosPricingDataPropertyEngagements_AcquisitionUnderwriting_EventExtensions_Domain_Completed_ResultOneof": [
      "OdProtosPricingDataPropertyEngagements_AcquisitionUnderwriting_EventExtensions_Domain_Completed_ResultOneof_Error",
      "OdProtosPricingDataPropertyEngagements_AcquisitionUnderwriting_EventExtensions_Domain_Completed_ResultOneof_Success"
    ],
    "OdProtosPricingDataPropertyEngagements_AcquisitionUnderwriting_EventExtensions_Domain_Completed_Success_OutcomeOneof": [
      "OdProtosPricingDataPropertyEngagements_AcquisitionUnderwriting_EventExtensions_Domain_Completed_Success_OutcomeOneof_Proceed",
      "OdProtosPricingDataPropertyEngagements_AcquisitionUnderwriting_EventExtensions_Domain_Completed_Success_OutcomeOneof_Walked"
    ],
    "OdProtosPricingDataPropertyEngagements_AcquisitionUnderwriting_EventExtensions_Domain_TypeOneof": [
      "OdProtosPricingDataPropertyEngagements_AcquisitionUnderwriting_EventExtensions_Domain_TypeOneof_Completed"
    ],
    "OdProtosPricingDataPropertyEngagements_AcquisitionValuation_EventExtensions_Domain_Completed_WalkProposalStatusOneof": [
      "OdProtosPricingDataPropertyEngagements_AcquisitionValuation_EventExtensions_Domain_Completed_WalkProposalStatusOneof_NoWalkProposed",
      "OdProtosPricingDataPropertyEngagements_AcquisitionValuation_EventExtensions_Domain_Completed_WalkProposalStatusOneof_WalkProposed"
    ],
    "OdProtosPricingDataPropertyEngagements_AcquisitionValuation_EventExtensions_Domain_TypeOneof": [
      "OdProtosPricingDataPropertyEngagements_AcquisitionValuation_EventExtensions_Domain_TypeOneof_Canceled",
      "OdProtosPricingDataPropertyEngagements_AcquisitionValuation_EventExtensions_Domain_TypeOneof_Completed"
    ],
    "OdProtosPricingDataPropertyEngagements_SellWithUpsidePricing_EventExtensions_Domain_Completed_Error_KindOneof": [
      "OdProtosPricingDataPropertyEngagements_SellWithUpsidePricing_EventExtensions_Domain_Completed_Error_KindOneof_Unknown"
    ],
    "OdProtosPricingDataPropertyEngagements_SellWithUpsidePricing_EventExtensions_Domain_Completed_ResultOneof": [
      "OdProtosPricingDataPropertyEngagements_SellWithUpsidePricing_EventExtensions_Domain_Completed_ResultOneof_Error",
      "OdProtosPricingDataPropertyEngagements_SellWithUpsidePricing_EventExtensions_Domain_Completed_ResultOneof_Success"
    ],
    "OdProtosPricingDataPropertyEngagements_SellWithUpsidePricing_EventExtensions_Domain_TypeOneof": [
      "OdProtosPricingDataPropertyEngagements_SellWithUpsidePricing_EventExtensions_Domain_TypeOneof_Completed",
      "OdProtosPricingDataPropertyEngagements_SellWithUpsidePricing_EventExtensions_Domain_TypeOneof_DerivedPricing"
    ],
    "OdProtosPricingData_MockAcquisitionUnderwriting_MockDataLabeling_ConfigOneof": [
      "OdProtosPricingData_MockAcquisitionUnderwriting_MockDataLabeling_ConfigOneof_HappyPath"
    ],
    "OdProtosPricingData_MockAcquisitionUnderwriting_MockPricingDecision_ConfigOneof": [
      "OdProtosPricingData_MockAcquisitionUnderwriting_MockPricingDecision_ConfigOneof_HappyPath",
      "OdProtosPricingData_MockAcquisitionUnderwriting_MockPricingDecision_ConfigOneof_Walk"
    ],
    "OdProtosPricingData_MockAcquisitionUnderwriting_MockRepairBudgetReview_ConfigOneof": [
      "OdProtosPricingData_MockAcquisitionUnderwriting_MockRepairBudgetReview_ConfigOneof_HappyPath",
      "OdProtosPricingData_MockAcquisitionUnderwriting_MockRepairBudgetReview_ConfigOneof_ProposeWalk"
    ],
    "OdProtosPricingData_MockAcquisitionUnderwriting_MockRiskAssessment_ConfigOneof": [
      "OdProtosPricingData_MockAcquisitionUnderwriting_MockRiskAssessment_ConfigOneof_HappyPath",
      "OdProtosPricingData_MockAcquisitionUnderwriting_MockRiskAssessment_ConfigOneof_ProposeWalk",
      "OdProtosPricingData_MockAcquisitionUnderwriting_MockRiskAssessment_ConfigOneof_SkipRiskAssessment"
    ],
    "OdProtosPricingData_MockAcquisitionUnderwriting_MockValuation_ConfigOneof": [
      "OdProtosPricingData_MockAcquisitionUnderwriting_MockValuation_ConfigOneof_HappyPath",
      "OdProtosPricingData_MockAcquisitionUnderwriting_MockValuation_ConfigOneof_ProposeWalk"
    ],
    "OdProtosPricingsData_AgentGuaranteedFixedCommission_ValueOneof": [
      "OdProtosPricingsData_AgentGuaranteedFixedCommission_ValueOneof_FixedAmount",
      "OdProtosPricingsData_AgentGuaranteedFixedCommission_ValueOneof_PctOfUserExpectedResale"
    ],
    "OdProtosPricingsData_Modification_KindOneof": [
      "OdProtosPricingsData_Modification_KindOneof_AgentFixedCommission",
      "OdProtosPricingsData_Modification_KindOneof_AgentProjectedSalesPrice",
      "OdProtosPricingsData_Modification_KindOneof_AgentVariableCommission",
      "OdProtosPricingsData_Modification_KindOneof_BuyerAgentCommission",
      "OdProtosPricingsData_Modification_KindOneof_PrelistRepairsSubsidy",
      "OdProtosPricingsData_Modification_KindOneof_SalesPriceSubsidy",
      "OdProtosPricingsData_Modification_KindOneof_SellerAgentCommission",
      "OdProtosPricingsData_Modification_KindOneof_SellerDesiredAdvance",
      "OdProtosPricingsData_Modification_KindOneof_SellerProjectedSalesPrice"
    ],
    "OdProtosPricingsData_Mutation_OperationOneof": [
      "OdProtosPricingsData_Mutation_OperationOneof_Add",
      "OdProtosPricingsData_Mutation_OperationOneof_Remove",
      "OdProtosPricingsData_Mutation_OperationOneof_Update",
      "OdProtosPricingsData_Mutation_OperationOneof_UpdateUnderwriting",
      "OdProtosPricingsData_Mutation_OperationOneof_Upsert"
    ],
    "OdProtosPricingsData_PricingExpanded_KindOneof": [
      "OdProtosPricingsData_PricingExpanded_KindOneof_ListWithOpendoor",
      "OdProtosPricingsData_PricingExpanded_KindOneof_SellDirect",
      "OdProtosPricingsData_PricingExpanded_KindOneof_SellWithUpside"
    ],
    "OdProtosPricingsData_Pricing_KindOneof": [
      "OdProtosPricingsData_Pricing_KindOneof_ListWithOpendoor",
      "OdProtosPricingsData_Pricing_KindOneof_SellDirect",
      "OdProtosPricingsData_Pricing_KindOneof_SellWithUpside"
    ],
    "OdProtosPricingsData_SellDirectPricingPresentation_TypeOneof": [
      "OdProtosPricingsData_SellDirectPricingPresentation_TypeOneof_Agent",
      "OdProtosPricingsData_SellDirectPricingPresentation_TypeOneof_DirectToConsumer",
      "OdProtosPricingsData_SellDirectPricingPresentation_TypeOneof_LennarPilot",
      "OdProtosPricingsData_SellDirectPricingPresentation_TypeOneof_OnlineRealEstate",
      "OdProtosPricingsData_SellDirectPricingPresentation_TypeOneof_Outbounds"
    ],
    "OdProtosPricingsEvents_AddendumEvent_EventOneof": [
      "OdProtosPricingsEvents_AddendumEvent_EventOneof_DueDiligenceReviewDecisionMade"
    ],
    "OdProtosPricingsServicesPricingsGraphql_SubmitPostDiligenceVisitPricingUpdateRequest_OperatorDecisionOneof": [
      "OdProtosPricingsServicesPricingsGraphql_SubmitPostDiligenceVisitPricingUpdateRequest_OperatorDecisionOneof_Addendum",
      "OdProtosPricingsServicesPricingsGraphql_SubmitPostDiligenceVisitPricingUpdateRequest_OperatorDecisionOneof_Proceed",
      "OdProtosPricingsServicesPricingsGraphql_SubmitPostDiligenceVisitPricingUpdateRequest_OperatorDecisionOneof_Withdraw"
    ],
    "OdProtosPricingsServicesPricings_AddCXSubsidyResponse_ResponseOneof": [
      "OdProtosPricingsServicesPricings_AddCXSubsidyResponse_ResponseOneof_Error",
      "OdProtosPricingsServicesPricings_AddCXSubsidyResponse_ResponseOneof_Success"
    ],
    "OdProtosPricingsServicesPricings_CreateListWithOpendoorPricingRequest_EconomicsOneof": [
      "OdProtosPricingsServicesPricings_CreateListWithOpendoorPricingRequest_EconomicsOneof_RawEconomics",
      "OdProtosPricingsServicesPricings_CreateListWithOpendoorPricingRequest_EconomicsOneof_UnderwritingId"
    ],
    "OdProtosPricingsServicesPricings_CreateListWithOpendoorPricingResponse_ResponseOneof": [
      "OdProtosPricingsServicesPricings_CreateListWithOpendoorPricingResponse_ResponseOneof_Error",
      "OdProtosPricingsServicesPricings_CreateListWithOpendoorPricingResponse_ResponseOneof_Success"
    ],
    "OdProtosPricingsServicesPricings_CreateSellDirectPricingResponse_ResponseOneof": [
      "OdProtosPricingsServicesPricings_CreateSellDirectPricingResponse_ResponseOneof_Error",
      "OdProtosPricingsServicesPricings_CreateSellDirectPricingResponse_ResponseOneof_Success"
    ],
    "OdProtosPricingsServicesPricings_CreateSellWithUpsidePricingRequest_AgentRelationshipOneof": [
      "OdProtosPricingsServicesPricings_CreateSellWithUpsidePricingRequest_AgentRelationshipOneof_AgentReferralPartnerId",
      "OdProtosPricingsServicesPricings_CreateSellWithUpsidePricingRequest_AgentRelationshipOneof_BrokerageId"
    ],
    "OdProtosPricingsServicesPricings_CreateSellWithUpsidePricingResponse_ResponseOneof": [
      "OdProtosPricingsServicesPricings_CreateSellWithUpsidePricingResponse_ResponseOneof_Error",
      "OdProtosPricingsServicesPricings_CreateSellWithUpsidePricingResponse_ResponseOneof_Success"
    ],
    "OdProtosPricingsServicesPricings_DeriveNewPricingResponse_ResponseOneof": [
      "OdProtosPricingsServicesPricings_DeriveNewPricingResponse_ResponseOneof_Error",
      "OdProtosPricingsServicesPricings_DeriveNewPricingResponse_ResponseOneof_Success"
    ],
    "OdProtosPricingsServicesPricings_ExplainPricingResponse_ResponseOneof": [
      "OdProtosPricingsServicesPricings_ExplainPricingResponse_ResponseOneof_Error",
      "OdProtosPricingsServicesPricings_ExplainPricingResponse_ResponseOneof_Success"
    ],
    "OdProtosPricingsServicesPricings_GetPricingResponse_ResponseOneof": [
      "OdProtosPricingsServicesPricings_GetPricingResponse_ResponseOneof_Error",
      "OdProtosPricingsServicesPricings_GetPricingResponse_ResponseOneof_Success"
    ],
    "OdProtosPricingsServicesPricings_GetUnitEconomicsResponse_ResponseOneof": [
      "OdProtosPricingsServicesPricings_GetUnitEconomicsResponse_ResponseOneof_Error",
      "OdProtosPricingsServicesPricings_GetUnitEconomicsResponse_ResponseOneof_Success"
    ],
    "OdProtosPricingsServicesPricings_SubmitPostDiligenceVisitRepairScopeUpdateResponse_ResponseOneof": [
      "OdProtosPricingsServicesPricings_SubmitPostDiligenceVisitRepairScopeUpdateResponse_ResponseOneof_Error",
      "OdProtosPricingsServicesPricings_SubmitPostDiligenceVisitRepairScopeUpdateResponse_ResponseOneof_Success"
    ],
    "OdProtosPropertyDataStoreEvents_PropertyEvent_EventOneof": [
      "OdProtosPropertyDataStoreEvents_PropertyEvent_EventOneof_PropertyWrite"
    ],
    "OdProtosPropertyLifecycleDataPropertyEngagements_BwodLead_EventExtensions_Domain_TypeOneof": [
      "OdProtosPropertyLifecycleDataPropertyEngagements_BwodLead_EventExtensions_Domain_TypeOneof_Offered"
    ],
    "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Create_TypeOneof": [
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Create_TypeOneof_AcquisitionDataLabeling",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Create_TypeOneof_AcquisitionRepairBudgetReview",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Create_TypeOneof_AcquisitionRiskAssessment",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Create_TypeOneof_AcquisitionUnderwriting",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Create_TypeOneof_AcquisitionValuation",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Create_TypeOneof_Assessment",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Create_TypeOneof_BuyerRepairNegotiation",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Create_TypeOneof_BwodLead",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Create_TypeOneof_DebtFinancing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Create_TypeOneof_DigitalCheckout",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Create_TypeOneof_DirectLead",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Create_TypeOneof_DirectOffer",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Create_TypeOneof_ExclusiveListing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Create_TypeOneof_ExternalListing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Create_TypeOneof_HomeAccessMonitoring",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Create_TypeOneof_Inventory",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Create_TypeOneof_InventoryListing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Create_TypeOneof_InventoryMaintenance",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Create_TypeOneof_InventoryReno",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Create_TypeOneof_LenderRequiredRepairs",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Create_TypeOneof_MaintenanceSchedule",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Create_TypeOneof_OboBuyerOffer",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Create_TypeOneof_OboBwodOffer",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Create_TypeOneof_ReitReno",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Create_TypeOneof_RenoPrep",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Create_TypeOneof_RenoProjectExecution",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Create_TypeOneof_RenoRepairScoping",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Create_TypeOneof_ResaleBuyDirect",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Create_TypeOneof_ResaleBuyerOffer",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Create_TypeOneof_ResaleInventory",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Create_TypeOneof_ResaleListing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Create_TypeOneof_SellWithUpsidePricing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Create_TypeOneof_ThirdPartyMarketplaceListing"
    ],
    "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Domain_TypeOneof": [
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Domain_TypeOneof_Assessment",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Domain_TypeOneof_BuyerRepairNegotiation",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Domain_TypeOneof_BwodLead",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Domain_TypeOneof_DebtFinancing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Domain_TypeOneof_DigitalCheckout",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Domain_TypeOneof_DirectLead",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Domain_TypeOneof_DirectOffer",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Domain_TypeOneof_ExclusiveListing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Domain_TypeOneof_ExternalListing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Domain_TypeOneof_HomeAccessMonitoring",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Domain_TypeOneof_Inventory",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Domain_TypeOneof_InventoryListing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Domain_TypeOneof_InventoryMaintenance",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Domain_TypeOneof_InventoryReno",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Domain_TypeOneof_LenderRequiredRepairs",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Domain_TypeOneof_MaintenanceSchedule",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Domain_TypeOneof_OboBuyerOffer",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Domain_TypeOneof_OboBwodOffer",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Domain_TypeOneof_ReitReno",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Domain_TypeOneof_RenoPrep",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Domain_TypeOneof_RenoProjectExecution",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Domain_TypeOneof_RenoRepairScoping",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Domain_TypeOneof_ResaleBuyerOffer",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Domain_TypeOneof_ResaleListing"
    ],
    "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Stop_TypeOneof": [
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Stop_TypeOneof_AcquisitionDataLabeling",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Stop_TypeOneof_AcquisitionRepairBudgetReview",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Stop_TypeOneof_AcquisitionRiskAssessment",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Stop_TypeOneof_AcquisitionUnderwriting",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Stop_TypeOneof_AcquisitionValuation",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Stop_TypeOneof_Assessment",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Stop_TypeOneof_BuyerRepairNegotiation",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Stop_TypeOneof_BwodLead",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Stop_TypeOneof_DebtFinancing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Stop_TypeOneof_DigitalCheckout",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Stop_TypeOneof_DirectLead",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Stop_TypeOneof_DirectOffer",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Stop_TypeOneof_ExclusiveListing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Stop_TypeOneof_ExternalListing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Stop_TypeOneof_HomeAccessMonitoring",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Stop_TypeOneof_Inventory",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Stop_TypeOneof_InventoryListing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Stop_TypeOneof_InventoryMaintenance",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Stop_TypeOneof_InventoryReno",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Stop_TypeOneof_LenderRequiredRepairs",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Stop_TypeOneof_MaintenanceSchedule",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Stop_TypeOneof_OboBuyerOffer",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Stop_TypeOneof_OboBwodOffer",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Stop_TypeOneof_ReitReno",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Stop_TypeOneof_RenoPrep",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Stop_TypeOneof_RenoProjectExecution",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Stop_TypeOneof_RenoRepairScoping",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Stop_TypeOneof_ResaleBuyDirect",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Stop_TypeOneof_ResaleBuyerOffer",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Stop_TypeOneof_ResaleInventory",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Stop_TypeOneof_ResaleListing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Stop_TypeOneof_SellWithUpsidePricing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Stop_TypeOneof_ThirdPartyMarketplaceListing"
    ],
    "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Wake_TypeOneof": [
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Wake_TypeOneof_AcquisitionDataLabeling",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Wake_TypeOneof_AcquisitionRepairBudgetReview",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Wake_TypeOneof_AcquisitionRiskAssessment",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Wake_TypeOneof_AcquisitionUnderwriting",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Wake_TypeOneof_AcquisitionValuation",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Wake_TypeOneof_Assessment",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Wake_TypeOneof_BuyerRepairNegotiation",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Wake_TypeOneof_BwodLead",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Wake_TypeOneof_DebtFinancing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Wake_TypeOneof_DigitalCheckout",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Wake_TypeOneof_DirectLead",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Wake_TypeOneof_DirectOffer",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Wake_TypeOneof_ExclusiveListing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Wake_TypeOneof_ExternalListing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Wake_TypeOneof_HomeAccessMonitoring",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Wake_TypeOneof_Inventory",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Wake_TypeOneof_InventoryListing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Wake_TypeOneof_InventoryMaintenance",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Wake_TypeOneof_InventoryReno",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Wake_TypeOneof_LenderRequiredRepairs",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Wake_TypeOneof_MaintenanceSchedule",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Wake_TypeOneof_OboBuyerOffer",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Wake_TypeOneof_OboBwodOffer",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Wake_TypeOneof_ReitReno",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Wake_TypeOneof_RenoPrep",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Wake_TypeOneof_RenoProjectExecution",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Wake_TypeOneof_RenoRepairScoping",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Wake_TypeOneof_ResaleBuyerOffer",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Wake_TypeOneof_ResaleInventory",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Wake_TypeOneof_ResaleListing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Wake_TypeOneof_SellWithUpsidePricing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_CommandExtensions_Wake_TypeOneof_ThirdPartyMarketplaceListing"
    ],
    "OdProtosPropertyLifecycleDataPropertyEngagements_DebtFinancing_EventExtensions_Domain_EventOneof": [
      "OdProtosPropertyLifecycleDataPropertyEngagements_DebtFinancing_EventExtensions_Domain_EventOneof_Bar",
      "OdProtosPropertyLifecycleDataPropertyEngagements_DebtFinancing_EventExtensions_Domain_EventOneof_Foo"
    ],
    "OdProtosPropertyLifecycleDataPropertyEngagements_DirectLead_EventExtensions_Domain_TypeOneof": [
      "OdProtosPropertyLifecycleDataPropertyEngagements_DirectLead_EventExtensions_Domain_TypeOneof_Denied",
      "OdProtosPropertyLifecycleDataPropertyEngagements_DirectLead_EventExtensions_Domain_TypeOneof_PrelimOfferSent",
      "OdProtosPropertyLifecycleDataPropertyEngagements_DirectLead_EventExtensions_Domain_TypeOneof_Qualified"
    ],
    "OdProtosPropertyLifecycleDataPropertyEngagements_DirectOffer_EventExtensions_Domain_TypeOneof": [
      "OdProtosPropertyLifecycleDataPropertyEngagements_DirectOffer_EventExtensions_Domain_TypeOneof_Closed",
      "OdProtosPropertyLifecycleDataPropertyEngagements_DirectOffer_EventExtensions_Domain_TypeOneof_CoeChanged",
      "OdProtosPropertyLifecycleDataPropertyEngagements_DirectOffer_EventExtensions_Domain_TypeOneof_CustomerWithdrawn",
      "OdProtosPropertyLifecycleDataPropertyEngagements_DirectOffer_EventExtensions_Domain_TypeOneof_EnteredContract",
      "OdProtosPropertyLifecycleDataPropertyEngagements_DirectOffer_EventExtensions_Domain_TypeOneof_ExpirationChanged",
      "OdProtosPropertyLifecycleDataPropertyEngagements_DirectOffer_EventExtensions_Domain_TypeOneof_Expired",
      "OdProtosPropertyLifecycleDataPropertyEngagements_DirectOffer_EventExtensions_Domain_TypeOneof_FinalOfferSent",
      "OdProtosPropertyLifecycleDataPropertyEngagements_DirectOffer_EventExtensions_Domain_TypeOneof_FinalOfferViewed",
      "OdProtosPropertyLifecycleDataPropertyEngagements_DirectOffer_EventExtensions_Domain_TypeOneof_LateCheckout",
      "OdProtosPropertyLifecycleDataPropertyEngagements_DirectOffer_EventExtensions_Domain_TypeOneof_LateCheckoutDateChanged",
      "OdProtosPropertyLifecycleDataPropertyEngagements_DirectOffer_EventExtensions_Domain_TypeOneof_OpendoorWithdrawn",
      "OdProtosPropertyLifecycleDataPropertyEngagements_DirectOffer_EventExtensions_Domain_TypeOneof_PrelimOfferSent",
      "OdProtosPropertyLifecycleDataPropertyEngagements_DirectOffer_EventExtensions_Domain_TypeOneof_ReleasedContingencies",
      "OdProtosPropertyLifecycleDataPropertyEngagements_DirectOffer_EventExtensions_Domain_TypeOneof_Withdrawn"
    ],
    "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Domain_TypeOneof": [
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Domain_TypeOneof_AcquisitionDataLabeling",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Domain_TypeOneof_AcquisitionRepairBudgetReview",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Domain_TypeOneof_AcquisitionRiskAssessment",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Domain_TypeOneof_AcquisitionUnderwriting",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Domain_TypeOneof_AcquisitionValuation",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Domain_TypeOneof_BuyerRepairNegotiation",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Domain_TypeOneof_BwodLead",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Domain_TypeOneof_DebtFinancing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Domain_TypeOneof_DigitalCheckout",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Domain_TypeOneof_DirectLead",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Domain_TypeOneof_DirectOffer",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Domain_TypeOneof_ExclusiveListing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Domain_TypeOneof_ExternalListing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Domain_TypeOneof_HomeAccessMonitoring",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Domain_TypeOneof_Inventory",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Domain_TypeOneof_InventoryListing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Domain_TypeOneof_InventoryMaintenance",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Domain_TypeOneof_InventoryReno",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Domain_TypeOneof_LenderRequiredRepairs",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Domain_TypeOneof_MaintenanceSchedule",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Domain_TypeOneof_OboBuyerOffer",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Domain_TypeOneof_OboBwodOffer",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Domain_TypeOneof_ReitReno",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Domain_TypeOneof_RenoPrep",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Domain_TypeOneof_RenoProjectExecution",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Domain_TypeOneof_RenoRepairScoping",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Domain_TypeOneof_ResaleBuyDirect",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Domain_TypeOneof_ResaleBuyerOffer",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Domain_TypeOneof_ResaleInventory",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Domain_TypeOneof_ResaleListing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Domain_TypeOneof_SellWithUpsidePricing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Domain_TypeOneof_ThirdPartyMarketplaceListing"
    ],
    "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Started_TypeOneof": [
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Started_TypeOneof_AcquisitionDataLabeling",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Started_TypeOneof_AcquisitionRepairBudgetReview",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Started_TypeOneof_AcquisitionRiskAssessment",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Started_TypeOneof_AcquisitionUnderwriting",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Started_TypeOneof_AcquisitionValuation",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Started_TypeOneof_Assessment",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Started_TypeOneof_BuyerRepairNegotiation",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Started_TypeOneof_BwodLead",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Started_TypeOneof_DebtFinancing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Started_TypeOneof_DigitalCheckout",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Started_TypeOneof_DirectLead",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Started_TypeOneof_DirectOffer",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Started_TypeOneof_ExclusiveListing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Started_TypeOneof_ExternalListing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Started_TypeOneof_HomeAccessMonitoring",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Started_TypeOneof_Inventory",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Started_TypeOneof_InventoryListing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Started_TypeOneof_InventoryMaintenance",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Started_TypeOneof_InventoryReno",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Started_TypeOneof_LenderRequiredRepairs",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Started_TypeOneof_MaintenanceSchedule",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Started_TypeOneof_OboBuyerOffer",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Started_TypeOneof_OboBwodOffer",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Started_TypeOneof_ReitReno",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Started_TypeOneof_RenoPrep",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Started_TypeOneof_RenoProjectExecution",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Started_TypeOneof_RenoRepairScoping",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Started_TypeOneof_ResaleBuyDirect",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Started_TypeOneof_ResaleBuyerOffer",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Started_TypeOneof_ResaleInventory",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Started_TypeOneof_ResaleListing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Started_TypeOneof_SellWithUpsidePricing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_EventExtensions_Started_TypeOneof_ThirdPartyMarketplaceListing"
    ],
    "OdProtosPropertyLifecycleDataPropertyEngagements_ExclusiveListing_EventExtensions_Domain_TypeOneof": [
      "OdProtosPropertyLifecycleDataPropertyEngagements_ExclusiveListing_EventExtensions_Domain_TypeOneof_Expired",
      "OdProtosPropertyLifecycleDataPropertyEngagements_ExclusiveListing_EventExtensions_Domain_TypeOneof_InContract",
      "OdProtosPropertyLifecycleDataPropertyEngagements_ExclusiveListing_EventExtensions_Domain_TypeOneof_Listed",
      "OdProtosPropertyLifecycleDataPropertyEngagements_ExclusiveListing_EventExtensions_Domain_TypeOneof_SetupStarted",
      "OdProtosPropertyLifecycleDataPropertyEngagements_ExclusiveListing_EventExtensions_Domain_TypeOneof_Sold"
    ],
    "OdProtosPropertyLifecycleDataPropertyEngagements_ExternalListing_EventExtensions_Domain_TypeOneof": [
      "OdProtosPropertyLifecycleDataPropertyEngagements_ExternalListing_EventExtensions_Domain_TypeOneof_Active",
      "OdProtosPropertyLifecycleDataPropertyEngagements_ExternalListing_EventExtensions_Domain_TypeOneof_AttorneyReview",
      "OdProtosPropertyLifecycleDataPropertyEngagements_ExternalListing_EventExtensions_Domain_TypeOneof_Canceled",
      "OdProtosPropertyLifecycleDataPropertyEngagements_ExternalListing_EventExtensions_Domain_TypeOneof_ContingencyReleased",
      "OdProtosPropertyLifecycleDataPropertyEngagements_ExternalListing_EventExtensions_Domain_TypeOneof_InContract",
      "OdProtosPropertyLifecycleDataPropertyEngagements_ExternalListing_EventExtensions_Domain_TypeOneof_Inactive",
      "OdProtosPropertyLifecycleDataPropertyEngagements_ExternalListing_EventExtensions_Domain_TypeOneof_Sold"
    ],
    "OdProtosPropertyLifecycleDataPropertyEngagements_HomeAccessMonitoring_EventExtensions_Domain_TypeOneof": [
      "OdProtosPropertyLifecycleDataPropertyEngagements_HomeAccessMonitoring_EventExtensions_Domain_TypeOneof_AccessAvailable",
      "OdProtosPropertyLifecycleDataPropertyEngagements_HomeAccessMonitoring_EventExtensions_Domain_TypeOneof_AccessMonitoringAvailable",
      "OdProtosPropertyLifecycleDataPropertyEngagements_HomeAccessMonitoring_EventExtensions_Domain_TypeOneof_Completed",
      "OdProtosPropertyLifecycleDataPropertyEngagements_HomeAccessMonitoring_EventExtensions_Domain_TypeOneof_MonitoringAvailable",
      "OdProtosPropertyLifecycleDataPropertyEngagements_HomeAccessMonitoring_EventExtensions_Domain_TypeOneof_Requested"
    ],
    "OdProtosPropertyLifecycleDataPropertyEngagements_InventoryMaintenance_EventExtensions_Domain_TypeOneof": [
      "OdProtosPropertyLifecycleDataPropertyEngagements_InventoryMaintenance_EventExtensions_Domain_TypeOneof_Inactive"
    ],
    "OdProtosPropertyLifecycleDataPropertyEngagements_InventoryReno_EventExtensions_Domain_TypeOneof": [
      "OdProtosPropertyLifecycleDataPropertyEngagements_InventoryReno_EventExtensions_Domain_TypeOneof_Canceled",
      "OdProtosPropertyLifecycleDataPropertyEngagements_InventoryReno_EventExtensions_Domain_TypeOneof_Completed",
      "OdProtosPropertyLifecycleDataPropertyEngagements_InventoryReno_EventExtensions_Domain_TypeOneof_Draft",
      "OdProtosPropertyLifecycleDataPropertyEngagements_InventoryReno_EventExtensions_Domain_TypeOneof_InProgress"
    ],
    "OdProtosPropertyLifecycleDataPropertyEngagements_Inventory_EventExtensions_Domain_TypeOneof": [
      "OdProtosPropertyLifecycleDataPropertyEngagements_Inventory_EventExtensions_Domain_TypeOneof_Access",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Inventory_EventExtensions_Domain_TypeOneof_Acquired",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Inventory_EventExtensions_Domain_TypeOneof_Acquiring",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Inventory_EventExtensions_Domain_TypeOneof_AcquisitionCoeDateChange",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Inventory_EventExtensions_Domain_TypeOneof_ExpectedAcquisitionAccessDateChange",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Inventory_EventExtensions_Domain_TypeOneof_ExpectedAcquisitionCoeDateChange",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Inventory_EventExtensions_Domain_TypeOneof_ExpectedAcquisitionLateCheckoutDateChange",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Inventory_EventExtensions_Domain_TypeOneof_ExpectedResaleCoeDateChange",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Inventory_EventExtensions_Domain_TypeOneof_NotAcquiring",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Inventory_EventExtensions_Domain_TypeOneof_OnTheMarket",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Inventory_EventExtensions_Domain_TypeOneof_PrepForResale",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Inventory_EventExtensions_Domain_TypeOneof_Reserved",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Inventory_EventExtensions_Domain_TypeOneof_Sellable",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Inventory_EventExtensions_Domain_TypeOneof_Selling",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Inventory_EventExtensions_Domain_TypeOneof_Sold"
    ],
    "OdProtosPropertyLifecycleDataPropertyEngagements_MaintenanceSchedule_EventExtensions_Domain_TypeOneof": [
      "OdProtosPropertyLifecycleDataPropertyEngagements_MaintenanceSchedule_EventExtensions_Domain_TypeOneof_Active",
      "OdProtosPropertyLifecycleDataPropertyEngagements_MaintenanceSchedule_EventExtensions_Domain_TypeOneof_Canceled",
      "OdProtosPropertyLifecycleDataPropertyEngagements_MaintenanceSchedule_EventExtensions_Domain_TypeOneof_Finished",
      "OdProtosPropertyLifecycleDataPropertyEngagements_MaintenanceSchedule_EventExtensions_Domain_TypeOneof_Scheduled"
    ],
    "OdProtosPropertyLifecycleDataPropertyEngagements_Metadata_TypeOneof": [
      "OdProtosPropertyLifecycleDataPropertyEngagements_Metadata_TypeOneof_AcquisitionDataLabeling",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Metadata_TypeOneof_AcquisitionRepairBudgetReview",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Metadata_TypeOneof_AcquisitionRiskAssessment",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Metadata_TypeOneof_AcquisitionUnderwriting",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Metadata_TypeOneof_AcquisitionValuation",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Metadata_TypeOneof_Assessment",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Metadata_TypeOneof_BuyerRepairNegotiation",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Metadata_TypeOneof_BwodLead",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Metadata_TypeOneof_DebtFinancing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Metadata_TypeOneof_DirectLead",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Metadata_TypeOneof_DirectOffer",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Metadata_TypeOneof_ExclusiveListing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Metadata_TypeOneof_ExternalListing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Metadata_TypeOneof_HomeAccessMonitoring",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Metadata_TypeOneof_Inventory",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Metadata_TypeOneof_InventoryListing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Metadata_TypeOneof_InventoryMaintenance",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Metadata_TypeOneof_InventoryReno",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Metadata_TypeOneof_LenderRequiredRepairs",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Metadata_TypeOneof_MaintenanceSchedule",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Metadata_TypeOneof_OboBuyerOffer",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Metadata_TypeOneof_OboBwodOffer",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Metadata_TypeOneof_ReitReno",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Metadata_TypeOneof_RenoPrep",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Metadata_TypeOneof_RenoProjectExecution",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Metadata_TypeOneof_RenoRepairScoping",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Metadata_TypeOneof_ResaleBuyDirect",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Metadata_TypeOneof_ResaleBuyerOffer",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Metadata_TypeOneof_ResaleInventory",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Metadata_TypeOneof_ResaleListing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Metadata_TypeOneof_SellWithUpsidePricing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_Metadata_TypeOneof_ThirdPartyMarketplaceListing"
    ],
    "OdProtosPropertyLifecycleDataPropertyEngagements_OboBuyerOffer_EventExtensions_Domain_TypeOneof": [
      "OdProtosPropertyLifecycleDataPropertyEngagements_OboBuyerOffer_EventExtensions_Domain_TypeOneof_Active",
      "OdProtosPropertyLifecycleDataPropertyEngagements_OboBuyerOffer_EventExtensions_Domain_TypeOneof_AwaitingSignature",
      "OdProtosPropertyLifecycleDataPropertyEngagements_OboBuyerOffer_EventExtensions_Domain_TypeOneof_BuyerWalked",
      "OdProtosPropertyLifecycleDataPropertyEngagements_OboBuyerOffer_EventExtensions_Domain_TypeOneof_Canceled",
      "OdProtosPropertyLifecycleDataPropertyEngagements_OboBuyerOffer_EventExtensions_Domain_TypeOneof_Closed",
      "OdProtosPropertyLifecycleDataPropertyEngagements_OboBuyerOffer_EventExtensions_Domain_TypeOneof_CoeChanged",
      "OdProtosPropertyLifecycleDataPropertyEngagements_OboBuyerOffer_EventExtensions_Domain_TypeOneof_ContingenciesReleased",
      "OdProtosPropertyLifecycleDataPropertyEngagements_OboBuyerOffer_EventExtensions_Domain_TypeOneof_ContractFellThrough",
      "OdProtosPropertyLifecycleDataPropertyEngagements_OboBuyerOffer_EventExtensions_Domain_TypeOneof_InContract"
    ],
    "OdProtosPropertyLifecycleDataPropertyEngagements_OboBwodOffer_EventExtensions_Domain_TypeOneof": [
      "OdProtosPropertyLifecycleDataPropertyEngagements_OboBwodOffer_EventExtensions_Domain_TypeOneof_AcqWithdrawn",
      "OdProtosPropertyLifecycleDataPropertyEngagements_OboBwodOffer_EventExtensions_Domain_TypeOneof_Canceled",
      "OdProtosPropertyLifecycleDataPropertyEngagements_OboBwodOffer_EventExtensions_Domain_TypeOneof_ContingenciesReleased",
      "OdProtosPropertyLifecycleDataPropertyEngagements_OboBwodOffer_EventExtensions_Domain_TypeOneof_InContract",
      "OdProtosPropertyLifecycleDataPropertyEngagements_OboBwodOffer_EventExtensions_Domain_TypeOneof_Listed",
      "OdProtosPropertyLifecycleDataPropertyEngagements_OboBwodOffer_EventExtensions_Domain_TypeOneof_PreRenovation",
      "OdProtosPropertyLifecycleDataPropertyEngagements_OboBwodOffer_EventExtensions_Domain_TypeOneof_ResaleContingenciesReleased",
      "OdProtosPropertyLifecycleDataPropertyEngagements_OboBwodOffer_EventExtensions_Domain_TypeOneof_ResaleInContract",
      "OdProtosPropertyLifecycleDataPropertyEngagements_OboBwodOffer_EventExtensions_Domain_TypeOneof_Sold"
    ],
    "OdProtosPropertyLifecycleDataPropertyEngagements_ReitReno_EventExtensions_Domain_TypeOneof": [
      "OdProtosPropertyLifecycleDataPropertyEngagements_ReitReno_EventExtensions_Domain_TypeOneof_DateChange"
    ],
    "OdProtosPropertyLifecycleDataPropertyEngagements_RenoPrep_EventExtensions_Domain_TypeOneof": [
      "OdProtosPropertyLifecycleDataPropertyEngagements_RenoPrep_EventExtensions_Domain_TypeOneof_Canceled",
      "OdProtosPropertyLifecycleDataPropertyEngagements_RenoPrep_EventExtensions_Domain_TypeOneof_Completed"
    ],
    "OdProtosPropertyLifecycleDataPropertyEngagements_RenoProjectExecution_EventExtensions_Domain_TypeOneof": [
      "OdProtosPropertyLifecycleDataPropertyEngagements_RenoProjectExecution_EventExtensions_Domain_TypeOneof_Cancelled",
      "OdProtosPropertyLifecycleDataPropertyEngagements_RenoProjectExecution_EventExtensions_Domain_TypeOneof_Completed",
      "OdProtosPropertyLifecycleDataPropertyEngagements_RenoProjectExecution_EventExtensions_Domain_TypeOneof_DateChange",
      "OdProtosPropertyLifecycleDataPropertyEngagements_RenoProjectExecution_EventExtensions_Domain_TypeOneof_EndDateChange",
      "OdProtosPropertyLifecycleDataPropertyEngagements_RenoProjectExecution_EventExtensions_Domain_TypeOneof_InProgress",
      "OdProtosPropertyLifecycleDataPropertyEngagements_RenoProjectExecution_EventExtensions_Domain_TypeOneof_StartDateChange"
    ],
    "OdProtosPropertyLifecycleDataPropertyEngagements_RenoRepairScoping_EventExtensions_Domain_TypeOneof": [
      "OdProtosPropertyLifecycleDataPropertyEngagements_RenoRepairScoping_EventExtensions_Domain_TypeOneof_Canceled",
      "OdProtosPropertyLifecycleDataPropertyEngagements_RenoRepairScoping_EventExtensions_Domain_TypeOneof_Completed",
      "OdProtosPropertyLifecycleDataPropertyEngagements_RenoRepairScoping_EventExtensions_Domain_TypeOneof_Started"
    ],
    "OdProtosPropertyLifecycleDataPropertyEngagements_ResaleBuyerOffer_EventExtensions_Domain_TypeOneof": [
      "OdProtosPropertyLifecycleDataPropertyEngagements_ResaleBuyerOffer_EventExtensions_Domain_TypeOneof_Active",
      "OdProtosPropertyLifecycleDataPropertyEngagements_ResaleBuyerOffer_EventExtensions_Domain_TypeOneof_AttorneyReview",
      "OdProtosPropertyLifecycleDataPropertyEngagements_ResaleBuyerOffer_EventExtensions_Domain_TypeOneof_AwaitingSignature",
      "OdProtosPropertyLifecycleDataPropertyEngagements_ResaleBuyerOffer_EventExtensions_Domain_TypeOneof_Backup",
      "OdProtosPropertyLifecycleDataPropertyEngagements_ResaleBuyerOffer_EventExtensions_Domain_TypeOneof_BuyerWalked",
      "OdProtosPropertyLifecycleDataPropertyEngagements_ResaleBuyerOffer_EventExtensions_Domain_TypeOneof_Canceled",
      "OdProtosPropertyLifecycleDataPropertyEngagements_ResaleBuyerOffer_EventExtensions_Domain_TypeOneof_Closed",
      "OdProtosPropertyLifecycleDataPropertyEngagements_ResaleBuyerOffer_EventExtensions_Domain_TypeOneof_CoeChanged",
      "OdProtosPropertyLifecycleDataPropertyEngagements_ResaleBuyerOffer_EventExtensions_Domain_TypeOneof_ContingenciesReleased",
      "OdProtosPropertyLifecycleDataPropertyEngagements_ResaleBuyerOffer_EventExtensions_Domain_TypeOneof_ContractFellthrough",
      "OdProtosPropertyLifecycleDataPropertyEngagements_ResaleBuyerOffer_EventExtensions_Domain_TypeOneof_Countered",
      "OdProtosPropertyLifecycleDataPropertyEngagements_ResaleBuyerOffer_EventExtensions_Domain_TypeOneof_InContract",
      "OdProtosPropertyLifecycleDataPropertyEngagements_ResaleBuyerOffer_EventExtensions_Domain_TypeOneof_InNegotiation",
      "OdProtosPropertyLifecycleDataPropertyEngagements_ResaleBuyerOffer_EventExtensions_Domain_TypeOneof_Rejected"
    ],
    "OdProtosPropertyLifecycleDataPropertyEngagements_ResaleListing_EventExtensions_Domain_TypeOneof": [
      "OdProtosPropertyLifecycleDataPropertyEngagements_ResaleListing_EventExtensions_Domain_TypeOneof_Active",
      "OdProtosPropertyLifecycleDataPropertyEngagements_ResaleListing_EventExtensions_Domain_TypeOneof_AttorneyReview",
      "OdProtosPropertyLifecycleDataPropertyEngagements_ResaleListing_EventExtensions_Domain_TypeOneof_Canceled",
      "OdProtosPropertyLifecycleDataPropertyEngagements_ResaleListing_EventExtensions_Domain_TypeOneof_ContingencyReleased",
      "OdProtosPropertyLifecycleDataPropertyEngagements_ResaleListing_EventExtensions_Domain_TypeOneof_InContract",
      "OdProtosPropertyLifecycleDataPropertyEngagements_ResaleListing_EventExtensions_Domain_TypeOneof_Inactive",
      "OdProtosPropertyLifecycleDataPropertyEngagements_ResaleListing_EventExtensions_Domain_TypeOneof_Sold"
    ],
    "OdProtosPropertyLifecycleDataPropertyEngagements_State_TypeOneof": [
      "OdProtosPropertyLifecycleDataPropertyEngagements_State_TypeOneof_AcquisitionDataLabeling",
      "OdProtosPropertyLifecycleDataPropertyEngagements_State_TypeOneof_AcquisitionRepairBudgetReview",
      "OdProtosPropertyLifecycleDataPropertyEngagements_State_TypeOneof_AcquisitionRiskAssessment",
      "OdProtosPropertyLifecycleDataPropertyEngagements_State_TypeOneof_AcquisitionUnderwriting",
      "OdProtosPropertyLifecycleDataPropertyEngagements_State_TypeOneof_AcquisitionValuation",
      "OdProtosPropertyLifecycleDataPropertyEngagements_State_TypeOneof_Assessment",
      "OdProtosPropertyLifecycleDataPropertyEngagements_State_TypeOneof_BuyerRepairNegotiation",
      "OdProtosPropertyLifecycleDataPropertyEngagements_State_TypeOneof_BwodLead",
      "OdProtosPropertyLifecycleDataPropertyEngagements_State_TypeOneof_DebtFinancing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_State_TypeOneof_DigitalCheckout",
      "OdProtosPropertyLifecycleDataPropertyEngagements_State_TypeOneof_DirectLead",
      "OdProtosPropertyLifecycleDataPropertyEngagements_State_TypeOneof_DirectOffer",
      "OdProtosPropertyLifecycleDataPropertyEngagements_State_TypeOneof_ExclusiveListing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_State_TypeOneof_ExternalListing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_State_TypeOneof_HomeAccessMonitoring",
      "OdProtosPropertyLifecycleDataPropertyEngagements_State_TypeOneof_Inventory",
      "OdProtosPropertyLifecycleDataPropertyEngagements_State_TypeOneof_InventoryListing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_State_TypeOneof_InventoryMaintenance",
      "OdProtosPropertyLifecycleDataPropertyEngagements_State_TypeOneof_InventoryReno",
      "OdProtosPropertyLifecycleDataPropertyEngagements_State_TypeOneof_LenderRequiredRepairs",
      "OdProtosPropertyLifecycleDataPropertyEngagements_State_TypeOneof_MaintenanceSchedule",
      "OdProtosPropertyLifecycleDataPropertyEngagements_State_TypeOneof_OboBuyerOffer",
      "OdProtosPropertyLifecycleDataPropertyEngagements_State_TypeOneof_OboBwodOffer",
      "OdProtosPropertyLifecycleDataPropertyEngagements_State_TypeOneof_ReitReno",
      "OdProtosPropertyLifecycleDataPropertyEngagements_State_TypeOneof_RenoPrep",
      "OdProtosPropertyLifecycleDataPropertyEngagements_State_TypeOneof_RenoProjectExecution",
      "OdProtosPropertyLifecycleDataPropertyEngagements_State_TypeOneof_RenoRepairScoping",
      "OdProtosPropertyLifecycleDataPropertyEngagements_State_TypeOneof_ResaleBuyDirect",
      "OdProtosPropertyLifecycleDataPropertyEngagements_State_TypeOneof_ResaleBuyerOffer",
      "OdProtosPropertyLifecycleDataPropertyEngagements_State_TypeOneof_ResaleInventory",
      "OdProtosPropertyLifecycleDataPropertyEngagements_State_TypeOneof_ResaleListing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_State_TypeOneof_SellWithUpsidePricing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_State_TypeOneof_ThirdPartyMarketplaceListing",
      "OdProtosPropertyLifecycleDataPropertyEngagements_State_TypeOneof_Unchanged"
    ],
    "OdProtosPropertyLifecycleEvents_PropertyLifecycleInputMessage_EventOneof": [
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleInputMessage_EventOneof_PropertyEngagementCommand",
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleInputMessage_EventOneof_PropertyEngagementEvent",
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleInputMessage_EventOneof_PropertyEvent"
    ],
    "OdProtosPropertyLifecycleEvents_PropertyLifecycleInputMessage_PropertyEngagementCommand_Create_LocationOneof": [
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleInputMessage_PropertyEngagementCommand_Create_LocationOneof_AddressToken",
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleInputMessage_PropertyEngagementCommand_Create_LocationOneof_PropertyId"
    ],
    "OdProtosPropertyLifecycleEvents_PropertyLifecycleInputMessage_PropertyEngagementCommand_TypeOneof": [
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleInputMessage_PropertyEngagementCommand_TypeOneof_ChangePropertyAddressToken",
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleInputMessage_PropertyEngagementCommand_TypeOneof_ChangePropertyEngagementGroup",
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleInputMessage_PropertyEngagementCommand_TypeOneof_Create",
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleInputMessage_PropertyEngagementCommand_TypeOneof_Domain",
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleInputMessage_PropertyEngagementCommand_TypeOneof_Pause",
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleInputMessage_PropertyEngagementCommand_TypeOneof_Stop",
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleInputMessage_PropertyEngagementCommand_TypeOneof_Wake"
    ],
    "OdProtosPropertyLifecycleEvents_PropertyLifecycleInputMessage_PropertyEngagementEvent_Domain_NewStateOneof": [
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleInputMessage_PropertyEngagementEvent_Domain_NewStateOneof_LifecycleState",
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleInputMessage_PropertyEngagementEvent_Domain_NewStateOneof_Unchanged"
    ],
    "OdProtosPropertyLifecycleEvents_PropertyLifecycleInputMessage_PropertyEngagementEvent_LocationOneof": [
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleInputMessage_PropertyEngagementEvent_LocationOneof_AddressToken",
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleInputMessage_PropertyEngagementEvent_LocationOneof_PropertyId"
    ],
    "OdProtosPropertyLifecycleEvents_PropertyLifecycleInputMessage_PropertyEngagementEvent_TypeOneof": [
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleInputMessage_PropertyEngagementEvent_TypeOneof_Domain",
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleInputMessage_PropertyEngagementEvent_TypeOneof_Paused",
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleInputMessage_PropertyEngagementEvent_TypeOneof_Started",
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleInputMessage_PropertyEngagementEvent_TypeOneof_Woken"
    ],
    "OdProtosPropertyLifecycleEvents_PropertyLifecycleInputMessage_PropertyEvent_TypeOneof": [
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleInputMessage_PropertyEvent_TypeOneof_AddressTokenUpdated",
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleInputMessage_PropertyEvent_TypeOneof_Created"
    ],
    "OdProtosPropertyLifecycleEvents_PropertyLifecycleMessage_EventOneof": [
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleMessage_EventOneof_PropertyEngagementCommand",
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleMessage_EventOneof_PropertyEngagementEvent",
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleMessage_EventOneof_PropertyEvent"
    ],
    "OdProtosPropertyLifecycleEvents_PropertyLifecycleMessage_PropertyEngagementCommand_TypeOneof": [
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleMessage_PropertyEngagementCommand_TypeOneof_ChangePropertyAddressToken",
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleMessage_PropertyEngagementCommand_TypeOneof_ChangePropertyEngagementGroup",
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleMessage_PropertyEngagementCommand_TypeOneof_Create",
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleMessage_PropertyEngagementCommand_TypeOneof_Domain",
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleMessage_PropertyEngagementCommand_TypeOneof_Pause",
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleMessage_PropertyEngagementCommand_TypeOneof_Stop",
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleMessage_PropertyEngagementCommand_TypeOneof_Wake"
    ],
    "OdProtosPropertyLifecycleEvents_PropertyLifecycleMessage_PropertyEngagementEvent_Domain_NewStateOneof": [
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleMessage_PropertyEngagementEvent_Domain_NewStateOneof_LifecycleState",
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleMessage_PropertyEngagementEvent_Domain_NewStateOneof_Unchanged"
    ],
    "OdProtosPropertyLifecycleEvents_PropertyLifecycleMessage_PropertyEngagementEvent_TypeOneof": [
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleMessage_PropertyEngagementEvent_TypeOneof_Deleted",
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleMessage_PropertyEngagementEvent_TypeOneof_Domain",
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleMessage_PropertyEngagementEvent_TypeOneof_Paused",
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleMessage_PropertyEngagementEvent_TypeOneof_Started",
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleMessage_PropertyEngagementEvent_TypeOneof_Woken"
    ],
    "OdProtosPropertyLifecycleEvents_PropertyLifecycleMessage_PropertyEvent_TypeOneof": [
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleMessage_PropertyEvent_TypeOneof_AddressTokenUpdated",
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleMessage_PropertyEvent_TypeOneof_Created",
      "OdProtosPropertyLifecycleEvents_PropertyLifecycleMessage_PropertyEvent_TypeOneof_PropertyIdUpdated"
    ],
    "OdProtosPropertyLifecycleServices_GetPropertyEngagementsV1_Request_ByOneof": [
      "OdProtosPropertyLifecycleServices_GetPropertyEngagementsV1_Request_ByOneof_CustomerId",
      "OdProtosPropertyLifecycleServices_GetPropertyEngagementsV1_Request_ByOneof_PropertyEngagementGroupIds",
      "OdProtosPropertyLifecycleServices_GetPropertyEngagementsV1_Request_ByOneof_PropertyEngagementIds",
      "OdProtosPropertyLifecycleServices_GetPropertyEngagementsV1_Request_ByOneof_PropertyId"
    ],
    "OdProtosPropertyLifecycleServices_GetPropertyEngagementsV1_Request_Filter_ByOneof": [
      "OdProtosPropertyLifecycleServices_GetPropertyEngagementsV1_Request_Filter_ByOneof_LifecycleStates",
      "OdProtosPropertyLifecycleServices_GetPropertyEngagementsV1_Request_Filter_ByOneof_MinCompletedAt",
      "OdProtosPropertyLifecycleServices_GetPropertyEngagementsV1_Request_Filter_ByOneof_PropertyEngagementTypes"
    ],
    "OdProtosPropertyLifecycleServices_GetPropertyEngagements_Request_ByOneof": [
      "OdProtosPropertyLifecycleServices_GetPropertyEngagements_Request_ByOneof_CustomerId",
      "OdProtosPropertyLifecycleServices_GetPropertyEngagements_Request_ByOneof_PropertyEngagementIds",
      "OdProtosPropertyLifecycleServices_GetPropertyEngagements_Request_ByOneof_PropertyId"
    ],
    "OdProtosPropertyLifecycleServices_GetPropertyEventLog_Request_ByOneof": [
      "OdProtosPropertyLifecycleServices_GetPropertyEventLog_Request_ByOneof_AddressToken",
      "OdProtosPropertyLifecycleServices_GetPropertyEventLog_Request_ByOneof_PropertyId"
    ],
    "OdProtosPropertyLifecycleServices_GetProperty_Request_ByOneof": [
      "OdProtosPropertyLifecycleServices_GetProperty_Request_ByOneof_AddressToken",
      "OdProtosPropertyLifecycleServices_GetProperty_Request_ByOneof_PropertyId"
    ],
    "OdProtosQacServices_ServiceSpec_SpecOneof": [
      "OdProtosQacServices_ServiceSpec_SpecOneof_Github",
      "OdProtosQacServices_ServiceSpec_SpecOneof_Goose"
    ],
    "OdProtosRealtyCommon_Commission_TypeOneof": [
      "OdProtosRealtyCommon_Commission_TypeOneof_FlatCents",
      "OdProtosRealtyCommon_Commission_TypeOneof_RateBips"
    ],
    "OdProtosRealtyCommon_Disclosure_IdentifierOneof": [
      "OdProtosRealtyCommon_Disclosure_IdentifierOneof_BuyOfferId",
      "OdProtosRealtyCommon_Disclosure_IdentifierOneof_NegotiationId",
      "OdProtosRealtyCommon_Disclosure_IdentifierOneof_SellRequestId"
    ],
    "OdProtosRealtyCommon_TermOneof_TypeOneof": [
      "OdProtosRealtyCommon_TermOneof_TypeOneof_Coe",
      "OdProtosRealtyCommon_TermOneof_TypeOneof_Credit",
      "OdProtosRealtyCommon_TermOneof_TypeOneof_Fee",
      "OdProtosRealtyCommon_TermOneof_TypeOneof_Financing",
      "OdProtosRealtyCommon_TermOneof_TypeOneof_OptionPeriod",
      "OdProtosRealtyCommon_TermOneof_TypeOneof_Other",
      "OdProtosRealtyCommon_TermOneof_TypeOneof_Price",
      "OdProtosRealtyCommon_TermOneof_TypeOneof_Repair"
    ],
    "OdProtosRealtyDocumentsData_Asset_LocationOneof": [
      "OdProtosRealtyDocumentsData_Asset_LocationOneof_CabinetAssetId",
      "OdProtosRealtyDocumentsData_Asset_LocationOneof_Url"
    ],
    "OdProtosRealtyDocumentsData_GroupSpecific_DomainOneof": [
      "OdProtosRealtyDocumentsData_GroupSpecific_DomainOneof_ClearinghouseSpecific"
    ],
    "OdProtosRealtyDocumentsData_OverrideField_ValueOneof": [
      "OdProtosRealtyDocumentsData_OverrideField_ValueOneof_BoolVal",
      "OdProtosRealtyDocumentsData_OverrideField_ValueOneof_StringVal"
    ],
    "OdProtosRealtyOdlsData_SellRequest_Channel_TypeOneof": [
      "OdProtosRealtyOdlsData_SellRequest_Channel_TypeOneof_AgentRepresentation",
      "OdProtosRealtyOdlsData_SellRequest_Channel_TypeOneof_EarlyAccess",
      "OdProtosRealtyOdlsData_SellRequest_Channel_TypeOneof_Exclusives",
      "OdProtosRealtyOdlsData_SellRequest_Channel_TypeOneof_Institutional",
      "OdProtosRealtyOdlsData_SellRequest_Channel_TypeOneof_Public"
    ],
    "OdProtosRealtyOdlsEvents_AgentRepresentationEvent_EventOneof": [
      "OdProtosRealtyOdlsEvents_AgentRepresentationEvent_EventOneof_SellRequestCreated",
      "OdProtosRealtyOdlsEvents_AgentRepresentationEvent_EventOneof_SellRequestUpdated"
    ],
    "OdProtosRealtyOdlsEvents_EarlyAccessBuyerEvent_EventOneof": [
      "OdProtosRealtyOdlsEvents_EarlyAccessBuyerEvent_EventOneof_SellRequestCreated",
      "OdProtosRealtyOdlsEvents_EarlyAccessBuyerEvent_EventOneof_SellRequestUpdated"
    ],
    "OdProtosRealtyOdlsEvents_ExclusivesBuyerEvent_EventOneof": [
      "OdProtosRealtyOdlsEvents_ExclusivesBuyerEvent_EventOneof_SellRequestCreated",
      "OdProtosRealtyOdlsEvents_ExclusivesBuyerEvent_EventOneof_SellRequestUpdated"
    ],
    "OdProtosRealtyOdlsEvents_InstitutionalBuyerEvent_EventOneof": [
      "OdProtosRealtyOdlsEvents_InstitutionalBuyerEvent_EventOneof_SellRequestCreated",
      "OdProtosRealtyOdlsEvents_InstitutionalBuyerEvent_EventOneof_SellRequestUpdated"
    ],
    "OdProtosRealtyOdlsEvents_OpenHouseEvent_EventOneof": [
      "OdProtosRealtyOdlsEvents_OpenHouseEvent_EventOneof_Created",
      "OdProtosRealtyOdlsEvents_OpenHouseEvent_EventOneof_Updated"
    ],
    "OdProtosRealtyOdlsEvents_PublicBuyerEvent_EventOneof": [
      "OdProtosRealtyOdlsEvents_PublicBuyerEvent_EventOneof_SellRequestCreated",
      "OdProtosRealtyOdlsEvents_PublicBuyerEvent_EventOneof_SellRequestUpdated"
    ],
    "OdProtosRealtyOdlsEvents_SellRequestChangeEvents_EventOneof": [
      "OdProtosRealtyOdlsEvents_SellRequestChangeEvents_EventOneof_NewEvents"
    ],
    "OdProtosRealtyOdlsEvents_SellRequestEvent_EventOneof": [
      "OdProtosRealtyOdlsEvents_SellRequestEvent_EventOneof_SellRequestCreated",
      "OdProtosRealtyOdlsEvents_SellRequestEvent_EventOneof_SellRequestUpdated"
    ],
    "OdProtosRealtyOdlsEvents_SellRequestHistoryEvent_EventOneof": [
      "OdProtosRealtyOdlsEvents_SellRequestHistoryEvent_EventOneof_SellRequestHistoryWritten"
    ],
    "OdProtosRealtyTasks_ResolveDocumentTaskData_TransactionIdOneof": [
      "OdProtosRealtyTasks_ResolveDocumentTaskData_TransactionIdOneof_ListingOfferId",
      "OdProtosRealtyTasks_ResolveDocumentTaskData_TransactionIdOneof_OfferId"
    ],
    "OdProtosRealtyTasks_UnsignedDocumentTaskData_DocumentOneof": [
      "OdProtosRealtyTasks_UnsignedDocumentTaskData_DocumentOneof_WebAddendumId"
    ],
    "OdProtosRenovationRepairScopingEvents_RenoRepairScopingEvents_EventOneof": [
      "OdProtosRenovationRepairScopingEvents_RenoRepairScopingEvents_EventOneof_Canceled",
      "OdProtosRenovationRepairScopingEvents_RenoRepairScopingEvents_EventOneof_Requested",
      "OdProtosRenovationRepairScopingEvents_RenoRepairScopingEvents_EventOneof_ScopingCompleted",
      "OdProtosRenovationRepairScopingEvents_RenoRepairScopingEvents_EventOneof_ScopingStarted"
    ],
    "OdProtosResaleInventoryPropertyEngagements_Resale_EventExtensions_Domain_TypeOneof": [
      "OdProtosResaleInventoryPropertyEngagements_Resale_EventExtensions_Domain_TypeOneof_AcceptedOfferTypesUpdated",
      "OdProtosResaleInventoryPropertyEngagements_Resale_EventExtensions_Domain_TypeOneof_ActiveChannelsUpdated",
      "OdProtosResaleInventoryPropertyEngagements_Resale_EventExtensions_Domain_TypeOneof_BuyDirectAdjustmentFactorUpdated",
      "OdProtosResaleInventoryPropertyEngagements_Resale_EventExtensions_Domain_TypeOneof_BuyerCommitted",
      "OdProtosResaleInventoryPropertyEngagements_Resale_EventExtensions_Domain_TypeOneof_BuyerUncommitted",
      "OdProtosResaleInventoryPropertyEngagements_Resale_EventExtensions_Domain_TypeOneof_ExclusivesEligibleUpdated",
      "OdProtosResaleInventoryPropertyEngagements_Resale_EventExtensions_Domain_TypeOneof_ExpectedPropertyAccessUnblockedDateUpdated",
      "OdProtosResaleInventoryPropertyEngagements_Resale_EventExtensions_Domain_TypeOneof_ExpectedSellableDateUpdated",
      "OdProtosResaleInventoryPropertyEngagements_Resale_EventExtensions_Domain_TypeOneof_HeadlinePriceUpdated",
      "OdProtosResaleInventoryPropertyEngagements_Resale_EventExtensions_Domain_TypeOneof_IsExclusiveUpdated",
      "OdProtosResaleInventoryPropertyEngagements_Resale_EventExtensions_Domain_TypeOneof_PhotosReady",
      "OdProtosResaleInventoryPropertyEngagements_Resale_EventExtensions_Domain_TypeOneof_PreparationStarted",
      "OdProtosResaleInventoryPropertyEngagements_Resale_EventExtensions_Domain_TypeOneof_PropertyAccessBlocked",
      "OdProtosResaleInventoryPropertyEngagements_Resale_EventExtensions_Domain_TypeOneof_PropertyAccessUnblocked",
      "OdProtosResaleInventoryPropertyEngagements_Resale_EventExtensions_Domain_TypeOneof_PubliclyListed",
      "OdProtosResaleInventoryPropertyEngagements_Resale_EventExtensions_Domain_TypeOneof_RemoteEntryAvailable",
      "OdProtosResaleInventoryPropertyEngagements_Resale_EventExtensions_Domain_TypeOneof_RemoteEntryUnavailable",
      "OdProtosResaleInventoryPropertyEngagements_Resale_EventExtensions_Domain_TypeOneof_RevertResaleSold",
      "OdProtosResaleInventoryPropertyEngagements_Resale_EventExtensions_Domain_TypeOneof_SellingHalted",
      "OdProtosResaleInventoryPropertyEngagements_Resale_EventExtensions_Domain_TypeOneof_SellingStarted",
      "OdProtosResaleInventoryPropertyEngagements_Resale_EventExtensions_Domain_TypeOneof_Terminated"
    ],
    "OdProtosRiskAssessmentData_CommercialNeighborsRisk_OptionOneof": [
      "OdProtosRiskAssessmentData_CommercialNeighborsRisk_OptionOneof_Commercial",
      "OdProtosRiskAssessmentData_CommercialNeighborsRisk_OptionOneof_Industrial",
      "OdProtosRiskAssessmentData_CommercialNeighborsRisk_OptionOneof_School"
    ],
    "OdProtosRiskAssessmentData_PowerlineRisk_OptionOneof": [
      "OdProtosRiskAssessmentData_PowerlineRisk_OptionOneof_HighVoltagePowerlineTower",
      "OdProtosRiskAssessmentData_PowerlineRisk_OptionOneof_HighVoltagePowerlineWire",
      "OdProtosRiskAssessmentData_PowerlineRisk_OptionOneof_LowVoltagePowerlinePole",
      "OdProtosRiskAssessmentData_PowerlineRisk_OptionOneof_LowVoltagePowerlineWire",
      "OdProtosRiskAssessmentData_PowerlineRisk_OptionOneof_PowerlineStation"
    ],
    "OdProtosRiskAssessmentData_Risk_FactorOneof": [
      "OdProtosRiskAssessmentData_Risk_FactorOneof_BimodalComps",
      "OdProtosRiskAssessmentData_Risk_FactorOneof_CommercialNeighbors",
      "OdProtosRiskAssessmentData_Risk_FactorOneof_CrampedKitchen",
      "OdProtosRiskAssessmentData_Risk_FactorOneof_MultiFamilyNeighbors",
      "OdProtosRiskAssessmentData_Risk_FactorOneof_NewConstruction",
      "OdProtosRiskAssessmentData_Risk_FactorOneof_NonConformingCurbAppeal",
      "OdProtosRiskAssessmentData_Risk_FactorOneof_OutlierComps",
      "OdProtosRiskAssessmentData_Risk_FactorOneof_Powerline",
      "OdProtosRiskAssessmentData_Risk_FactorOneof_RecentDelisting",
      "OdProtosRiskAssessmentData_Risk_FactorOneof_Road",
      "OdProtosRiskAssessmentData_Risk_FactorOneof_SlopedBackyard",
      "OdProtosRiskAssessmentData_Risk_FactorOneof_SlopedDriveway",
      "OdProtosRiskAssessmentData_Risk_FactorOneof_SmallMaster",
      "OdProtosRiskAssessmentData_Risk_FactorOneof_SunkenSpaces",
      "OdProtosRiskAssessmentData_Risk_FactorOneof_TrainTrack",
      "OdProtosRiskAssessmentData_Risk_FactorOneof_UnderRenovated",
      "OdProtosRiskAssessmentData_Risk_FactorOneof_UnsightlyNeighbor",
      "OdProtosRiskAssessmentData_Risk_FactorOneof_UnusualAdjustments"
    ],
    "OdProtosRiskAssessmentData_RoadRisk_OptionOneof": [
      "OdProtosRiskAssessmentData_RoadRisk_OptionOneof_ArterialRoad",
      "OdProtosRiskAssessmentData_RoadRisk_OptionOneof_ConnectorRoad",
      "OdProtosRiskAssessmentData_RoadRisk_OptionOneof_FreewayHighway",
      "OdProtosRiskAssessmentData_RoadRisk_OptionOneof_MainStreetWithinSubdivision"
    ],
    "OdProtosRiskAssessmentData_UnusualAdjustmentsRisk_OptionOneof": [
      "OdProtosRiskAssessmentData_UnusualAdjustmentsRisk_OptionOneof_GolfLot",
      "OdProtosRiskAssessmentData_UnusualAdjustmentsRisk_OptionOneof_WaterView"
    ],
    "OdProtosRiskAssessmentEvents_TaskEvent_EventOneof": [
      "OdProtosRiskAssessmentEvents_TaskEvent_EventOneof_ManualRiskAssessmentCompleted"
    ],
    "OdProtosRiskAssessmentServices_CreateCaseyTaskForTestingResponse_ResponseOneof": [
      "OdProtosRiskAssessmentServices_CreateCaseyTaskForTestingResponse_ResponseOneof_Error",
      "OdProtosRiskAssessmentServices_CreateCaseyTaskForTestingResponse_ResponseOneof_Success"
    ],
    "OdProtosRiskAssessmentServices_CreateRiskAssessmentResponse_ResponseOneof": [
      "OdProtosRiskAssessmentServices_CreateRiskAssessmentResponse_ResponseOneof_Error",
      "OdProtosRiskAssessmentServices_CreateRiskAssessmentResponse_ResponseOneof_Success"
    ],
    "OdProtosRiskAssessmentServices_GetReusableRiskAssessmentResponse_ResponseOneof": [
      "OdProtosRiskAssessmentServices_GetReusableRiskAssessmentResponse_ResponseOneof_Error",
      "OdProtosRiskAssessmentServices_GetReusableRiskAssessmentResponse_ResponseOneof_Success"
    ],
    "OdProtosRiskAssessmentServices_GetRiskAssessmentResponse_ResponseOneof": [
      "OdProtosRiskAssessmentServices_GetRiskAssessmentResponse_ResponseOneof_Error",
      "OdProtosRiskAssessmentServices_GetRiskAssessmentResponse_ResponseOneof_Success"
    ],
    "OdProtosRiskAssessmentServices_LogSkipDecisionResponse_ResponseOneof": [
      "OdProtosRiskAssessmentServices_LogSkipDecisionResponse_ResponseOneof_Error",
      "OdProtosRiskAssessmentServices_LogSkipDecisionResponse_ResponseOneof_Success"
    ],
    "OdProtosRiskAssessmentServices_RecordRiskAssessmentReuseResponse_ResponseOneof": [
      "OdProtosRiskAssessmentServices_RecordRiskAssessmentReuseResponse_ResponseOneof_Error",
      "OdProtosRiskAssessmentServices_RecordRiskAssessmentReuseResponse_ResponseOneof_Success"
    ],
    "OdProtosRiskAssessmentServices_StartManualRiskAssessmentResponse_ResponseOneof": [
      "OdProtosRiskAssessmentServices_StartManualRiskAssessmentResponse_ResponseOneof_Error",
      "OdProtosRiskAssessmentServices_StartManualRiskAssessmentResponse_ResponseOneof_Success"
    ],
    "OdProtosRiskAssessmentServices_TerminatePropertyEngagementResponse_ResponseOneof": [
      "OdProtosRiskAssessmentServices_TerminatePropertyEngagementResponse_ResponseOneof_Error",
      "OdProtosRiskAssessmentServices_TerminatePropertyEngagementResponse_ResponseOneof_Success"
    ],
    "OdProtosRollCallData_EnrollmentFilter_Operand_ValueOneof": [
      "OdProtosRollCallData_EnrollmentFilter_Operand_ValueOneof_ServiceValue",
      "OdProtosRollCallData_EnrollmentFilter_Operand_ValueOneof_StringValue",
      "OdProtosRollCallData_EnrollmentFilter_Operand_ValueOneof_StringValueList",
      "OdProtosRollCallData_EnrollmentFilter_Operand_ValueOneof_TimestampValue"
    ],
    "OdProtosRollCallEvents_EnrollmentEvent_EventOneof": [
      "OdProtosRollCallEvents_EnrollmentEvent_EventOneof_EnrollmentCanceled",
      "OdProtosRollCallEvents_EnrollmentEvent_EventOneof_EnrollmentCreated",
      "OdProtosRollCallEvents_EnrollmentEvent_EventOneof_EnrollmentUpdated"
    ],
    "OdProtosRubricData_Criterion_RubricItemOneof": [
      "OdProtosRubricData_Criterion_RubricItemOneof_PromptId",
      "OdProtosRubricData_Criterion_RubricItemOneof_StandardId"
    ],
    "OdProtosRubricEvents_PromptEvent_EventOneof": [
      "OdProtosRubricEvents_PromptEvent_EventOneof_DoorKeypadCode",
      "OdProtosRubricEvents_PromptEvent_EventOneof_GatedCommunityCodeResponse",
      "OdProtosRubricEvents_PromptEvent_EventOneof_KnoxSetupResponse",
      "OdProtosRubricEvents_PromptEvent_EventOneof_ListingPhotosResponse",
      "OdProtosRubricEvents_PromptEvent_EventOneof_ListingTypeResponse",
      "OdProtosRubricEvents_PromptEvent_EventOneof_OboActionResponse",
      "OdProtosRubricEvents_PromptEvent_EventOneof_Response"
    ],
    "OdProtosRubricEvents_ReportEvent_EventOneof": [
      "OdProtosRubricEvents_ReportEvent_EventOneof_Creation",
      "OdProtosRubricEvents_ReportEvent_EventOneof_Initialization"
    ],
    "OdProtosRubricV2Data_CorrelatedPromptResponse_ResponseOneof": [
      "OdProtosRubricV2Data_CorrelatedPromptResponse_ResponseOneof_Audios",
      "OdProtosRubricV2Data_CorrelatedPromptResponse_ResponseOneof_Photos",
      "OdProtosRubricV2Data_CorrelatedPromptResponse_ResponseOneof_SelectedOptions",
      "OdProtosRubricV2Data_CorrelatedPromptResponse_ResponseOneof_Text",
      "OdProtosRubricV2Data_CorrelatedPromptResponse_ResponseOneof_Videos"
    ],
    "OdProtosRubricV2Data_PromptBehavior_BehaviorOneof": [
      "OdProtosRubricV2Data_PromptBehavior_BehaviorOneof_ExternalActionTrigger",
      "OdProtosRubricV2Data_PromptBehavior_BehaviorOneof_FollowUpPrompt",
      "OdProtosRubricV2Data_PromptBehavior_BehaviorOneof_FollowUpPromptGroup",
      "OdProtosRubricV2Data_PromptBehavior_BehaviorOneof_PromptGroupAddition",
      "OdProtosRubricV2Data_PromptBehavior_BehaviorOneof_TextValidation"
    ],
    "OdProtosRubricV2Data_Prompt_ResponseOneof": [
      "OdProtosRubricV2Data_Prompt_ResponseOneof_Audios",
      "OdProtosRubricV2Data_Prompt_ResponseOneof_Photos",
      "OdProtosRubricV2Data_Prompt_ResponseOneof_SelectedOptions",
      "OdProtosRubricV2Data_Prompt_ResponseOneof_Text",
      "OdProtosRubricV2Data_Prompt_ResponseOneof_Videos"
    ],
    "OdProtosRubricV2Services_AnswerPromptRequest_ResponseOneof": [
      "OdProtosRubricV2Services_AnswerPromptRequest_ResponseOneof_Audios",
      "OdProtosRubricV2Services_AnswerPromptRequest_ResponseOneof_Photos",
      "OdProtosRubricV2Services_AnswerPromptRequest_ResponseOneof_SelectedOptions",
      "OdProtosRubricV2Services_AnswerPromptRequest_ResponseOneof_Text",
      "OdProtosRubricV2Services_AnswerPromptRequest_ResponseOneof_Videos"
    ],
    "OdProtosRubricV2Services_QuestionFilter_Expr_ExprOneof": [
      "OdProtosRubricV2Services_QuestionFilter_Expr_ExprOneof_And",
      "OdProtosRubricV2Services_QuestionFilter_Expr_ExprOneof_Or",
      "OdProtosRubricV2Services_QuestionFilter_Expr_ExprOneof_Pred"
    ],
    "OdProtosRubricV2Services_SearchReportQuestionsRequest_Expr_ExprOneof": [
      "OdProtosRubricV2Services_SearchReportQuestionsRequest_Expr_ExprOneof_And",
      "OdProtosRubricV2Services_SearchReportQuestionsRequest_Expr_ExprOneof_Filter",
      "OdProtosRubricV2Services_SearchReportQuestionsRequest_Expr_ExprOneof_Or"
    ],
    "OdProtosSalesCrmData_AssignedHSA_TypeOneof": [
      "OdProtosSalesCrmData_AssignedHSA_TypeOneof_Human",
      "OdProtosSalesCrmData_AssignedHSA_TypeOneof_VirtualAgent"
    ],
    "OdProtosSalesCrmData_Card_ExperimentOneof": [
      "OdProtosSalesCrmData_Card_ExperimentOneof_HigherOffer",
      "OdProtosSalesCrmData_Card_ExperimentOneof_Odlo",
      "OdProtosSalesCrmData_Card_ExperimentOneof_OdloHigherOffer"
    ],
    "OdProtosSalesCrmData_Comment_AnchorOneof": [
      "OdProtosSalesCrmData_Comment_AnchorOneof_TranscriptAnchor"
    ],
    "OdProtosSalesCrmData_DistributionRule_TargetOneof": [
      "OdProtosSalesCrmData_DistributionRule_TargetOneof_AgentId",
      "OdProtosSalesCrmData_DistributionRule_TargetOneof_Group"
    ],
    "OdProtosSalesCrmData_OutcomeDetails_DetailsOneof": [
      "OdProtosSalesCrmData_OutcomeDetails_DetailsOneof_AssessmentScheduled",
      "OdProtosSalesCrmData_OutcomeDetails_DetailsOneof_Failure",
      "OdProtosSalesCrmData_OutcomeDetails_DetailsOneof_MeetingBooked"
    ],
    "OdProtosSalesCrmData_SequenceAction_ActionOneof": [
      "OdProtosSalesCrmData_SequenceAction_ActionOneof_PhoneCall",
      "OdProtosSalesCrmData_SequenceAction_ActionOneof_Sms"
    ],
    "OdProtosSalesCrmServices_CreateCommentRequest_AnchorOneof": [
      "OdProtosSalesCrmServices_CreateCommentRequest_AnchorOneof_TranscriptAnchor"
    ],
    "OdProtosSellOpsTasks_MissedCommunicationsTaskData_OriginalPersonOneof": [
      "OdProtosSellOpsTasks_MissedCommunicationsTaskData_OriginalPersonOneof_ContactId",
      "OdProtosSellOpsTasks_MissedCommunicationsTaskData_OriginalPersonOneof_UserId"
    ],
    "OdProtosSellOpsTasks_ProactiveFollowUpTaskData_OriginalPersonOneof": [
      "OdProtosSellOpsTasks_ProactiveFollowUpTaskData_OriginalPersonOneof_ContactId",
      "OdProtosSellOpsTasks_ProactiveFollowUpTaskData_OriginalPersonOneof_UserId"
    ],
    "OdProtosSellOpsTasks_SellerFollowUpTaskData_OriginalPersonOneof": [
      "OdProtosSellOpsTasks_SellerFollowUpTaskData_OriginalPersonOneof_ContactId",
      "OdProtosSellOpsTasks_SellerFollowUpTaskData_OriginalPersonOneof_UserId"
    ],
    "OdProtosSellReceptionData_Answers_ExperimentalQuestionAnswer_SelectedValuesOneof": [
      "OdProtosSellReceptionData_Answers_ExperimentalQuestionAnswer_SelectedValuesOneof_DoubleValue",
      "OdProtosSellReceptionData_Answers_ExperimentalQuestionAnswer_SelectedValuesOneof_StringValues"
    ],
    "OdProtosSellReceptionEvents_SellerInputEvent_EventOneof": [
      "OdProtosSellReceptionEvents_SellerInputEvent_EventOneof_Created",
      "OdProtosSellReceptionEvents_SellerInputEvent_EventOneof_NewAnswers",
      "OdProtosSellReceptionEvents_SellerInputEvent_EventOneof_OnboardingCompleted",
      "OdProtosSellReceptionEvents_SellerInputEvent_EventOneof_ProductDenied",
      "OdProtosSellReceptionEvents_SellerInputEvent_EventOneof_ProductMatched",
      "OdProtosSellReceptionEvents_SellerInputEvent_EventOneof_ProductQualified",
      "OdProtosSellReceptionEvents_SellerInputEvent_EventOneof_ProductUndenied"
    ],
    "OdProtosSellSellerData_LeadId_LeadOneof": [
      "OdProtosSellSellerData_LeadId_LeadOneof_LeadId",
      "OdProtosSellSellerData_LeadId_LeadOneof_Source"
    ],
    "OdProtosSellSellerData_Offer_DetailsOneof": [
      "OdProtosSellSellerData_Offer_DetailsOneof_AgentReferral",
      "OdProtosSellSellerData_Offer_DetailsOneof_ListWithOpendoorOffer",
      "OdProtosSellSellerData_Offer_DetailsOneof_OpendoorOffer",
      "OdProtosSellSellerData_Offer_DetailsOneof_ReitOffer"
    ],
    "OdProtosSellSellerData_ProductSpecificData_DataOneof": [
      "OdProtosSellSellerData_ProductSpecificData_DataOneof_AgentReferral",
      "OdProtosSellSellerData_ProductSpecificData_DataOneof_ListWithOpendoor",
      "OdProtosSellSellerData_ProductSpecificData_DataOneof_OpendoorDirect",
      "OdProtosSellSellerData_ProductSpecificData_DataOneof_Reit"
    ],
    "OdProtosSellSellerEvents_SellerLeadEvent_EventOneof": [
      "OdProtosSellSellerEvents_SellerLeadEvent_EventOneof_AcquisitionUnderwritingDecisionDetermined",
      "OdProtosSellSellerEvents_SellerLeadEvent_EventOneof_Created",
      "OdProtosSellSellerEvents_SellerLeadEvent_EventOneof_OfferAccepted",
      "OdProtosSellSellerEvents_SellerLeadEvent_EventOneof_OfferClosed",
      "OdProtosSellSellerEvents_SellerLeadEvent_EventOneof_OfferEnteredContract",
      "OdProtosSellSellerEvents_SellerLeadEvent_EventOneof_OfferExpired",
      "OdProtosSellSellerEvents_SellerLeadEvent_EventOneof_OfferExpiringSoon",
      "OdProtosSellSellerEvents_SellerLeadEvent_EventOneof_OfferProductSpecificDataUpdated",
      "OdProtosSellSellerEvents_SellerLeadEvent_EventOneof_OfferReceived",
      "OdProtosSellSellerEvents_SellerLeadEvent_EventOneof_OfferRefreshRequested",
      "OdProtosSellSellerEvents_SellerLeadEvent_EventOneof_OfferReleasedContingencies",
      "OdProtosSellSellerEvents_SellerLeadEvent_EventOneof_OfferReviewCanceled",
      "OdProtosSellSellerEvents_SellerLeadEvent_EventOneof_OfferReviewCreated",
      "OdProtosSellSellerEvents_SellerLeadEvent_EventOneof_OfferSent",
      "OdProtosSellSellerEvents_SellerLeadEvent_EventOneof_OfferUpdated",
      "OdProtosSellSellerEvents_SellerLeadEvent_EventOneof_OfferViewed",
      "OdProtosSellSellerEvents_SellerLeadEvent_EventOneof_OfferWithdrawn",
      "OdProtosSellSellerEvents_SellerLeadEvent_EventOneof_ProductDenied",
      "OdProtosSellSellerEvents_SellerLeadEvent_EventOneof_ProductDeselected",
      "OdProtosSellSellerEvents_SellerLeadEvent_EventOneof_ProductQualified",
      "OdProtosSellSellerEvents_SellerLeadEvent_EventOneof_ProductSelected",
      "OdProtosSellSellerEvents_SellerLeadEvent_EventOneof_ProductUndenied",
      "OdProtosSellSellerEvents_SellerLeadEvent_EventOneof_Updated"
    ],
    "OdProtosSellSellerServices_GetLeadRequest_LeadOneof": [
      "OdProtosSellSellerServices_GetLeadRequest_LeadOneof_LeadId",
      "OdProtosSellSellerServices_GetLeadRequest_LeadOneof_Source"
    ],
    "OdProtosSellSellerServices_ListLeadsRequest_IdentifiersOneof": [
      "OdProtosSellSellerServices_ListLeadsRequest_IdentifiersOneof_CustomerIds",
      "OdProtosSellSellerServices_ListLeadsRequest_IdentifiersOneof_LeadUuids"
    ],
    "OdProtosSellSellerServices_UpdateLeadRequest_LeadOneof": [
      "OdProtosSellSellerServices_UpdateLeadRequest_LeadOneof_LeadId",
      "OdProtosSellSellerServices_UpdateLeadRequest_LeadOneof_Source"
    ],
    "OdProtosSellSellerServices_WithdrawFromProductRequest_WithdrawalReasonOneof": [
      "OdProtosSellSellerServices_WithdrawFromProductRequest_WithdrawalReasonOneof_OpendoorWalkReason",
      "OdProtosSellSellerServices_WithdrawFromProductRequest_WithdrawalReasonOneof_SellerWalkReason"
    ],
    "OdProtosSellWebEvents_LeadEvent_EventOneof": [
      "OdProtosSellWebEvents_LeadEvent_EventOneof_ClosingManagerUpdated",
      "OdProtosSellWebEvents_LeadEvent_EventOneof_ExteriorAssessmentCanceled",
      "OdProtosSellWebEvents_LeadEvent_EventOneof_ExteriorAssessmentRescheduled",
      "OdProtosSellWebEvents_LeadEvent_EventOneof_ExteriorAssessmentScheduled",
      "OdProtosSellWebEvents_LeadEvent_EventOneof_HomeAdvisorUpdated",
      "OdProtosSellWebEvents_LeadEvent_EventOneof_LeadChannelUpdated",
      "OdProtosSellWebEvents_LeadEvent_EventOneof_ListWithCertaintyEnrollmentChanged",
      "OdProtosSellWebEvents_LeadEvent_EventOneof_ManualDenial",
      "OdProtosSellWebEvents_LeadEvent_EventOneof_OfferRefreshRequested",
      "OdProtosSellWebEvents_LeadEvent_EventOneof_OfferReviewCompleted",
      "OdProtosSellWebEvents_LeadEvent_EventOneof_OrvaNoteCreated",
      "OdProtosSellWebEvents_LeadEvent_EventOneof_PartnerReferralsUpdated",
      "OdProtosSellWebEvents_LeadEvent_EventOneof_PricingRoutingEventCreated",
      "OdProtosSellWebEvents_LeadEvent_EventOneof_VideoWalkthroughCanceled",
      "OdProtosSellWebEvents_LeadEvent_EventOneof_VideoWalkthroughCompleted",
      "OdProtosSellWebEvents_LeadEvent_EventOneof_VideoWalkthroughNoShow",
      "OdProtosSellWebEvents_LeadEvent_EventOneof_VideoWalkthroughScheduled"
    ],
    "OdProtosSellWebEvents_OpendoorDirectOfferEvent_COEChanged_PreviousCoeOneof": [
      "OdProtosSellWebEvents_OpendoorDirectOfferEvent_COEChanged_PreviousCoeOneof_NoPreviousCoe",
      "OdProtosSellWebEvents_OpendoorDirectOfferEvent_COEChanged_PreviousCoeOneof_PreviousCoeTimestamp"
    ],
    "OdProtosSellWebEvents_OpendoorDirectOfferEvent_EventOneof": [
      "OdProtosSellWebEvents_OpendoorDirectOfferEvent_EventOneof_Accepted",
      "OdProtosSellWebEvents_OpendoorDirectOfferEvent_EventOneof_Closed",
      "OdProtosSellWebEvents_OpendoorDirectOfferEvent_EventOneof_CoeChanged",
      "OdProtosSellWebEvents_OpendoorDirectOfferEvent_EventOneof_Created",
      "OdProtosSellWebEvents_OpendoorDirectOfferEvent_EventOneof_EnteredContract",
      "OdProtosSellWebEvents_OpendoorDirectOfferEvent_EventOneof_Expired",
      "OdProtosSellWebEvents_OpendoorDirectOfferEvent_EventOneof_ExpiringSoon",
      "OdProtosSellWebEvents_OpendoorDirectOfferEvent_EventOneof_OfferReviewCreated",
      "OdProtosSellWebEvents_OpendoorDirectOfferEvent_EventOneof_RecordedPriceFinalized",
      "OdProtosSellWebEvents_OpendoorDirectOfferEvent_EventOneof_ReleasedContingencies",
      "OdProtosSellWebEvents_OpendoorDirectOfferEvent_EventOneof_SendOfferMailer",
      "OdProtosSellWebEvents_OpendoorDirectOfferEvent_EventOneof_Sent",
      "OdProtosSellWebEvents_OpendoorDirectOfferEvent_EventOneof_Updated",
      "OdProtosSellWebEvents_OpendoorDirectOfferEvent_EventOneof_UpdatedExpiresAt",
      "OdProtosSellWebEvents_OpendoorDirectOfferEvent_EventOneof_Viewed",
      "OdProtosSellWebEvents_OpendoorDirectOfferEvent_EventOneof_Walked",
      "OdProtosSellWebEvents_OpendoorDirectOfferEvent_EventOneof_Withdrawn"
    ],
    "OdProtosSellWebEvents_ReitOfferEvent_EventOneof": [
      "OdProtosSellWebEvents_ReitOfferEvent_EventOneof_Accepted",
      "OdProtosSellWebEvents_ReitOfferEvent_EventOneof_Closed",
      "OdProtosSellWebEvents_ReitOfferEvent_EventOneof_Created",
      "OdProtosSellWebEvents_ReitOfferEvent_EventOneof_EnteredContract",
      "OdProtosSellWebEvents_ReitOfferEvent_EventOneof_Expired",
      "OdProtosSellWebEvents_ReitOfferEvent_EventOneof_Sent",
      "OdProtosSellWebEvents_ReitOfferEvent_EventOneof_UpdatedExpiresAt",
      "OdProtosSellWebEvents_ReitOfferEvent_EventOneof_Withdrawn"
    ],
    "OdProtosServiceRegistry_DBSyncTransform_TransformOneof": [
      "OdProtosServiceRegistry_DBSyncTransform_TransformOneof_ObfuscateColumns",
      "OdProtosServiceRegistry_DBSyncTransform_TransformOneof_SqlScript",
      "OdProtosServiceRegistry_DBSyncTransform_TransformOneof_TruncateTable"
    ],
    "OdProtosServiceRegistry_DataStore_DataStoreOneof": [
      "OdProtosServiceRegistry_DataStore_DataStoreOneof_Elasticsearch",
      "OdProtosServiceRegistry_DataStore_DataStoreOneof_Postgres",
      "OdProtosServiceRegistry_DataStore_DataStoreOneof_Redis"
    ],
    "OdProtosSettlerEvents_RecordsTitleEscrowLifecycleEvent_EventOneof": [
      "OdProtosSettlerEvents_RecordsTitleEscrowLifecycleEvent_EventOneof_TitleEscrowLifecycleEvent"
    ],
    "OdProtosSettlerEvents_RecordsTitleFileEvent_EventOneof": [
      "OdProtosSettlerEvents_RecordsTitleFileEvent_EventOneof_AddDocumentFailed",
      "OdProtosSettlerEvents_RecordsTitleFileEvent_EventOneof_CancelFileFailed",
      "OdProtosSettlerEvents_RecordsTitleFileEvent_EventOneof_CancelFileSucceeded",
      "OdProtosSettlerEvents_RecordsTitleFileEvent_EventOneof_CreateFileApiFailed",
      "OdProtosSettlerEvents_RecordsTitleFileEvent_EventOneof_CreateFileFailed",
      "OdProtosSettlerEvents_RecordsTitleFileEvent_EventOneof_CreateFileSucceeded",
      "OdProtosSettlerEvents_RecordsTitleFileEvent_EventOneof_CreateReviewOnlyFileFailed",
      "OdProtosSettlerEvents_RecordsTitleFileEvent_EventOneof_CreateReviewOnlyFileSucceeded",
      "OdProtosSettlerEvents_RecordsTitleFileEvent_EventOneof_CreateTitleOnlyFileFailed",
      "OdProtosSettlerEvents_RecordsTitleFileEvent_EventOneof_CreateTitleOnlyFileSucceeded",
      "OdProtosSettlerEvents_RecordsTitleFileEvent_EventOneof_ExternalDocumentUploaded",
      "OdProtosSettlerEvents_RecordsTitleFileEvent_EventOneof_SendEmailFailed",
      "OdProtosSettlerEvents_RecordsTitleFileEvent_EventOneof_UpdateFileTitlePrecloserFailed",
      "OdProtosSettlerEvents_RecordsTitleFileEvent_EventOneof_UpdateFileTitlePrecloserSucceeded"
    ],
    "OdProtosSettlerServices_CreateFileRequest_BuyerOneof": [
      "OdProtosSettlerServices_CreateFileRequest_BuyerOneof_BuyerCorporation",
      "OdProtosSettlerServices_CreateFileRequest_BuyerOneof_BuyerIndividual",
      "OdProtosSettlerServices_CreateFileRequest_BuyerOneof_BuyerPartnership"
    ],
    "OdProtosSettlerServices_CreateFileRequest_SellerOneof": [
      "OdProtosSettlerServices_CreateFileRequest_SellerOneof_SellerCorporation",
      "OdProtosSettlerServices_CreateFileRequest_SellerOneof_SellerIndividual",
      "OdProtosSettlerServices_CreateFileRequest_SellerOneof_SellerPartnership"
    ],
    "OdProtosSettlerServices_ListCoordinatorsForFilesRequest_ParamsOneof": [
      "OdProtosSettlerServices_ListCoordinatorsForFilesRequest_ParamsOneof_Search"
    ],
    "OdProtosSettlerServices_UpdateFileParticipantsRequest_BuyerOneof": [
      "OdProtosSettlerServices_UpdateFileParticipantsRequest_BuyerOneof_BuyerCorporation",
      "OdProtosSettlerServices_UpdateFileParticipantsRequest_BuyerOneof_BuyerIndividual",
      "OdProtosSettlerServices_UpdateFileParticipantsRequest_BuyerOneof_BuyerPartnership"
    ],
    "OdProtosSettlerServices_UpdateFileParticipantsRequest_SellerOneof": [
      "OdProtosSettlerServices_UpdateFileParticipantsRequest_SellerOneof_SellerCorporation",
      "OdProtosSettlerServices_UpdateFileParticipantsRequest_SellerOneof_SellerIndividual",
      "OdProtosSettlerServices_UpdateFileParticipantsRequest_SellerOneof_SellerPartnership"
    ],
    "OdProtosSettlerServices_UpdateFileParticipantsResponse_BuyerOneof": [
      "OdProtosSettlerServices_UpdateFileParticipantsResponse_BuyerOneof_BuyerCorporation",
      "OdProtosSettlerServices_UpdateFileParticipantsResponse_BuyerOneof_BuyerIndividual",
      "OdProtosSettlerServices_UpdateFileParticipantsResponse_BuyerOneof_BuyerPartnership"
    ],
    "OdProtosSettlerServices_UpdateFileParticipantsResponse_SellerOneof": [
      "OdProtosSettlerServices_UpdateFileParticipantsResponse_SellerOneof_SellerCorporation",
      "OdProtosSettlerServices_UpdateFileParticipantsResponse_SellerOneof_SellerIndividual",
      "OdProtosSettlerServices_UpdateFileParticipantsResponse_SellerOneof_SellerPartnership"
    ],
    "OdProtosSignalsServices_CompAvailability_StatusOneof": [
      "OdProtosSignalsServices_CompAvailability_StatusOneof_Unusable",
      "OdProtosSignalsServices_CompAvailability_StatusOneof_Usable"
    ],
    "OdProtosSignalsServices_FetchCompsAvailabilityResponse_StatusOneof": [
      "OdProtosSignalsServices_FetchCompsAvailabilityResponse_StatusOneof_Error",
      "OdProtosSignalsServices_FetchCompsAvailabilityResponse_StatusOneof_Success"
    ],
    "OdProtosSignalsServices_FetchHpiResponse_StatusOneof": [
      "OdProtosSignalsServices_FetchHpiResponse_StatusOneof_Error",
      "OdProtosSignalsServices_FetchHpiResponse_StatusOneof_Success"
    ],
    "OdProtosSignalsServices_FetchHybridOVMLineItemAdjustmentsResponse_StatusOneof": [
      "OdProtosSignalsServices_FetchHybridOVMLineItemAdjustmentsResponse_StatusOneof_Error",
      "OdProtosSignalsServices_FetchHybridOVMLineItemAdjustmentsResponse_StatusOneof_Success"
    ],
    "OdProtosSupportData_ZendeskTicket_RequesterOneof": [
      "OdProtosSupportData_ZendeskTicket_RequesterOneof_ExternalCustomerId",
      "OdProtosSupportData_ZendeskTicket_RequesterOneof_ExternalCustomerUuid",
      "OdProtosSupportData_ZendeskTicket_RequesterOneof_OdRequesterId"
    ],
    "OdProtosSupportEvents_ZendeskTicketEvent_EventOneof": [
      "OdProtosSupportEvents_ZendeskTicketEvent_EventOneof_Create",
      "OdProtosSupportEvents_ZendeskTicketEvent_EventOneof_Update"
    ],
    "OdProtosSupportServices_AddCommentToTicketRequest_AuthorOneof": [
      "OdProtosSupportServices_AddCommentToTicketRequest_AuthorOneof_CustomerId",
      "OdProtosSupportServices_AddCommentToTicketRequest_AuthorOneof_UserToken"
    ],
    "OdProtosSupportServices_AddCommentToTicketRequest_IdentifierOneof": [
      "OdProtosSupportServices_AddCommentToTicketRequest_IdentifierOneof_Id",
      "OdProtosSupportServices_AddCommentToTicketRequest_IdentifierOneof_ZendeskTicketId"
    ],
    "OdProtosSupportServices_AssignTicketRequest_IdentifierOneof": [
      "OdProtosSupportServices_AssignTicketRequest_IdentifierOneof_Id",
      "OdProtosSupportServices_AssignTicketRequest_IdentifierOneof_ZendeskTicketId"
    ],
    "OdProtosSupportServices_AssociateRecordToTicketRequest_IdentifierOneof": [
      "OdProtosSupportServices_AssociateRecordToTicketRequest_IdentifierOneof_Id",
      "OdProtosSupportServices_AssociateRecordToTicketRequest_IdentifierOneof_ZendeskTicketId"
    ],
    "OdProtosSupportServices_CreateTicketRequest_AdditionalTicketFieldsOneof": [
      "OdProtosSupportServices_CreateTicketRequest_AdditionalTicketFieldsOneof_AssessmentFailureFields",
      "OdProtosSupportServices_CreateTicketRequest_AdditionalTicketFieldsOneof_BrokerRejectionOfDocumentFields",
      "OdProtosSupportServices_CreateTicketRequest_AdditionalTicketFieldsOneof_ContractChangeFields",
      "OdProtosSupportServices_CreateTicketRequest_AdditionalTicketFieldsOneof_HomeIssuesAcquisitionFields",
      "OdProtosSupportServices_CreateTicketRequest_AdditionalTicketFieldsOneof_IdentityEscalationFields",
      "OdProtosSupportServices_CreateTicketRequest_AdditionalTicketFieldsOneof_InPersonVaRequestAcquisitionFields",
      "OdProtosSupportServices_CreateTicketRequest_AdditionalTicketFieldsOneof_MarketOpsEscalationsFields",
      "OdProtosSupportServices_CreateTicketRequest_AdditionalTicketFieldsOneof_SolarTicketFields"
    ],
    "OdProtosSupportServices_CreateTicketRequest_RequesterOneof": [
      "OdProtosSupportServices_CreateTicketRequest_RequesterOneof_CustomerId",
      "OdProtosSupportServices_CreateTicketRequest_RequesterOneof_RequesterEmail",
      "OdProtosSupportServices_CreateTicketRequest_RequesterOneof_UserToken"
    ],
    "OdProtosSupportServices_DisassociateRecordFromTicketRequest_IdentifierOneof": [
      "OdProtosSupportServices_DisassociateRecordFromTicketRequest_IdentifierOneof_Id",
      "OdProtosSupportServices_DisassociateRecordFromTicketRequest_IdentifierOneof_ZendeskTicketId"
    ],
    "OdProtosSupportServices_UpdateOriginatingRecordForTicketRequest_TicketIdentifierOneof": [
      "OdProtosSupportServices_UpdateOriginatingRecordForTicketRequest_TicketIdentifierOneof_ZendeskTicketId"
    ],
    "OdProtosThirdPartyMarketplaceListingPe_DomainEvent_TypeOneof": [
      "OdProtosThirdPartyMarketplaceListingPe_DomainEvent_TypeOneof_AcceptedOfferTypesUpdated",
      "OdProtosThirdPartyMarketplaceListingPe_DomainEvent_TypeOneof_BuyerCommitted",
      "OdProtosThirdPartyMarketplaceListingPe_DomainEvent_TypeOneof_BuyerUncommitted",
      "OdProtosThirdPartyMarketplaceListingPe_DomainEvent_TypeOneof_ExpectedSellableDateUpdated",
      "OdProtosThirdPartyMarketplaceListingPe_DomainEvent_TypeOneof_HeadlinePriceUpdated",
      "OdProtosThirdPartyMarketplaceListingPe_DomainEvent_TypeOneof_PhotosReady",
      "OdProtosThirdPartyMarketplaceListingPe_DomainEvent_TypeOneof_RemoteEntryAvailable",
      "OdProtosThirdPartyMarketplaceListingPe_DomainEvent_TypeOneof_RemoteEntryUnavailable",
      "OdProtosThirdPartyMarketplaceListingPe_DomainEvent_TypeOneof_SellerCommitted",
      "OdProtosThirdPartyMarketplaceListingPe_DomainEvent_TypeOneof_SellingHalted",
      "OdProtosThirdPartyMarketplaceListingPe_DomainEvent_TypeOneof_SellingStarted",
      "OdProtosThirdPartyMarketplaceListingPe_DomainEvent_TypeOneof_Terminated"
    ],
    "OdProtosTrippyEvents_VisitEvent_EventOneof": [
      "OdProtosTrippyEvents_VisitEvent_EventOneof_AssignedUserChange",
      "OdProtosTrippyEvents_VisitEvent_EventOneof_Cancel",
      "OdProtosTrippyEvents_VisitEvent_EventOneof_CheckOut",
      "OdProtosTrippyEvents_VisitEvent_EventOneof_Create",
      "OdProtosTrippyEvents_VisitEvent_EventOneof_Followup",
      "OdProtosTrippyEvents_VisitEvent_EventOneof_Reject",
      "OdProtosTrippyEvents_VisitEvent_EventOneof_ScheduleChange",
      "OdProtosTrippyEvents_VisitEvent_EventOneof_ScheduledStart",
      "OdProtosTrippyEvents_VisitEvent_EventOneof_ScheduledStop",
      "OdProtosTrippyEvents_VisitEvent_EventOneof_Upcoming"
    ],
    "OdProtosTrippyServices_TimestampParam_ParamsOneof": [
      "OdProtosTrippyServices_TimestampParam_ParamsOneof_TimeRange",
      "OdProtosTrippyServices_TimestampParam_ParamsOneof_Unset"
    ],
    "OdProtosTrustEvents_TrustLevelEvent_EventOneof": [
      "OdProtosTrustEvents_TrustLevelEvent_EventOneof_Change"
    ],
    "OdProtosValidataData_ConfidenceThresholds_ThresholdOneof": [
      "OdProtosValidataData_ConfidenceThresholds_ThresholdOneof_AbsoluteValueThreshold",
      "OdProtosValidataData_ConfidenceThresholds_ThresholdOneof_PercentageThreshold"
    ],
    "OdProtosValidataEvents_RecordsDataQualityTaskEvent_EventOneof": [
      "OdProtosValidataEvents_RecordsDataQualityTaskEvent_EventOneof_DataQualityTaskCompleted"
    ],
    "OdProtosValuationsServicesValuations_GetMergedCompsForClosestValuationResponse_ResponseOneof": [
      "OdProtosValuationsServicesValuations_GetMergedCompsForClosestValuationResponse_ResponseOneof_Error",
      "OdProtosValuationsServicesValuations_GetMergedCompsForClosestValuationResponse_ResponseOneof_Success"
    ],
    "OdProtosValuationsServicesValuations_GetMergedCompsForClosestValuationResponse_Success_SelectedValuationKindOneof": [
      "OdProtosValuationsServicesValuations_GetMergedCompsForClosestValuationResponse_Success_SelectedValuationKindOneof_EnsembledValuationId",
      "OdProtosValuationsServicesValuations_GetMergedCompsForClosestValuationResponse_Success_SelectedValuationKindOneof_ValuationId"
    ],
    "OdProtosValuationsServicesValuations_GetMergedCompsForValuationRequest_ValuationKindOneof": [
      "OdProtosValuationsServicesValuations_GetMergedCompsForValuationRequest_ValuationKindOneof_EnsembledValuationId",
      "OdProtosValuationsServicesValuations_GetMergedCompsForValuationRequest_ValuationKindOneof_ValuationId"
    ],
    "OdProtosValuationsServicesValuations_GetMergedCompsForValuationResponse_ResponseOneof": [
      "OdProtosValuationsServicesValuations_GetMergedCompsForValuationResponse_ResponseOneof_Error",
      "OdProtosValuationsServicesValuations_GetMergedCompsForValuationResponse_ResponseOneof_Success"
    ],
    "OdProtosValuationsServicesValuations_GetValuationResponse_ResponseOneof": [
      "OdProtosValuationsServicesValuations_GetValuationResponse_ResponseOneof_Error",
      "OdProtosValuationsServicesValuations_GetValuationResponse_ResponseOneof_Success"
    ],
    "OdProtosVariantData_Grain_CustomerGrain_PrimaryIdOneof": [
      "OdProtosVariantData_Grain_CustomerGrain_PrimaryIdOneof_CustomerUuid"
    ],
    "OdProtosVariantData_Grain_CustomerGrain_TemporaryIdOneof": [
      "OdProtosVariantData_Grain_CustomerGrain_TemporaryIdOneof_AnonymousId"
    ],
    "OdProtosVariantData_Grain_GrainOneof": [
      "OdProtosVariantData_Grain_GrainOneof_Customer",
      "OdProtosVariantData_Grain_GrainOneof_Operator",
      "OdProtosVariantData_Grain_GrainOneof_Property"
    ],
    "OdProtosVariantData_Grain_IdOneof": [
      "OdProtosVariantData_Grain_IdOneof_AnonymousId",
      "OdProtosVariantData_Grain_IdOneof_CustomerUuid"
    ],
    "OdProtosVariantData_Grain_OperatorGrain_PrimaryIdOneof": [
      "OdProtosVariantData_Grain_OperatorGrain_PrimaryIdOneof_HumanToken"
    ],
    "OdProtosVariantData_Grain_PropertyGrain_PrimaryIdOneof": [
      "OdProtosVariantData_Grain_PropertyGrain_PrimaryIdOneof_AddressToken"
    ],
    "OdProtosVariantData_Grain_PropertyGrain_TemporaryIdOneof": [
      "OdProtosVariantData_Grain_PropertyGrain_TemporaryIdOneof_PropertyEngagementId"
    ],
    "OdProtosVariantV2Data_Grain_CustomerGrain_TemporaryIdOneof": [
      "OdProtosVariantV2Data_Grain_CustomerGrain_TemporaryIdOneof_AnonymousId"
    ],
    "OdProtosVariantV2Data_Grain_GrainOneof": [
      "OdProtosVariantV2Data_Grain_GrainOneof_Customer",
      "OdProtosVariantV2Data_Grain_GrainOneof_Lead",
      "OdProtosVariantV2Data_Grain_GrainOneof_Operator",
      "OdProtosVariantV2Data_Grain_GrainOneof_Property"
    ],
    "OdProtosVariantV2Data_Grain_PropertyGrain_TemporaryIdOneof": [
      "OdProtosVariantV2Data_Grain_PropertyGrain_TemporaryIdOneof_PropertyEngagementId"
    ],
    "OdProtosVendorsData_Capability_ConfigurationOneof": [
      "OdProtosVendorsData_Capability_ConfigurationOneof_D1WConfiguration"
    ],
    "OdProtosVendorsServices_SearchVendorBranchesPaginatedRequest_LocationOneof": [
      "OdProtosVendorsServices_SearchVendorBranchesPaginatedRequest_LocationOneof_AddressUuid",
      "OdProtosVendorsServices_SearchVendorBranchesPaginatedRequest_LocationOneof_CasaAddress",
      "OdProtosVendorsServices_SearchVendorBranchesPaginatedRequest_LocationOneof_RegionIds"
    ],
    "OdProtosWebData_AssessmentStep_StepOneof": [
      "OdProtosWebData_AssessmentStep_StepOneof_DiligenceVisitStep",
      "OdProtosWebData_AssessmentStep_StepOneof_InspectionStep",
      "OdProtosWebData_AssessmentStep_StepOneof_OfferReviewStep",
      "OdProtosWebData_AssessmentStep_StepOneof_VirtualAssessmentStep"
    ],
    "OdProtosWebData_CancellationRequest_SecondaryReasonOneof": [
      "OdProtosWebData_CancellationRequest_SecondaryReasonOneof_OpendoorWalkReason",
      "OdProtosWebData_CancellationRequest_SecondaryReasonOneof_SellerInitiatedReason"
    ],
    "OdProtosWebData_CommunicationData_TypeOneof": [
      "OdProtosWebData_CommunicationData_TypeOneof_EmailConversation"
    ],
    "OdProtosWebData_ExperimentValue_ValueOneof": [
      "OdProtosWebData_ExperimentValue_ValueOneof_BooleanValue",
      "OdProtosWebData_ExperimentValue_ValueOneof_Data",
      "OdProtosWebData_ExperimentValue_ValueOneof_StringValue"
    ],
    "OdProtosWebData_GuidanceDataPoint_DataPointOneof": [
      "OdProtosWebData_GuidanceDataPoint_DataPointOneof_CentsDeltaSincePreviousPrelimOffer",
      "OdProtosWebData_GuidanceDataPoint_DataPointOneof_InternalFee"
    ],
    "OdProtosWebData_LeadIdentifier_LeadOneof": [
      "OdProtosWebData_LeadIdentifier_LeadOneof_Params",
      "OdProtosWebData_LeadIdentifier_LeadOneof_SellerLeadUuid",
      "OdProtosWebData_LeadIdentifier_LeadOneof_Source",
      "OdProtosWebData_LeadIdentifier_LeadOneof_Token"
    ],
    "OdProtosWebData_ListingOfferCustomers_AgentTcOneof": [
      "OdProtosWebData_ListingOfferCustomers_AgentTcOneof_AgentTcCustomer",
      "OdProtosWebData_ListingOfferCustomers_AgentTcOneof_AgentTcName"
    ],
    "OdProtosWebData_ListingOfferCustomers_Buyer2Oneof": [
      "OdProtosWebData_ListingOfferCustomers_Buyer2Oneof_Buyer2Customer",
      "OdProtosWebData_ListingOfferCustomers_Buyer2Oneof_Buyer2Name"
    ],
    "OdProtosWebData_ListingOfferCustomers_BuyerOneof": [
      "OdProtosWebData_ListingOfferCustomers_BuyerOneof_BuyerCustomer",
      "OdProtosWebData_ListingOfferCustomers_BuyerOneof_BuyerName"
    ],
    "OdProtosWebData_ListingOfferCustomers_ContactOneof": [
      "OdProtosWebData_ListingOfferCustomers_ContactOneof_ContactCustomer",
      "OdProtosWebData_ListingOfferCustomers_ContactOneof_ContactEmail",
      "OdProtosWebData_ListingOfferCustomers_ContactOneof_ContactName"
    ],
    "OdProtosWebData_ListingOfferParticipant_IdentifierOneof": [
      "OdProtosWebData_ListingOfferParticipant_IdentifierOneof_CustomerUuid"
    ],
    "OdProtosWebData_MessageData_TypeOneof": [
      "OdProtosWebData_MessageData_TypeOneof_Call",
      "OdProtosWebData_MessageData_TypeOneof_Email",
      "OdProtosWebData_MessageData_TypeOneof_Sms",
      "OdProtosWebData_MessageData_TypeOneof_Voicemail"
    ],
    "OdProtosWebData_Transaction_Financing_FinancingOneof": [
      "OdProtosWebData_Transaction_Financing_FinancingOneof_CashFinancing",
      "OdProtosWebData_Transaction_Financing_FinancingOneof_LoanFinancing"
    ],
    "OdProtosWebData_Transaction_Financing_LoanFinancing_LoanOneof": [
      "OdProtosWebData_Transaction_Financing_LoanFinancing_LoanOneof_ConventionalLoan",
      "OdProtosWebData_Transaction_Financing_LoanFinancing_LoanOneof_FhaLoan",
      "OdProtosWebData_Transaction_Financing_LoanFinancing_LoanOneof_UsdaLoan",
      "OdProtosWebData_Transaction_Financing_LoanFinancing_LoanOneof_VaLoan"
    ],
    "OdProtosWebData_Transaction_LateCheckoutV2_LateCheckoutOneof": [
      "OdProtosWebData_Transaction_LateCheckoutV2_LateCheckoutOneof_InterestedLateCheckout",
      "OdProtosWebData_Transaction_LateCheckoutV2_LateCheckoutOneof_NotInterestedLateCheckout"
    ],
    "OdProtosWebData_Transaction_Participant_ParticipantOneof": [
      "OdProtosWebData_Transaction_Participant_ParticipantOneof_BasicParticipant",
      "OdProtosWebData_Transaction_Participant_ParticipantOneof_CustomerParticipant",
      "OdProtosWebData_Transaction_Participant_ParticipantOneof_HumanParticipant",
      "OdProtosWebData_Transaction_Participant_ParticipantOneof_OrganizationParticipant"
    ],
    "OdProtosWebData_Transaction_TransactionSource_SourceOneof": [
      "OdProtosWebData_Transaction_TransactionSource_SourceOneof_Web"
    ],
    "OdProtosWebData_Underwriting_ValuationOneof": [
      "OdProtosWebData_Underwriting_ValuationOneof_EnsembledValuationId",
      "OdProtosWebData_Underwriting_ValuationOneof_ValuationId"
    ],
    "OdProtosWebData_VirtualAssessmentStep_StepOneof": [
      "OdProtosWebData_VirtualAssessmentStep_StepOneof_OrvaStep",
      "OdProtosWebData_VirtualAssessmentStep_StepOneof_SsvaStep"
    ],
    "OdProtosWebEvents_AddendumEvent_EventOneof": [
      "OdProtosWebEvents_AddendumEvent_EventOneof_Created",
      "OdProtosWebEvents_AddendumEvent_EventOneof_State"
    ],
    "OdProtosWebEvents_CoreCustomerEvent_EventOneof": [
      "OdProtosWebEvents_CoreCustomerEvent_EventOneof_CustomerCommPreferenceUpdated",
      "OdProtosWebEvents_CoreCustomerEvent_EventOneof_CustomerMerged",
      "OdProtosWebEvents_CoreCustomerEvent_EventOneof_CustomerSubscribed",
      "OdProtosWebEvents_CoreCustomerEvent_EventOneof_CustomerUnsubscribed",
      "OdProtosWebEvents_CoreCustomerEvent_EventOneof_CustomerUpserted",
      "OdProtosWebEvents_CoreCustomerEvent_EventOneof_EmailChanged",
      "OdProtosWebEvents_CoreCustomerEvent_EventOneof_PhoneNumberChanged"
    ],
    "OdProtosWebEvents_CustomerDataEvent_EventOneof": [
      "OdProtosWebEvents_CustomerDataEvent_EventOneof_EmailUpdated"
    ],
    "OdProtosWebEvents_DigitalCheckoutEvent_EventOneof": [
      "OdProtosWebEvents_DigitalCheckoutEvent_EventOneof_Approved",
      "OdProtosWebEvents_DigitalCheckoutEvent_EventOneof_Submitted"
    ],
    "OdProtosWebEvents_DocumentEvent_EventOneof": [
      "OdProtosWebEvents_DocumentEvent_EventOneof_Reviewed",
      "OdProtosWebEvents_DocumentEvent_EventOneof_Uploaded"
    ],
    "OdProtosWebEvents_ElasticSearchIndexUpdateEvent_EventOneof": [
      "OdProtosWebEvents_ElasticSearchIndexUpdateEvent_EventOneof_ElasticSearchUpdate"
    ],
    "OdProtosWebEvents_ExternalListingEvent_EventOneof": [
      "OdProtosWebEvents_ExternalListingEvent_EventOneof_ExternalListing"
    ],
    "OdProtosWebEvents_FlipEvent_EventOneof": [
      "OdProtosWebEvents_FlipEvent_EventOneof_FlipAddressChanged",
      "OdProtosWebEvents_FlipEvent_EventOneof_FlipCreated",
      "OdProtosWebEvents_FlipEvent_EventOneof_FlipResaleAgentLeadChanged",
      "OdProtosWebEvents_FlipEvent_EventOneof_FlipStateChanged",
      "OdProtosWebEvents_FlipEvent_EventOneof_LateCheckoutDateChanged"
    ],
    "OdProtosWebEvents_HeartbeatEvent_EventOneof": [
      "OdProtosWebEvents_HeartbeatEvent_EventOneof_KafkaAndGrpcHeartbeat"
    ],
    "OdProtosWebEvents_HelloSignContractEvent_EventOneof": [
      "OdProtosWebEvents_HelloSignContractEvent_EventOneof_AllSigned",
      "OdProtosWebEvents_HelloSignContractEvent_EventOneof_Declined",
      "OdProtosWebEvents_HelloSignContractEvent_EventOneof_EmailBounce",
      "OdProtosWebEvents_HelloSignContractEvent_EventOneof_Sent",
      "OdProtosWebEvents_HelloSignContractEvent_EventOneof_Signed"
    ],
    "OdProtosWebEvents_HumanEvent_EventOneof": [
      "OdProtosWebEvents_HumanEvent_EventOneof_Create",
      "OdProtosWebEvents_HumanEvent_EventOneof_Delete",
      "OdProtosWebEvents_HumanEvent_EventOneof_Update"
    ],
    "OdProtosWebEvents_InspectionEvent_EventOneof": [
      "OdProtosWebEvents_InspectionEvent_EventOneof_Created",
      "OdProtosWebEvents_InspectionEvent_EventOneof_Modified"
    ],
    "OdProtosWebEvents_InspectionReportEvent_EventOneof": [
      "OdProtosWebEvents_InspectionReportEvent_EventOneof_Canceled",
      "OdProtosWebEvents_InspectionReportEvent_EventOneof_Completed",
      "OdProtosWebEvents_InspectionReportEvent_EventOneof_Created"
    ],
    "OdProtosWebEvents_InventoryEvent_EventOneof": [
      "OdProtosWebEvents_InventoryEvent_EventOneof_InventoryDetails"
    ],
    "OdProtosWebEvents_InvoiceEvent_EventOneof": [
      "OdProtosWebEvents_InvoiceEvent_EventOneof_Create",
      "OdProtosWebEvents_InvoiceEvent_EventOneof_Update"
    ],
    "OdProtosWebEvents_ListingEvent_EventOneof": [
      "OdProtosWebEvents_ListingEvent_EventOneof_Active",
      "OdProtosWebEvents_ListingEvent_EventOneof_AttorneyReview",
      "OdProtosWebEvents_ListingEvent_EventOneof_Canceled",
      "OdProtosWebEvents_ListingEvent_EventOneof_ContingencyReleased",
      "OdProtosWebEvents_ListingEvent_EventOneof_Draft",
      "OdProtosWebEvents_ListingEvent_EventOneof_EnrolledInWarehousing",
      "OdProtosWebEvents_ListingEvent_EventOneof_ExternalListingStatusChange",
      "OdProtosWebEvents_ListingEvent_EventOneof_InContract",
      "OdProtosWebEvents_ListingEvent_EventOneof_MlsListingStatusChange",
      "OdProtosWebEvents_ListingEvent_EventOneof_Sold"
    ],
    "OdProtosWebEvents_ListingFeedbacksEvent_EventOneof": [
      "OdProtosWebEvents_ListingFeedbacksEvent_EventOneof_ListingFeedbacksCreated"
    ],
    "OdProtosWebEvents_ListingOfferEvent_EventOneof": [
      "OdProtosWebEvents_ListingOfferEvent_EventOneof_BuyerWalked",
      "OdProtosWebEvents_ListingOfferEvent_EventOneof_Canceled",
      "OdProtosWebEvents_ListingOfferEvent_EventOneof_CoeChanged",
      "OdProtosWebEvents_ListingOfferEvent_EventOneof_Created",
      "OdProtosWebEvents_ListingOfferEvent_EventOneof_EarnestMoneyReceived",
      "OdProtosWebEvents_ListingOfferEvent_EventOneof_InContract",
      "OdProtosWebEvents_ListingOfferEvent_EventOneof_PriceChange",
      "OdProtosWebEvents_ListingOfferEvent_EventOneof_Rejected",
      "OdProtosWebEvents_ListingOfferEvent_EventOneof_StateChange",
      "OdProtosWebEvents_ListingOfferEvent_EventOneof_Updated"
    ],
    "OdProtosWebEvents_OrganizationEvent_EventOneof": [
      "OdProtosWebEvents_OrganizationEvent_EventOneof_Create",
      "OdProtosWebEvents_OrganizationEvent_EventOneof_Delete",
      "OdProtosWebEvents_OrganizationEvent_EventOneof_Update"
    ],
    "OdProtosWebEvents_ParticipantEvent_EventOneof": [
      "OdProtosWebEvents_ParticipantEvent_EventOneof_ParticipantCreated",
      "OdProtosWebEvents_ParticipantEvent_EventOneof_ParticipantUpdated"
    ],
    "OdProtosWebEvents_ProposalEvent_EventOneof": [
      "OdProtosWebEvents_ProposalEvent_EventOneof_Updated"
    ],
    "OdProtosWebEvents_RepairBudgetReviewEvent_EventOneof": [
      "OdProtosWebEvents_RepairBudgetReviewEvent_EventOneof_Completed",
      "OdProtosWebEvents_RepairBudgetReviewEvent_EventOneof_Created",
      "OdProtosWebEvents_RepairBudgetReviewEvent_EventOneof_Finalized",
      "OdProtosWebEvents_RepairBudgetReviewEvent_EventOneof_ManuallyResolvedEscalation",
      "OdProtosWebEvents_RepairBudgetReviewEvent_EventOneof_Redrafted"
    ],
    "OdProtosWebEvents_ViewingAppointmentEvent_EventOneof": [
      "OdProtosWebEvents_ViewingAppointmentEvent_EventOneof_Canceled",
      "OdProtosWebEvents_ViewingAppointmentEvent_EventOneof_Created",
      "OdProtosWebEvents_ViewingAppointmentEvent_EventOneof_Updated"
    ],
    "OdProtosWebEvents_VirtualAssessmentEvent_EventOneof": [
      "OdProtosWebEvents_VirtualAssessmentEvent_EventOneof_Completed",
      "OdProtosWebEvents_VirtualAssessmentEvent_EventOneof_Scheduled"
    ],
    "OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_ListingOneof": [
      "OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_ListingOneof_AddressToken",
      "OdProtosWebServicesBuyDirect_Requests_CreateBuyDirectOffer_ListingOneof_ListingId"
    ],
    "OdProtosWebServicesBuyDirect_Requests_NotifyAepOfContingentBuyer_ListingOneof": [
      "OdProtosWebServicesBuyDirect_Requests_NotifyAepOfContingentBuyer_ListingOneof_AddressToken",
      "OdProtosWebServicesBuyDirect_Requests_NotifyAepOfContingentBuyer_ListingOneof_ListingId"
    ],
    "OdProtosWebServicesDocument_DocumentRequests_List_ParamsOneof": [
      "OdProtosWebServicesDocument_DocumentRequests_List_ParamsOneof_CurrentLead",
      "OdProtosWebServicesDocument_DocumentRequests_List_ParamsOneof_Documentable",
      "OdProtosWebServicesDocument_DocumentRequests_List_ParamsOneof_Ids",
      "OdProtosWebServicesDocument_DocumentRequests_List_ParamsOneof_ListingOffer"
    ],
    "OdProtosWebServicesDocument_DocumentRequests_Upload_ParamsOneof": [
      "OdProtosWebServicesDocument_DocumentRequests_Upload_ParamsOneof_Document"
    ],
    "OdProtosWebServicesHpmGeoAssignment_GetGeoAssignmentsRequest_PrimaryFilterOneof": [
      "OdProtosWebServicesHpmGeoAssignment_GetGeoAssignmentsRequest_PrimaryFilterOneof_HumanId",
      "OdProtosWebServicesHpmGeoAssignment_GetGeoAssignmentsRequest_PrimaryFilterOneof_MarketId",
      "OdProtosWebServicesHpmGeoAssignment_GetGeoAssignmentsRequest_PrimaryFilterOneof_PostalCode"
    ],
    "OdProtosWebServicesInvoice_ListInvoicesRequest_ByOneof": [
      "OdProtosWebServicesInvoice_ListInvoicesRequest_ByOneof_WorkOrderId"
    ],
    "OdProtosWebServicesListingFeedbacks_GetListingFeedbacksRequest_IdentifierOneof": [
      "OdProtosWebServicesListingFeedbacks_GetListingFeedbacksRequest_IdentifierOneof_CustomerId",
      "OdProtosWebServicesListingFeedbacks_GetListingFeedbacksRequest_IdentifierOneof_ListingId"
    ],
    "OdProtosWebServicesListingOffer_Requests_GetListingOffer_IdentifierOneof": [
      "OdProtosWebServicesListingOffer_Requests_GetListingOffer_IdentifierOneof_ListingOfferId",
      "OdProtosWebServicesListingOffer_Requests_GetListingOffer_IdentifierOneof_ListingOfferUuid"
    ],
    "OdProtosWebServicesListingOffer_Requests_ListOffers_IdentifierOneof": [
      "OdProtosWebServicesListingOffer_Requests_ListOffers_IdentifierOneof_AddressToken",
      "OdProtosWebServicesListingOffer_Requests_ListOffers_IdentifierOneof_CustomerId"
    ],
    "OdProtosWebServicesListingOffer_Requests_SetCustomers_AgentTcOneof": [
      "OdProtosWebServicesListingOffer_Requests_SetCustomers_AgentTcOneof_AgentTcCustomerId",
      "OdProtosWebServicesListingOffer_Requests_SetCustomers_AgentTcOneof_NullifyAgentTcCustomer"
    ],
    "OdProtosWebServicesListingOffer_Requests_SetCustomers_Buyer2Oneof": [
      "OdProtosWebServicesListingOffer_Requests_SetCustomers_Buyer2Oneof_Buyer2CustomerId",
      "OdProtosWebServicesListingOffer_Requests_SetCustomers_Buyer2Oneof_Buyer2Info",
      "OdProtosWebServicesListingOffer_Requests_SetCustomers_Buyer2Oneof_NullifyBuyer2Customer"
    ],
    "OdProtosWebServicesListingOffer_Requests_SetCustomers_BuyerOneof": [
      "OdProtosWebServicesListingOffer_Requests_SetCustomers_BuyerOneof_BuyerCustomerId",
      "OdProtosWebServicesListingOffer_Requests_SetCustomers_BuyerOneof_BuyerInfo",
      "OdProtosWebServicesListingOffer_Requests_SetCustomers_BuyerOneof_NullifyBuyerCustomer"
    ],
    "OdProtosWebServicesListingOffer_Requests_SetCustomers_ContactOneof": [
      "OdProtosWebServicesListingOffer_Requests_SetCustomers_ContactOneof_ContactCustomerId",
      "OdProtosWebServicesListingOffer_Requests_SetCustomers_ContactOneof_NullifyContactCustomer"
    ],
    "OdProtosWebServicesListing_GetExternalListingRequest_IdentifierOneof": [
      "OdProtosWebServicesListing_GetExternalListingRequest_IdentifierOneof_ListingId",
      "OdProtosWebServicesListing_GetExternalListingRequest_IdentifierOneof_ListingUuid",
      "OdProtosWebServicesListing_GetExternalListingRequest_IdentifierOneof_PropertyEngagementGroupId"
    ],
    "OdProtosWebServicesListing_GetListingRequest_IdentifierOneof": [
      "OdProtosWebServicesListing_GetListingRequest_IdentifierOneof_AddressToken",
      "OdProtosWebServicesListing_GetListingRequest_IdentifierOneof_FlipToken",
      "OdProtosWebServicesListing_GetListingRequest_IdentifierOneof_ListingId",
      "OdProtosWebServicesListing_GetListingRequest_IdentifierOneof_ListingUuid"
    ],
    "OdProtosWebServicesListing_ListExternalListingWeeklyFeedbackRequest_IdentifierOneof": [
      "OdProtosWebServicesListing_ListExternalListingWeeklyFeedbackRequest_IdentifierOneof_FlipToken",
      "OdProtosWebServicesListing_ListExternalListingWeeklyFeedbackRequest_IdentifierOneof_ListingId"
    ],
    "OdProtosWebServicesListing_ListVisitingCustomersForListingRequest_IdentifierOneof": [
      "OdProtosWebServicesListing_ListVisitingCustomersForListingRequest_IdentifierOneof_AddressId",
      "OdProtosWebServicesListing_ListVisitingCustomersForListingRequest_IdentifierOneof_ListingId"
    ],
    "OdProtosWebServicesMaintenance_GetMessageThreadRequest_RequestTypeOneof": [
      "OdProtosWebServicesMaintenance_GetMessageThreadRequest_RequestTypeOneof_RequestIdentifier"
    ],
    "OdProtosWebServicesMaintenance_ListMaintenanceRequestsRequest_RequestTypeOneof": [
      "OdProtosWebServicesMaintenance_ListMaintenanceRequestsRequest_RequestTypeOneof_AddressRequest",
      "OdProtosWebServicesMaintenance_ListMaintenanceRequestsRequest_RequestTypeOneof_VendorRequest"
    ],
    "OdProtosWebServicesPasswordless_GetActiveTokenRequest_ParamsOneof": [
      "OdProtosWebServicesPasswordless_GetActiveTokenRequest_ParamsOneof_Email"
    ],
    "OdProtosWebServicesSellDirect_ClearLastSSVARecordingByRecordedFeatureRequest_LeadOneof": [
      "OdProtosWebServicesSellDirect_ClearLastSSVARecordingByRecordedFeatureRequest_LeadOneof_Params",
      "OdProtosWebServicesSellDirect_ClearLastSSVARecordingByRecordedFeatureRequest_LeadOneof_Source"
    ],
    "OdProtosWebServicesSellDirect_DeleteParticipantRequest_LeadOneof": [
      "OdProtosWebServicesSellDirect_DeleteParticipantRequest_LeadOneof_Source"
    ],
    "OdProtosWebServicesSellDirect_DeleteSSVAFileRequest_LeadOneof": [
      "OdProtosWebServicesSellDirect_DeleteSSVAFileRequest_LeadOneof_Params",
      "OdProtosWebServicesSellDirect_DeleteSSVAFileRequest_LeadOneof_Source"
    ],
    "OdProtosWebServicesSellDirect_GetAllExteriorAssessmentSlotsResponse_ResponseOneof": [
      "OdProtosWebServicesSellDirect_GetAllExteriorAssessmentSlotsResponse_ResponseOneof_ExteriorAssessmentGenericErrors",
      "OdProtosWebServicesSellDirect_GetAllExteriorAssessmentSlotsResponse_ResponseOneof_ExteriorAssessmentSlots"
    ],
    "OdProtosWebServicesSellDirect_GetLeadRequest_LeadOneof": [
      "OdProtosWebServicesSellDirect_GetLeadRequest_LeadOneof_Params",
      "OdProtosWebServicesSellDirect_GetLeadRequest_LeadOneof_SellerLeadUuid",
      "OdProtosWebServicesSellDirect_GetLeadRequest_LeadOneof_Source",
      "OdProtosWebServicesSellDirect_GetLeadRequest_LeadOneof_Token"
    ],
    "OdProtosWebServicesSellDirect_GetOfferReviewsRequest_IdentifierOneof": [
      "OdProtosWebServicesSellDirect_GetOfferReviewsRequest_IdentifierOneof_OfferUuid"
    ],
    "OdProtosWebServicesSellDirect_GetParticipantsRequest_LeadOneof": [
      "OdProtosWebServicesSellDirect_GetParticipantsRequest_LeadOneof_SellerLeadUuid",
      "OdProtosWebServicesSellDirect_GetParticipantsRequest_LeadOneof_Source"
    ],
    "OdProtosWebServicesSellDirect_ListExteriorAssessmentAvailabilitySlotsResponse_ResponseOneof": [
      "OdProtosWebServicesSellDirect_ListExteriorAssessmentAvailabilitySlotsResponse_ResponseOneof_ExteriorAssessmentAvailableSlots",
      "OdProtosWebServicesSellDirect_ListExteriorAssessmentAvailabilitySlotsResponse_ResponseOneof_ExteriorAssessmentGenericErrors"
    ],
    "OdProtosWebServicesSellDirect_ListOffersRequest_OffersOneof": [
      "OdProtosWebServicesSellDirect_ListOffersRequest_OffersOneof_Ids",
      "OdProtosWebServicesSellDirect_ListOffersRequest_OffersOneof_Params"
    ],
    "OdProtosWebServicesSellDirect_PerformLeadHandoffRequest_CustomerOneof": [
      "OdProtosWebServicesSellDirect_PerformLeadHandoffRequest_CustomerOneof_CustomerId",
      "OdProtosWebServicesSellDirect_PerformLeadHandoffRequest_CustomerOneof_NewCustomer"
    ],
    "OdProtosWebServicesSellDirect_ResendParticipantInviteRequest_LeadOneof": [
      "OdProtosWebServicesSellDirect_ResendParticipantInviteRequest_LeadOneof_Source"
    ],
    "OdProtosWebServicesSellDirect_RollbackToAcceptedRequest_WalkReasonOneof": [
      "OdProtosWebServicesSellDirect_RollbackToAcceptedRequest_WalkReasonOneof_OpendoorWalkReason",
      "OdProtosWebServicesSellDirect_RollbackToAcceptedRequest_WalkReasonOneof_SellerWalkReason"
    ],
    "OdProtosWebServicesSellDirect_ScheduleExteriorAssessmentResponse_ResponseOneof": [
      "OdProtosWebServicesSellDirect_ScheduleExteriorAssessmentResponse_ResponseOneof_ExteriorAssessmentGenericErrors",
      "OdProtosWebServicesSellDirect_ScheduleExteriorAssessmentResponse_ResponseOneof_ExteriorAssessmentSlots"
    ],
    "OdProtosWebServicesSellDirect_SetSSVAReminderSMSRequest_LeadOneof": [
      "OdProtosWebServicesSellDirect_SetSSVAReminderSMSRequest_LeadOneof_Params",
      "OdProtosWebServicesSellDirect_SetSSVAReminderSMSRequest_LeadOneof_Source"
    ],
    "OdProtosWebServicesSellDirect_SubmitSSVARecordedFeatureRequest_LeadOneof": [
      "OdProtosWebServicesSellDirect_SubmitSSVARecordedFeatureRequest_LeadOneof_Params",
      "OdProtosWebServicesSellDirect_SubmitSSVARecordedFeatureRequest_LeadOneof_Source"
    ],
    "OdProtosWebServicesSellDirect_UpdateSSVARecordingsRequest_LeadOneof": [
      "OdProtosWebServicesSellDirect_UpdateSSVARecordingsRequest_LeadOneof_Params",
      "OdProtosWebServicesSellDirect_UpdateSSVARecordingsRequest_LeadOneof_Source"
    ],
    "OdProtosWebServicesSellDirect_UpsertParticipantRequest_LeadOneof": [
      "OdProtosWebServicesSellDirect_UpsertParticipantRequest_LeadOneof_Source"
    ],
    "OdProtosWebServicesSellDirect_VerifyHubAccessRequest_IdentifierOneof": [
      "OdProtosWebServicesSellDirect_VerifyHubAccessRequest_IdentifierOneof_FlipToken",
      "OdProtosWebServicesSellDirect_VerifyHubAccessRequest_IdentifierOneof_SellerLeadUuid"
    ],
    "OdProtosWebServicesSellDirect_ViewedSSVAPageRequest_LeadOneof": [
      "OdProtosWebServicesSellDirect_ViewedSSVAPageRequest_LeadOneof_Params",
      "OdProtosWebServicesSellDirect_ViewedSSVAPageRequest_LeadOneof_Source"
    ],
    "OdProtosWebServicesSellDirect_WithdrawOfferRequest_WalkReasonOneof": [
      "OdProtosWebServicesSellDirect_WithdrawOfferRequest_WalkReasonOneof_OpendoorWalkReason",
      "OdProtosWebServicesSellDirect_WithdrawOfferRequest_WalkReasonOneof_SellerWalkReason"
    ],
    "OdProtosWebServicesStructuredTouchpoint_Requests_Search_QueryOneof": [
      "OdProtosWebServicesStructuredTouchpoint_Requests_Search_QueryOneof_OfferUuid",
      "OdProtosWebServicesStructuredTouchpoint_Requests_Search_QueryOneof_Touchpointable"
    ],
    "OdProtosWebServicesUnderwritingQcResult_GetCompleteQcCaseyTaskArgumentsResponse_ResponseOneof": [
      "OdProtosWebServicesUnderwritingQcResult_GetCompleteQcCaseyTaskArgumentsResponse_ResponseOneof_Error",
      "OdProtosWebServicesUnderwritingQcResult_GetCompleteQcCaseyTaskArgumentsResponse_ResponseOneof_Success"
    ],
    "OdProtosWebServicesUnderwriting_CalculateFeesRequest_ValuationOneof": [
      "OdProtosWebServicesUnderwriting_CalculateFeesRequest_ValuationOneof_EnsembledValuationId",
      "OdProtosWebServicesUnderwriting_CalculateFeesRequest_ValuationOneof_OverrideValuation",
      "OdProtosWebServicesUnderwriting_CalculateFeesRequest_ValuationOneof_ValuationId"
    ],
    "OdProtosWebServicesUnderwriting_CalculateFeesResponse_ResponseOneof": [
      "OdProtosWebServicesUnderwriting_CalculateFeesResponse_ResponseOneof_Error",
      "OdProtosWebServicesUnderwriting_CalculateFeesResponse_ResponseOneof_Success"
    ],
    "OdProtosWebServicesUnderwriting_CheckIfUnderwritingCanBeStartedResponse_ResponseOneof": [
      "OdProtosWebServicesUnderwriting_CheckIfUnderwritingCanBeStartedResponse_ResponseOneof_Error",
      "OdProtosWebServicesUnderwriting_CheckIfUnderwritingCanBeStartedResponse_ResponseOneof_Success"
    ],
    "OdProtosWebServicesUnderwriting_CheckIfUnderwritingCanBeStartedResponse_Success_ResultOneof": [
      "OdProtosWebServicesUnderwriting_CheckIfUnderwritingCanBeStartedResponse_Success_ResultOneof_Eligible",
      "OdProtosWebServicesUnderwriting_CheckIfUnderwritingCanBeStartedResponse_Success_ResultOneof_Ineligible"
    ],
    "OdProtosWebServicesUnderwriting_CreateDirectOverrideValuationResponse_ResponseOneof": [
      "OdProtosWebServicesUnderwriting_CreateDirectOverrideValuationResponse_ResponseOneof_Error",
      "OdProtosWebServicesUnderwriting_CreateDirectOverrideValuationResponse_ResponseOneof_Success"
    ],
    "OdProtosWebServicesUnderwriting_CreateEnsembledValuationResponse_ResponseOneof": [
      "OdProtosWebServicesUnderwriting_CreateEnsembledValuationResponse_ResponseOneof_Error",
      "OdProtosWebServicesUnderwriting_CreateEnsembledValuationResponse_ResponseOneof_Success"
    ],
    "OdProtosWebServicesUnderwriting_CreateOVMValuationResponse_ResponseOneof": [
      "OdProtosWebServicesUnderwriting_CreateOVMValuationResponse_ResponseOneof_Error",
      "OdProtosWebServicesUnderwriting_CreateOVMValuationResponse_ResponseOneof_Success"
    ],
    "OdProtosWebServicesUnderwriting_CreateUnderwritingTasksRequest_TaskParamsOneof": [
      "OdProtosWebServicesUnderwriting_CreateUnderwritingTasksRequest_TaskParamsOneof_PricingDecision",
      "OdProtosWebServicesUnderwriting_CreateUnderwritingTasksRequest_TaskParamsOneof_Valuation"
    ],
    "OdProtosWebServicesUnderwriting_CreateUnderwritingTasksResponse_ResponseOneof": [
      "OdProtosWebServicesUnderwriting_CreateUnderwritingTasksResponse_ResponseOneof_Error",
      "OdProtosWebServicesUnderwriting_CreateUnderwritingTasksResponse_ResponseOneof_Success"
    ],
    "OdProtosWebServicesUnderwriting_GetCalculatedFeesResponse_ResponseOneof": [
      "OdProtosWebServicesUnderwriting_GetCalculatedFeesResponse_ResponseOneof_Error",
      "OdProtosWebServicesUnderwriting_GetCalculatedFeesResponse_ResponseOneof_Success"
    ],
    "OdProtosWebServicesUnderwriting_GetEnsembledRepairLineItemsResponse_ResponseOneof": [
      "OdProtosWebServicesUnderwriting_GetEnsembledRepairLineItemsResponse_ResponseOneof_Error",
      "OdProtosWebServicesUnderwriting_GetEnsembledRepairLineItemsResponse_ResponseOneof_Success"
    ],
    "OdProtosWebServicesUnderwriting_GetEnsembledValuationWalkProposalsResponse_ResponseOneof": [
      "OdProtosWebServicesUnderwriting_GetEnsembledValuationWalkProposalsResponse_ResponseOneof_Error",
      "OdProtosWebServicesUnderwriting_GetEnsembledValuationWalkProposalsResponse_ResponseOneof_Success"
    ],
    "OdProtosWebServicesUnderwriting_GetEstimatedClosingCostsResponse_ResponseOneof": [
      "OdProtosWebServicesUnderwriting_GetEstimatedClosingCostsResponse_ResponseOneof_Error",
      "OdProtosWebServicesUnderwriting_GetEstimatedClosingCostsResponse_ResponseOneof_Success"
    ],
    "OdProtosWebServicesUnderwriting_GetPreliminaryOfferValuationResponse_ResponseOneof": [
      "OdProtosWebServicesUnderwriting_GetPreliminaryOfferValuationResponse_ResponseOneof_Error",
      "OdProtosWebServicesUnderwriting_GetPreliminaryOfferValuationResponse_ResponseOneof_Success"
    ],
    "OdProtosWebServicesUnderwriting_GetRepairBudgetReviewWalkProposalResponse_ResponseOneof": [
      "OdProtosWebServicesUnderwriting_GetRepairBudgetReviewWalkProposalResponse_ResponseOneof_Error",
      "OdProtosWebServicesUnderwriting_GetRepairBudgetReviewWalkProposalResponse_ResponseOneof_Success"
    ],
    "OdProtosWebServicesUnderwriting_GetReusableRiskAssessmentDetailsResponse_ResponseOneof": [
      "OdProtosWebServicesUnderwriting_GetReusableRiskAssessmentDetailsResponse_ResponseOneof_Error",
      "OdProtosWebServicesUnderwriting_GetReusableRiskAssessmentDetailsResponse_ResponseOneof_Success"
    ],
    "OdProtosWebServicesUnderwriting_GetReusableUnderwritingResponse_ResponseOneof": [
      "OdProtosWebServicesUnderwriting_GetReusableUnderwritingResponse_ResponseOneof_Error",
      "OdProtosWebServicesUnderwriting_GetReusableUnderwritingResponse_ResponseOneof_Success"
    ],
    "OdProtosWebServicesUnderwriting_GetReusableUnderwritingResponse_Success_ResultOneof": [
      "OdProtosWebServicesUnderwriting_GetReusableUnderwritingResponse_Success_ResultOneof_NotReusable",
      "OdProtosWebServicesUnderwriting_GetReusableUnderwritingResponse_Success_ResultOneof_ReusableUnderwriting"
    ],
    "OdProtosWebServicesUnderwriting_GetRiskTierRequest_TargetOneof": [
      "OdProtosWebServicesUnderwriting_GetRiskTierRequest_TargetOneof_AddressToken",
      "OdProtosWebServicesUnderwriting_GetRiskTierRequest_TargetOneof_PostalCode"
    ],
    "OdProtosWebServicesUnderwriting_PricingDecisionTaskParams_ValuationOneof": [
      "OdProtosWebServicesUnderwriting_PricingDecisionTaskParams_ValuationOneof_EnsembledValuationId",
      "OdProtosWebServicesUnderwriting_PricingDecisionTaskParams_ValuationOneof_SingleValuationId"
    ],
    "OdProtosWebServicesUnderwriting_ReusableUnderwriting_ValuationIdOneof": [
      "OdProtosWebServicesUnderwriting_ReusableUnderwriting_ValuationIdOneof_WebEnsembledValuationId",
      "OdProtosWebServicesUnderwriting_ReusableUnderwriting_ValuationIdOneof_WebValuationId"
    ],
    "OdProtosWebServicesUnderwriting_UpdateUnderwritingResponse_ResponseOneof": [
      "OdProtosWebServicesUnderwriting_UpdateUnderwritingResponse_ResponseOneof_Error",
      "OdProtosWebServicesUnderwriting_UpdateUnderwritingResponse_ResponseOneof_Success"
    ],
    "OdProtosWebServicesUnderwriting_UpdateUnderwritingWithWalkResponse_ResponseOneof": [
      "OdProtosWebServicesUnderwriting_UpdateUnderwritingWithWalkResponse_ResponseOneof_Error",
      "OdProtosWebServicesUnderwriting_UpdateUnderwritingWithWalkResponse_ResponseOneof_Success"
    ],
    "OdProtosWebServicesUnlock_UnlockRequests_Search_ParamsOneof": [
      "OdProtosWebServicesUnlock_UnlockRequests_Search_ParamsOneof_Address",
      "OdProtosWebServicesUnlock_UnlockRequests_Search_ParamsOneof_Contact"
    ],
    "OdProtosWebServicesValuation_GetValuationParamsRequest_ValuationKindOneof": [
      "OdProtosWebServicesValuation_GetValuationParamsRequest_ValuationKindOneof_EnsembledValuationId",
      "OdProtosWebServicesValuation_GetValuationParamsRequest_ValuationKindOneof_ValuationId"
    ],
    "OdProtosWebServicesValuation_ProxyGetMergedCompsForValuationRequest_ValuationKindOneof": [
      "OdProtosWebServicesValuation_ProxyGetMergedCompsForValuationRequest_ValuationKindOneof_EnsembledValuationId",
      "OdProtosWebServicesValuation_ProxyGetMergedCompsForValuationRequest_ValuationKindOneof_ValuationId"
    ],
    "OdProtosWingmanData_DataItem_DataIdentifierOneof": [
      "OdProtosWingmanData_DataItem_DataIdentifierOneof_AssetId",
      "OdProtosWingmanData_DataItem_DataIdentifierOneof_PromptId",
      "OdProtosWingmanData_DataItem_DataIdentifierOneof_VaQuestionTitle"
    ],
    "OdProtosWingmanEvents_WingmanTaskEvent_EventOneof": [
      "OdProtosWingmanEvents_WingmanTaskEvent_EventOneof_Create",
      "OdProtosWingmanEvents_WingmanTaskEvent_EventOneof_Delete",
      "OdProtosWingmanEvents_WingmanTaskEvent_EventOneof_Update"
    ],
    "OdProtosWingmanServices_GetLastResponseForTaskRequest_InputOneof": [
      "OdProtosWingmanServices_GetLastResponseForTaskRequest_InputOneof_RequestId",
      "OdProtosWingmanServices_GetLastResponseForTaskRequest_InputOneof_TaskId"
    ],
    "OdProtosWingmanServices_TaskRequest_InputOneof": [
      "OdProtosWingmanServices_TaskRequest_InputOneof_CallInsightsInput",
      "OdProtosWingmanServices_TaskRequest_InputOneof_CommunicationInsightInput",
      "OdProtosWingmanServices_TaskRequest_InputOneof_ContextualizeRepairAskInput",
      "OdProtosWingmanServices_TaskRequest_InputOneof_FinalOfferRepairNarrativeInput",
      "OdProtosWingmanServices_TaskRequest_InputOneof_ListingDescriptionInput",
      "OdProtosWingmanServices_TaskRequest_InputOneof_MaintenanceValidationTask",
      "OdProtosWingmanServices_TaskRequest_InputOneof_ScriptTaskInput",
      "OdProtosWingmanServices_TaskRequest_InputOneof_TranscribeInput",
      "OdProtosWingmanServices_TaskRequest_InputOneof_UrsJustificationTaskInput",
      "OdProtosWingmanServices_TaskRequest_InputOneof_WorkOrderMessageGenerationTask"
    ],
    "OdProtosWingmanServices_TaskResponse_OutputOneof": [
      "OdProtosWingmanServices_TaskResponse_OutputOneof_CallInsightsOutput",
      "OdProtosWingmanServices_TaskResponse_OutputOneof_CommunicationInsightOutput",
      "OdProtosWingmanServices_TaskResponse_OutputOneof_ContextualizeRepairAskOutput",
      "OdProtosWingmanServices_TaskResponse_OutputOneof_FinalOfferRepairNarrativeOutput",
      "OdProtosWingmanServices_TaskResponse_OutputOneof_ListingDescriptionOutput",
      "OdProtosWingmanServices_TaskResponse_OutputOneof_MaintenanceValidationOutput",
      "OdProtosWingmanServices_TaskResponse_OutputOneof_ScriptTaskOutput",
      "OdProtosWingmanServices_TaskResponse_OutputOneof_TranscribeOutput",
      "OdProtosWingmanServices_TaskResponse_OutputOneof_UrsJustificationTaskOutput",
      "OdProtosWingmanServices_TaskResponse_OutputOneof_WorkOrderMessageGenerationOutput"
    ],
    "OfferDetails": [
      "FinalOffer",
      "PreliminaryOffer",
      "TerminatedOffer",
      "UnknownOfferDetails",
      "UnreleasedFinalOffer"
    ],
    "PbdbEntryValue": [
      "OdProtosBuyConfig_MarketConfig",
      "OdProtosHomeOperationsConfig_MarketConfig",
      "OdProtosInstitutionsReithouseDataBrokerage_TransactionRuleSet",
      "OdProtosMarketConfig_Market",
      "OdProtosSellConfig_MarketConfig"
    ],
    "Pricing": [
      "ListingPricing",
      "SellWithUpsidePricing"
    ],
    "Product": [
      "ListingProduct",
      "SellDirectProduct",
      "SellWithUpsideProduct"
    ],
    "SellerTransaction": [
      "DeniedTransaction",
      "InContractTransaction",
      "InitializingTransaction",
      "QualifiedTransaction",
      "WithdrawnTransaction"
    ],
    "SurveyorDwellingInterface": [
      "SurveyorDwellingComp",
      "SurveyorDwellingSubject"
    ],
    "TaskActionPayload": [
      "ExternalLinkPayload",
      "ModalPayload",
      "RevealContentPayload"
    ],
    "Taskable": [
      "HelloSignTask",
      "HoaFeesTask",
      "HvacRoofTask",
      "LateCheckoutTask",
      "OtherHomeInfoTask",
      "ServiceAccountsTask",
      "SetCloseDateTask",
      "SetSignatoriesTask"
    ]
  }
}